var map = {
	"./App": [
		"3dfd",
		9
	],
	"./App.vue": [
		"3dfd",
		9
	],
	"./api/banner": [
		"709b",
		9
	],
	"./api/banner.js": [
		"709b",
		9
	],
	"./api/captcha": [
		"85a9",
		9,
		"chunk-2d0de8ab"
	],
	"./api/captcha.js": [
		"85a9",
		9,
		"chunk-2d0de8ab"
	],
	"./api/contact": [
		"e230",
		9,
		"chunk-2d224c80"
	],
	"./api/contact.js": [
		"e230",
		9,
		"chunk-2d224c80"
	],
	"./api/file": [
		"3f5e",
		9
	],
	"./api/file.js": [
		"3f5e",
		9
	],
	"./api/game": [
		"89cb",
		9
	],
	"./api/game.js": [
		"89cb",
		9
	],
	"./api/interceptors": [
		"0244",
		9
	],
	"./api/interceptors.js": [
		"0244",
		9
	],
	"./api/lang": [
		"9ea0",
		9
	],
	"./api/lang.js": [
		"9ea0",
		9
	],
	"./api/lottery": [
		"1184",
		9,
		"chunk-2d0aa612"
	],
	"./api/lottery.js": [
		"1184",
		9,
		"chunk-2d0aa612"
	],
	"./api/message": [
		"c443",
		9,
		"chunk-2d216b66"
	],
	"./api/message.js": [
		"c443",
		9,
		"chunk-2d216b66"
	],
	"./api/notification": [
		"277f",
		9,
		"chunk-2d0b310a"
	],
	"./api/notification.js": [
		"277f",
		9,
		"chunk-2d0b310a"
	],
	"./api/product": [
		"c4c8",
		9
	],
	"./api/product.js": [
		"c4c8",
		9
	],
	"./api/promotion": [
		"f74c",
		9
	],
	"./api/promotion.js": [
		"f74c",
		9
	],
	"./api/register": [
		"e0a5",
		9,
		"chunk-2d224a95"
	],
	"./api/register.js": [
		"e0a5",
		9,
		"chunk-2d224a95"
	],
	"./api/report": [
		"1c31",
		9,
		"chunk-2d0b6126"
	],
	"./api/report.js": [
		"1c31",
		9,
		"chunk-2d0b6126"
	],
	"./api/site": [
		"571f",
		9
	],
	"./api/site.js": [
		"571f",
		9
	],
	"./api/transaction-deposit": [
		"b897",
		9,
		"chunk-2d2106aa"
	],
	"./api/transaction-deposit.js": [
		"b897",
		9,
		"chunk-2d2106aa"
	],
	"./api/transaction-record": [
		"50e4",
		9,
		"chunk-2d0c7940"
	],
	"./api/transaction-record.js": [
		"50e4",
		9,
		"chunk-2d0c7940"
	],
	"./api/transaction-transfer": [
		"e38e",
		9
	],
	"./api/transaction-transfer.js": [
		"e38e",
		9
	],
	"./api/transaction-withdrawal": [
		"c8df",
		9,
		"chunk-2d21806d"
	],
	"./api/transaction-withdrawal.js": [
		"c8df",
		9,
		"chunk-2d21806d"
	],
	"./api/user": [
		"c24f",
		9
	],
	"./api/user.js": [
		"c24f",
		9
	],
	"./assets/PA/01/contact/facebook.png": [
		"7df0",
		7,
		"chunk-2d0e254d"
	],
	"./assets/PA/01/contact/line.png": [
		"def1",
		7,
		"chunk-2d229dc2"
	],
	"./assets/PA/01/contact/mail.png": [
		"a36a",
		7,
		"chunk-2d207f53"
	],
	"./assets/PA/01/contact/mobile.png": [
		"e04c",
		7,
		"chunk-2d224550"
	],
	"./assets/PA/01/contact/service.png": [
		"8f99",
		7,
		"chunk-2d0e9bc4"
	],
	"./assets/PA/01/contact/skype.png": [
		"3f54",
		7,
		"chunk-2d0c5568"
	],
	"./assets/PA/01/contact/telegram.png": [
		"2d27",
		7,
		"chunk-2d0bd92d"
	],
	"./assets/PA/01/contact/ui-contact.png": [
		"04fc",
		7,
		"chunk-2d0a42b7"
	],
	"./assets/PA/01/contact/wechat.png": [
		"40bc",
		7,
		"chunk-2d0c04b3"
	],
	"./assets/PA/01/footer/footer-bg-top.png": [
		"5986",
		7,
		"chunk-2d0c9598"
	],
	"./assets/PA/01/footer/footer-bg-transfer.png": [
		"99d2",
		7,
		"chunk-2d0e6c64"
	],
	"./assets/PA/01/footer/footer-bg.png": [
		"70b7",
		7,
		"chunk-2d0d61a4"
	],
	"./assets/PA/01/footer/footer-btn-deposit-en-us.png": [
		"268a",
		7,
		"chunk-2d0b2d63"
	],
	"./assets/PA/01/footer/footer-btn-deposit-th-th.png": [
		"da87",
		7,
		"chunk-2d228932"
	],
	"./assets/PA/01/footer/footer-btn-deposit-zh-cn.png": [
		"e2df",
		7,
		"chunk-2d2252a5"
	],
	"./assets/PA/01/footer/footer-btn-deposit-zh-tw.png": [
		"274b",
		7,
		"chunk-2d0b30a9"
	],
	"./assets/PA/01/footer/footer-btn-withdrawal-en-us.png": [
		"9b93",
		7,
		"chunk-2d0f0119"
	],
	"./assets/PA/01/footer/footer-btn-withdrawal-th-th.png": [
		"cc6a",
		7,
		"chunk-2d221c41"
	],
	"./assets/PA/01/footer/footer-btn-withdrawal-zh-cn.png": [
		"44f5",
		7,
		"chunk-2d0c1405"
	],
	"./assets/PA/01/footer/footer-btn-withdrawal-zh-tw.png": [
		"5908",
		7,
		"chunk-2d0c94a2"
	],
	"./assets/PA/01/footer/footer-icon-contact.png": [
		"47a9",
		7,
		"chunk-2d0c1eb1"
	],
	"./assets/PA/01/footer/footer-icon-fav.png": [
		"7ecf",
		7,
		"chunk-2d0e28e7"
	],
	"./assets/PA/01/footer/footer-icon-mail.png": [
		"cbd5",
		7,
		"chunk-2d221de6"
	],
	"./assets/PA/01/footer/footer-icon-promotion.png": [
		"fd88",
		7,
		"chunk-2d237d34"
	],
	"./assets/PA/01/footer/footer-icons.png": [
		"f510",
		7,
		"chunk-2d22cbe4"
	],
	"./assets/PA/01/footer/footerBg.png": [
		"bea9",
		7,
		"chunk-2d21b471"
	],
	"./assets/PA/01/footer/lnk_toolbar.png": [
		"9c73",
		7,
		"chunk-2d0f049c"
	],
	"./assets/PA/01/footer/toolbarBg.jpg": [
		"76c2",
		7,
		"chunk-2d0d7844"
	],
	"./assets/PA/01/footer/toolbarBgActive.jpg": [
		"14d5",
		7,
		"chunk-2d0ab6aa"
	],
	"./assets/PA/01/footer/ui-footer-toolbar-contact.png": [
		"2799",
		7,
		"chunk-2d0b311b"
	],
	"./assets/PA/01/footer/ui-footer-toolbar-event.png": [
		"5802",
		7,
		"chunk-2d0c90db"
	],
	"./assets/PA/01/footer/ui-footer-toolbar-home.png": [
		"ee7c",
		7,
		"chunk-2d230ca2"
	],
	"./assets/PA/01/footer/ui-footer-toolbar-registOrlogin.png": [
		"ef84",
		7,
		"chunk-2d231053"
	],
	"./assets/PA/01/footer/ui-footer-toolbar-trading.png": [
		"5fd5",
		7,
		"chunk-2d0d43d8"
	],
	"./assets/PA/01/forget-password/forgetDescBg.png": [
		"d1d4",
		7,
		"chunk-2d21da53"
	],
	"./assets/PA/01/game-lobby/1180-active.png": [
		"d464",
		7,
		"chunk-2d21e004"
	],
	"./assets/PA/01/game-lobby/1180.png": [
		"3efc",
		7,
		"chunk-2d0c57c5"
	],
	"./assets/PA/01/game-lobby/1230-active.png": [
		"fd22",
		7,
		"chunk-2d237c74"
	],
	"./assets/PA/01/game-lobby/1230.png": [
		"fae3",
		7,
		"chunk-2d23775f"
	],
	"./assets/PA/01/game-lobby/1240-active.png": [
		"bd2a",
		7,
		"chunk-2d21ab27"
	],
	"./assets/PA/01/game-lobby/1240.png": [
		"6ece",
		7,
		"chunk-2d0db487"
	],
	"./assets/PA/01/game-lobby/1250-active.png": [
		"e6a3",
		7,
		"chunk-2d226119"
	],
	"./assets/PA/01/game-lobby/1250.png": [
		"14e5",
		7,
		"chunk-2d0ab6c9"
	],
	"./assets/PA/01/game-lobby/1260-active.png": [
		"d8d9",
		7,
		"chunk-2d21f49f"
	],
	"./assets/PA/01/game-lobby/1260.png": [
		"e58e",
		7,
		"chunk-2d225893"
	],
	"./assets/PA/01/game-lobby/1270-active.png": [
		"631c",
		7,
		"chunk-2d0cf2c5"
	],
	"./assets/PA/01/game-lobby/1270.png": [
		"5619",
		7,
		"chunk-2d0c897f"
	],
	"./assets/PA/01/game-lobby/1280-active.png": [
		"5820",
		7,
		"chunk-2d0c9117"
	],
	"./assets/PA/01/game-lobby/1280.png": [
		"7f2d",
		7,
		"chunk-2d0e26b7"
	],
	"./assets/PA/01/game-lobby/1300-active.png": [
		"ff24",
		7,
		"chunk-2d2383f8"
	],
	"./assets/PA/01/game-lobby/1300.png": [
		"c17d",
		7,
		"chunk-2d2160b1"
	],
	"./assets/PA/01/game-lobby/1310-active.png": [
		"50e3",
		7,
		"chunk-2d0c793f"
	],
	"./assets/PA/01/game-lobby/1310.png": [
		"5edd",
		7,
		"chunk-2d0d4046"
	],
	"./assets/PA/01/game-lobby/1340-active.png": [
		"ced4",
		7,
		"chunk-2d222928"
	],
	"./assets/PA/01/game-lobby/1340.png": [
		"4a85",
		7,
		"chunk-2d0cb760"
	],
	"./assets/PA/01/game-lobby/1350-active.png": [
		"3bdc",
		7,
		"chunk-2d0c4c44"
	],
	"./assets/PA/01/game-lobby/1350.png": [
		"257f",
		7,
		"chunk-2d0b2988"
	],
	"./assets/PA/01/game-lobby/1360-active.png": [
		"cb50",
		7,
		"chunk-2d221830"
	],
	"./assets/PA/01/game-lobby/1360.png": [
		"3042",
		7,
		"chunk-2d0b8a91"
	],
	"./assets/PA/01/game-lobby/1370-active.png": [
		"01fd",
		7,
		"chunk-2d0a3775"
	],
	"./assets/PA/01/game-lobby/1370.png": [
		"70f9",
		7,
		"chunk-2d0d6222"
	],
	"./assets/PA/01/game-lobby/1380-active.png": [
		"3966",
		7,
		"chunk-2d0bac9c"
	],
	"./assets/PA/01/game-lobby/1380.png": [
		"2e3e",
		7,
		"chunk-2d0bdd3b"
	],
	"./assets/PA/01/game-lobby/1390-active.png": [
		"a048",
		7,
		"chunk-2d2073a9"
	],
	"./assets/PA/01/game-lobby/1390.png": [
		"3f66",
		7,
		"chunk-2d0c5589"
	],
	"./assets/PA/01/game-lobby/1400-active.png": [
		"412f",
		7,
		"chunk-2d0c02a7"
	],
	"./assets/PA/01/game-lobby/1400.png": [
		"5835",
		7,
		"chunk-2d0c913b"
	],
	"./assets/PA/01/game-lobby/1410-active.png": [
		"c835",
		7,
		"chunk-2d217a4d"
	],
	"./assets/PA/01/game-lobby/1410.png": [
		"858a",
		7,
		"chunk-2d0de3dc"
	],
	"./assets/PA/01/game-lobby/bg_jackpot.png": [
		"7288",
		7,
		"chunk-2d0d6411"
	],
	"./assets/PA/01/game-lobby/bg_lnk_inquire.png": [
		"07e8",
		7,
		"chunk-2d0a4db0"
	],
	"./assets/PA/01/game-lobby/btnTrans.png": [
		"02d8",
		7,
		"chunk-2d0a3acc"
	],
	"./assets/PA/01/game-lobby/btn_favorites.png": [
		"9293",
		7,
		"chunk-2d0e4ce9"
	],
	"./assets/PA/01/game-lobby/btn_favorites_active.png": [
		"4e70",
		7,
		"chunk-2d0cc640"
	],
	"./assets/PA/01/game-lobby/btn_freeplay.png": [
		"e0d3",
		7,
		"chunk-2d224af0"
	],
	"./assets/PA/01/game-lobby/btn_start.png": [
		"e04e",
		7,
		"chunk-2d224552"
	],
	"./assets/PA/01/game-lobby/ipt_favorites.png": [
		"5878",
		7,
		"chunk-2d0c91ba"
	],
	"./assets/PA/01/game-lobby/popular.png": [
		"52af",
		7,
		"chunk-2d0c8078"
	],
	"./assets/PA/01/header/btn_home.png": [
		"6b55",
		7,
		"chunk-2d0da382"
	],
	"./assets/PA/01/header/header-back.png": [
		"61a7",
		7,
		"chunk-2d0cf0e7"
	],
	"./assets/PA/01/header/header-bg.png": [
		"2819",
		7,
		"chunk-2d0b33e4"
	],
	"./assets/PA/01/header/header-lang-bg.png": [
		"0407",
		7,
		"chunk-2d0a3c01"
	],
	"./assets/PA/01/header/header-lang-icon.png": [
		"0448",
		7,
		"chunk-2d0a3c7e"
	],
	"./assets/PA/01/header/header-lang-modal-tick.png": [
		"a424",
		7,
		"chunk-2d20826b"
	],
	"./assets/PA/01/header/header-login-bg-en-us.png": [
		"3d16",
		7,
		"chunk-2d0c4d6c"
	],
	"./assets/PA/01/header/header-login-bg-my-mm.png": [
		"b646",
		7,
		"chunk-2d20fe8c"
	],
	"./assets/PA/01/header/header-login-bg-th-th.png": [
		"5704",
		7,
		"chunk-2d0c8d1c"
	],
	"./assets/PA/01/header/header-login-bg-zh-cn.png": [
		"1caa",
		7,
		"chunk-2d0b66e8"
	],
	"./assets/PA/01/header/header-login-bg-zh-tw.png": [
		"aa9b",
		7,
		"chunk-2d212c5f"
	],
	"./assets/PA/01/header/header-login-bg.png": [
		"73a0",
		7,
		"chunk-2d0d6cc1"
	],
	"./assets/PA/01/header/header-lottery-red-envelope-bg-en-us.png": [
		"902a",
		7,
		"chunk-2d0e44bc"
	],
	"./assets/PA/01/header/header-lottery-red-envelope-bg-my-mm.png": [
		"9787",
		7,
		"chunk-2d0e5f93"
	],
	"./assets/PA/01/header/header-lottery-red-envelope-bg-th-th.png": [
		"c2ad",
		7,
		"chunk-2d216988"
	],
	"./assets/PA/01/header/header-lottery-red-envelope-bg-zh-cn.png": [
		"ac94",
		7,
		"chunk-2d2133b3"
	],
	"./assets/PA/01/header/header-lottery-red-envelope-bg-zh-tw.png": [
		"3360",
		7,
		"chunk-2d0b9610"
	],
	"./assets/PA/01/header/header-lottery-red-envelope-bg.png": [
		"297a",
		7,
		"chunk-2d0b3887"
	],
	"./assets/PA/01/header/header-lottery-win-wheel-bg-en-us.png": [
		"1a4a",
		7,
		"chunk-2d0b59f3"
	],
	"./assets/PA/01/header/header-lottery-win-wheel-bg-my-mm.png": [
		"d45e",
		7,
		"chunk-2d21e016"
	],
	"./assets/PA/01/header/header-lottery-win-wheel-bg-th-th.png": [
		"8689",
		7,
		"chunk-2d0de775"
	],
	"./assets/PA/01/header/header-lottery-win-wheel-bg-zh-cn.png": [
		"289c",
		7,
		"chunk-2d0b3506"
	],
	"./assets/PA/01/header/header-lottery-win-wheel-bg-zh-tw.png": [
		"dc00",
		7,
		"chunk-2d228fb5"
	],
	"./assets/PA/01/header/header-money-icon.png": [
		"16e9",
		7,
		"chunk-2d0abe4f"
	],
	"./assets/PA/01/header/header-user-account.png": [
		"2d71",
		7,
		"chunk-2d0bd9c2"
	],
	"./assets/PA/01/header/header-user-vip.png": [
		"c1c6",
		7,
		"chunk-2d2165d7"
	],
	"./assets/PA/01/header/header-wallet-bg.png": [
		"9aa8",
		7,
		"chunk-2d0f0235"
	],
	"./assets/PA/01/header/headerBg.png": [
		"808e",
		7,
		"chunk-2d0dd11b"
	],
	"./assets/PA/01/header/logo.png": [
		"efd9",
		7,
		"chunk-2d2315ac"
	],
	"./assets/PA/01/home/SBO.png": [
		"bec8",
		7,
		"chunk-2d21b4ae"
	],
	"./assets/PA/01/home/btn_maintain.png": [
		"9dd6",
		7,
		"chunk-2d0f0dd3"
	],
	"./assets/PA/01/home/evo-block.png": [
		"7851",
		7,
		"chunk-2d0d7a33"
	],
	"./assets/PA/01/home/sbo-small.png": [
		"3a17",
		7,
		"chunk-2d0c422a"
	],
	"./assets/PA/01/lottery/luckyDraw.png": [
		"fcc2",
		7,
		"chunk-2d237ea2"
	],
	"./assets/PA/01/lottery/rotaryTable.png": [
		"6ed4",
		7,
		"chunk-2d0db475"
	],
	"./assets/PA/01/maintenance/footer_logo1.png": [
		"0ef9",
		7,
		"chunk-2d0afa7e"
	],
	"./assets/PA/01/maintenance/footer_logo2.png": [
		"47ba",
		7,
		"chunk-2d0c1ef8"
	],
	"./assets/PA/01/maintenance/footer_logo3.png": [
		"f3ea",
		7,
		"chunk-2d22cadf"
	],
	"./assets/PA/01/maintenance/footer_logo4.png": [
		"afc5",
		7,
		"chunk-2d21440d"
	],
	"./assets/PA/01/maintenance/footer_logo5.png": [
		"64f4",
		7,
		"chunk-2d0cfcc2"
	],
	"./assets/PA/01/maintenance/footer_logo6.png": [
		"72b4",
		7,
		"chunk-2d0d6923"
	],
	"./assets/PA/01/promotion/event01.jpg": [
		"b241",
		7,
		"chunk-2d20ef83"
	],
	"./assets/PA/01/promotion/event02.jpg": [
		"ed0a",
		7,
		"chunk-2d230806"
	],
	"./assets/PA/01/promotion/event03.jpg": [
		"96b1",
		7,
		"chunk-2d0e60e2"
	],
	"./assets/PA/01/promotion/event04.jpg": [
		"b2bf",
		7,
		"chunk-2d20f54a"
	],
	"./assets/PA/01/promotion/event06.jpg": [
		"06b2",
		7,
		"chunk-2d0a498c"
	],
	"./assets/PA/01/promotion/event07.jpg": [
		"f8f4",
		7,
		"chunk-2d22dd96"
	],
	"./assets/PA/01/ui/bg-chunk.png": [
		"16f6",
		7,
		"chunk-2d0abe6b"
	],
	"./assets/PA/01/ui/bg-mask.png": [
		"e511",
		7,
		"chunk-2d225786"
	],
	"./assets/PA/01/ui/bg-maskLeft.png": [
		"b677",
		7,
		"chunk-2d20feea"
	],
	"./assets/PA/01/ui/bg-maskRight.png": [
		"b30d",
		7,
		"chunk-2d20f2fb"
	],
	"./assets/PA/01/ui/bg.png": [
		"97b5",
		7,
		"chunk-2d0e64a7"
	],
	"./assets/PA/01/ui/ddl_pager.jpg": [
		"be92",
		7,
		"chunk-2d21af92"
	],
	"./assets/PA/01/ui/goTOP.png": [
		"97b0",
		7,
		"chunk-2d0e64a2"
	],
	"./assets/PA/01/ui/icon-tdControl.png": [
		"2f33",
		7,
		"chunk-2d0be0ca"
	],
	"./assets/PA/01/ui/lnk-trans-on.png": [
		"bb94",
		7,
		"chunk-2d21a451"
	],
	"./assets/PA/01/ui/lnk-trans.png": [
		"3cbd",
		7,
		"chunk-2d0c4fc8"
	],
	"./assets/PA/01/ui/lnk-trans2-on.png": [
		"639b",
		7,
		"chunk-2d0cf3bc"
	],
	"./assets/PA/01/ui/lnk-trans2.png": [
		"e12c",
		7,
		"chunk-2d2248d3"
	],
	"./assets/PA/01/ui/lnk_next.png": [
		"ec0c",
		7,
		"chunk-2d230447"
	],
	"./assets/PA/01/ui/lnk_nextMore.png": [
		"8f16",
		7,
		"chunk-2d0e9ac9"
	],
	"./assets/PA/01/ui/lnk_previous.png": [
		"717a",
		7,
		"chunk-2d0d605a"
	],
	"./assets/PA/01/ui/lnk_previousMore.png": [
		"4ac0",
		7,
		"chunk-2d0cbc90"
	],
	"./assets/PA/01/ui/search-icon.png": [
		"3c6e",
		7,
		"chunk-2d0c4a75"
	],
	"./assets/PA/01/ui/search-input-bg.png": [
		"2a89",
		7,
		"chunk-2d0bcea6"
	],
	"./assets/PA/01/ui/swiper-button-next.png": [
		"af1c",
		7,
		"chunk-2d213e2d"
	],
	"./assets/PA/01/ui/swiper-button-prev.png": [
		"4ade",
		7,
		"chunk-2d0cbce4"
	],
	"./assets/PA/01/ui/ui-arrow-down-brown.png": [
		"a2c5",
		7,
		"chunk-2d2080d9"
	],
	"./assets/PA/01/ui/ui-arrow-down-white.png": [
		"b58d",
		7,
		"chunk-2d20fb75"
	],
	"./assets/PA/01/ui/ui-arrow-down.png": [
		"73a7",
		7,
		"chunk-2d0d6cc8"
	],
	"./assets/PA/01/ui/ui-arrow-maskLeft.png": [
		"d777",
		7,
		"chunk-2d21eb69"
	],
	"./assets/PA/01/ui/ui-arrow-maskRight.png": [
		"9139",
		7,
		"chunk-2d0e4874"
	],
	"./assets/PA/01/ui/ui-arrow-select.png": [
		"357a",
		7,
		"chunk-2d0b9de2"
	],
	"./assets/PA/01/ui/ui-arrow-up-white.png": [
		"66e6",
		7,
		"chunk-2d0d0427"
	],
	"./assets/PA/01/ui/ui-arrow.png": [
		"078e",
		7,
		"chunk-2d0a486a"
	],
	"./assets/PA/01/ui/ui-arrow2-select.png": [
		"8668",
		7,
		"chunk-2d0de736"
	],
	"./assets/PA/01/ui/ui-arrowL.png": [
		"6235",
		7,
		"chunk-2d0cef14"
	],
	"./assets/PA/01/ui/ui-bank-card.png": [
		"5f43",
		7,
		"chunk-2d0d3e06"
	],
	"./assets/PA/01/ui/ui-border-01.png": [
		"9f827",
		7,
		"chunk-74d2efda"
	],
	"./assets/PA/01/ui/ui-box-count-bg.png": [
		"704c",
		7,
		"chunk-2d0d5c3e"
	],
	"./assets/PA/01/ui/ui-btn-oval.png": [
		"86880",
		7,
		"chunk-74af073c"
	],
	"./assets/PA/01/ui/ui-btn-rectangle-half-right.png": [
		"3497",
		7,
		"chunk-2d0b9a35"
	],
	"./assets/PA/01/ui/ui-btn-rectangle-light.png": [
		"f971",
		7,
		"chunk-2d22dba3"
	],
	"./assets/PA/01/ui/ui-btn-rectangle-yellow.png": [
		"13a1",
		7,
		"chunk-2d0ab288"
	],
	"./assets/PA/01/ui/ui-btn-rectangle.png": [
		"e14f",
		7,
		"chunk-2d224914"
	],
	"./assets/PA/01/ui/ui-collapse.png": [
		"e3e2",
		7,
		"chunk-2d225651"
	],
	"./assets/PA/01/ui/ui-event.png": [
		"616d",
		7,
		"chunk-2d0cebdf"
	],
	"./assets/PA/01/ui/ui-horn.png": [
		"92ac",
		7,
		"chunk-2d0e51f1"
	],
	"./assets/PA/01/ui/ui-icon-bank.png": [
		"70ec",
		7,
		"chunk-2d0d622d"
	],
	"./assets/PA/01/ui/ui-icon-mail.png": [
		"3bf6",
		7,
		"chunk-2d0c4c55"
	],
	"./assets/PA/01/ui/ui-icon-plus.png": [
		"34d5",
		7,
		"chunk-2d0b9f68"
	],
	"./assets/PA/01/ui/ui-icon-user.png": [
		"021f",
		7,
		"chunk-2d0a34cd"
	],
	"./assets/PA/01/ui/ui-input-date.png": [
		"f711",
		7,
		"chunk-2d22d367"
	],
	"./assets/PA/01/ui/ui-lobbyLeftSmall.png": [
		"8453",
		7,
		"chunk-2d0ddf90"
	],
	"./assets/PA/01/ui/ui-lobbyRightSmall.png": [
		"032f",
		7,
		"chunk-2d0a38ad"
	],
	"./assets/PA/01/ui/ui-mask-top-left-white-to-dark.png": [
		"6bfb",
		7,
		"chunk-2d0da99e"
	],
	"./assets/PA/01/ui/ui-modal-bg-decoration.png": [
		"1e42",
		7,
		"chunk-2d0b68c8"
	],
	"./assets/PA/01/ui/ui-modal-bg.png": [
		"3e25",
		7,
		"chunk-2d0c514b"
	],
	"./assets/PA/01/ui/ui-nav-tab-bg.png": [
		"4af3",
		7,
		"chunk-2d0cbcf0"
	],
	"./assets/PA/01/ui/ui-nav-tab-item-bg-active.png": [
		"5dbc",
		7,
		"chunk-2d0d3c46"
	],
	"./assets/PA/01/ui/ui-panel-tab-arrow-bottom.png": [
		"0cd7",
		7,
		"chunk-2d0af2bc"
	],
	"./assets/PA/01/ui/ui-panel-tab-arrow-left - copy.png": [
		"7f1a",
		7,
		"chunk-2d0e2695"
	],
	"./assets/PA/01/ui/ui-panel-tab-arrow-left.png": [
		"1849",
		7,
		"chunk-2d0abfe2"
	],
	"./assets/PA/01/ui/ui-panel-tab-arrow-right - copy.png": [
		"49f4",
		7,
		"chunk-2d0c26c9"
	],
	"./assets/PA/01/ui/ui-panel-tab-arrow-right.png": [
		"a786",
		7,
		"chunk-2d208e6a"
	],
	"./assets/PA/01/ui/ui-panel-tab-bg-active.png": [
		"7228",
		7,
		"chunk-2d0d6357"
	],
	"./assets/PA/01/ui/ui-panel-tab-bg.png": [
		"e41a",
		7,
		"chunk-2d2253f5"
	],
	"./assets/PA/01/ui/ui-panel-tab-border.png": [
		"21e8",
		7,
		"chunk-2d0b1fe8"
	],
	"./assets/PA/01/ui/ui-status.png": [
		"ad93",
		7,
		"chunk-2d213773"
	],
	"./assets/PA/01/ui/ui-tab-arrow-left.png": [
		"7f96",
		7,
		"chunk-2d0e2762"
	],
	"./assets/PA/01/ui/ui-tab-arrow-right.png": [
		"e4f8",
		7,
		"chunk-2d225a37"
	],
	"./assets/PA/01/ui/ui-transfer.png": [
		"ba7b",
		7,
		"chunk-2d21a080"
	],
	"./assets/PA/01/ui/ui-triangle-down.png": [
		"54f6",
		7,
		"chunk-2d0c8865"
	],
	"./assets/PA/01/ui/ui-triangle-right.png": [
		"5ef4",
		7,
		"chunk-2d0d4054"
	],
	"./assets/PA/01/user/ui-btn-modify-en-us.png": [
		"7c17",
		7,
		"chunk-2d0e1b28"
	],
	"./assets/PA/01/user/ui-btn-modify-th-th.png": [
		"34e2",
		7,
		"chunk-2d0b9f84"
	],
	"./assets/PA/01/user/ui-btn-modify-zh-cn.png": [
		"cdcb",
		7,
		"chunk-2d222576"
	],
	"./assets/PA/01/user/ui-btn-modify-zh-tw.png": [
		"eed8",
		7,
		"chunk-2d2311ea"
	],
	"./assets/PA/01/user/ui-btn-setup-en-us.png": [
		"598f",
		7,
		"chunk-2d0c95c8"
	],
	"./assets/PA/01/user/ui-btn-setup-th-th.png": [
		"c818",
		7,
		"chunk-2d217a12"
	],
	"./assets/PA/01/user/ui-btn-setup-zh-cn.png": [
		"e0a7",
		7,
		"chunk-2d224a97"
	],
	"./assets/PA/01/user/ui-btn-setup-zh-tw.png": [
		"d58c",
		7,
		"chunk-2d21e432"
	],
	"./assets/PA/01/user/ui-change-password.png": [
		"73cb",
		7,
		"chunk-2d0d6d31"
	],
	"./assets/PA/01/user/修改 (4).png": [
		"8d49",
		7,
		"chunk-2d0e93a7"
	],
	"./assets/Z/01/contact/mail.png": [
		"6eff",
		7,
		"chunk-2d0db4e5"
	],
	"./assets/Z/01/contact/ui-contact.png": [
		"56b9",
		7,
		"chunk-2d0c8f6e"
	],
	"./assets/Z/01/contact/ui-facebook.png": [
		"8ab6",
		7,
		"chunk-2d0e8df3"
	],
	"./assets/Z/01/contact/ui-telegram.png": [
		"cc71",
		7,
		"chunk-2d221c30"
	],
	"./assets/Z/01/footer/footerBg.png": [
		"77f7",
		7,
		"chunk-2d0d7c67"
	],
	"./assets/Z/01/footer/lnk_toolbar.png": [
		"b0f5",
		7,
		"chunk-2d20ee13"
	],
	"./assets/Z/01/footer/toolbarBg.jpg": [
		"36a0",
		7,
		"chunk-2d0ba688"
	],
	"./assets/Z/01/footer/toolbarBgActive.jpg": [
		"e096",
		7,
		"chunk-2d2245be"
	],
	"./assets/Z/01/footer/ui-footer-toolbar-contact.png": [
		"c2e2",
		7,
		"chunk-2d2169d2"
	],
	"./assets/Z/01/footer/ui-footer-toolbar-event.png": [
		"5ed0",
		7,
		"chunk-2d0d4012"
	],
	"./assets/Z/01/footer/ui-footer-toolbar-home.png": [
		"628c",
		7,
		"chunk-2d0cefdd"
	],
	"./assets/Z/01/footer/ui-footer-toolbar-registOrlogin.png": [
		"318c",
		7,
		"chunk-2d0b8eff"
	],
	"./assets/Z/01/footer/ui-footer-toolbar-trading.png": [
		"0f8a",
		7,
		"chunk-2d0af8d5"
	],
	"./assets/Z/01/forget-password/forgetDescBg.png": [
		"c9f9",
		7,
		"chunk-2d21843f"
	],
	"./assets/Z/01/game-lobby/1180-active.png": [
		"8a37",
		7,
		"chunk-2d0e8843"
	],
	"./assets/Z/01/game-lobby/1180.png": [
		"d855",
		7,
		"chunk-2d21eeea"
	],
	"./assets/Z/01/game-lobby/1230-active.png": [
		"7a92",
		7,
		"chunk-2d0e1499"
	],
	"./assets/Z/01/game-lobby/1230.png": [
		"ee84",
		7,
		"chunk-2d230c92"
	],
	"./assets/Z/01/game-lobby/1240-active.png": [
		"51b3",
		7,
		"chunk-2d0c7ca3"
	],
	"./assets/Z/01/game-lobby/1240.png": [
		"be11",
		7,
		"chunk-2d21ae99"
	],
	"./assets/Z/01/game-lobby/1250-active.png": [
		"e2ea",
		7,
		"chunk-2d2252bf"
	],
	"./assets/Z/01/game-lobby/1250.png": [
		"b92f",
		7,
		"chunk-2d2109c1"
	],
	"./assets/Z/01/game-lobby/1260-active.png": [
		"a8f8",
		7,
		"chunk-2d2097bf"
	],
	"./assets/Z/01/game-lobby/1260.png": [
		"7f6e",
		7,
		"chunk-2d0e2734"
	],
	"./assets/Z/01/game-lobby/1270-active.png": [
		"853a",
		7,
		"chunk-2d0de341"
	],
	"./assets/Z/01/game-lobby/1270.png": [
		"d523",
		7,
		"chunk-2d21e348"
	],
	"./assets/Z/01/game-lobby/1280-active.png": [
		"4fda",
		7,
		"chunk-2d0ccfa5"
	],
	"./assets/Z/01/game-lobby/1280.png": [
		"82d2",
		7,
		"chunk-2d0dddbe"
	],
	"./assets/Z/01/game-lobby/1300-active.png": [
		"2b5c",
		7,
		"chunk-2d0bd234"
	],
	"./assets/Z/01/game-lobby/1300.png": [
		"c628",
		7,
		"chunk-2d2172af"
	],
	"./assets/Z/01/game-lobby/1310-active.png": [
		"bed6",
		7,
		"chunk-2d21b4cb"
	],
	"./assets/Z/01/game-lobby/1310.png": [
		"ef7b",
		7,
		"chunk-2d231062"
	],
	"./assets/Z/01/game-lobby/1340-active.png": [
		"d463",
		7,
		"chunk-2d21e003"
	],
	"./assets/Z/01/game-lobby/1340.png": [
		"d4c1",
		7,
		"chunk-2d21e574"
	],
	"./assets/Z/01/game-lobby/1350-active.png": [
		"a233",
		7,
		"chunk-2d207b07"
	],
	"./assets/Z/01/game-lobby/1350.png": [
		"5d96",
		7,
		"chunk-2d0d3722"
	],
	"./assets/Z/01/game-lobby/1360-active.png": [
		"4c6e",
		7,
		"chunk-2d0cbed4"
	],
	"./assets/Z/01/game-lobby/1360.png": [
		"4b7e",
		7,
		"chunk-2d0cbb32"
	],
	"./assets/Z/01/game-lobby/1370-active.png": [
		"1788",
		7,
		"chunk-2d0abc9c"
	],
	"./assets/Z/01/game-lobby/1370.png": [
		"fa7e",
		7,
		"chunk-2d2371ff"
	],
	"./assets/Z/01/game-lobby/1380-active.png": [
		"9e5f",
		7,
		"chunk-2d0f0c13"
	],
	"./assets/Z/01/game-lobby/1380.png": [
		"bec0",
		7,
		"chunk-2d21b4a6"
	],
	"./assets/Z/01/game-lobby/1390-active.png": [
		"4f2b",
		7,
		"chunk-2d0cc998"
	],
	"./assets/Z/01/game-lobby/1390.png": [
		"b734",
		7,
		"chunk-2d21022c"
	],
	"./assets/Z/01/game-lobby/1400-active.png": [
		"0c33",
		7,
		"chunk-2d0aecc9"
	],
	"./assets/Z/01/game-lobby/1400.png": [
		"68fe",
		7,
		"chunk-2d0d0bf7"
	],
	"./assets/Z/01/game-lobby/1410-active.png": [
		"a7b7",
		7,
		"chunk-2d209381"
	],
	"./assets/Z/01/game-lobby/1410.png": [
		"e077",
		7,
		"chunk-2d224581"
	],
	"./assets/Z/01/game-lobby/1420-active.png": [
		"961a",
		7,
		"chunk-2d0e5b23"
	],
	"./assets/Z/01/game-lobby/1420.png": [
		"6151",
		7,
		"chunk-2d0ceb8d"
	],
	"./assets/Z/01/game-lobby/1430-active.png": [
		"ee5c",
		7,
		"chunk-2d230c64"
	],
	"./assets/Z/01/game-lobby/1430.png": [
		"d77e",
		7,
		"chunk-2d21eb97"
	],
	"./assets/Z/01/game-lobby/1440-active.png": [
		"1583",
		7,
		"chunk-2d0ab515"
	],
	"./assets/Z/01/game-lobby/1440.png": [
		"a62c",
		7,
		"chunk-2d208a1c"
	],
	"./assets/Z/01/game-lobby/1450-active.png": [
		"3464",
		7,
		"chunk-2d0b99d5"
	],
	"./assets/Z/01/game-lobby/1450.png": [
		"2598",
		7,
		"chunk-2d0b2998"
	],
	"./assets/Z/01/game-lobby/1460-active.png": [
		"ba52",
		7,
		"chunk-2d21a012"
	],
	"./assets/Z/01/game-lobby/1460.png": [
		"6780",
		7,
		"chunk-2d0d026f"
	],
	"./assets/Z/01/game-lobby/1470-active.png": [
		"3d1c",
		7,
		"chunk-2d0c4d99"
	],
	"./assets/Z/01/game-lobby/1470.png": [
		"196a",
		7,
		"chunk-2d0ac409"
	],
	"./assets/Z/01/game-lobby/bg_jackpot.png": [
		"7ea7",
		7,
		"chunk-2d0e287a"
	],
	"./assets/Z/01/game-lobby/bg_lnk_inquire.png": [
		"200f",
		7,
		"chunk-2d0b15ea"
	],
	"./assets/Z/01/game-lobby/btnTrans.png": [
		"8a1b",
		7,
		"chunk-2d0e8830"
	],
	"./assets/Z/01/game-lobby/btn_favorites.png": [
		"537b",
		7,
		"chunk-2d0c7f1f"
	],
	"./assets/Z/01/game-lobby/btn_favorites_active.png": [
		"91ba",
		7,
		"chunk-2d0e4e4d"
	],
	"./assets/Z/01/game-lobby/btn_freeplay.png": [
		"562e",
		7,
		"chunk-2d0c89ca"
	],
	"./assets/Z/01/game-lobby/btn_start.png": [
		"079b",
		7,
		"chunk-2d0a4886"
	],
	"./assets/Z/01/game-lobby/ipt_favorites.png": [
		"0ed1",
		7,
		"chunk-2d0afa38"
	],
	"./assets/Z/01/game-lobby/popular.png": [
		"0a068",
		7,
		"chunk-7451b8eb"
	],
	"./assets/Z/01/header/btn_home.png": [
		"c3bb",
		7,
		"chunk-2d216d66"
	],
	"./assets/Z/01/header/headerBg.png": [
		"ed3f",
		7,
		"chunk-2d230868"
	],
	"./assets/Z/01/home/btn_maintain.png": [
		"f373",
		7,
		"chunk-2d22c51f"
	],
	"./assets/Z/01/lottery/luckyDraw.png": [
		"9fa7",
		7,
		"chunk-2d0f14f9"
	],
	"./assets/Z/01/lottery/rotaryTable.png": [
		"01ed",
		7,
		"chunk-2d0a3756"
	],
	"./assets/Z/01/maintenance/footer_logo1.png": [
		"baa3",
		7,
		"chunk-2d21a567"
	],
	"./assets/Z/01/maintenance/footer_logo2.png": [
		"0262",
		7,
		"chunk-2d0a3534"
	],
	"./assets/Z/01/maintenance/footer_logo3.png": [
		"793b",
		7,
		"chunk-2d0d7de7"
	],
	"./assets/Z/01/maintenance/footer_logo4.png": [
		"af3f",
		7,
		"chunk-2d213e6e"
	],
	"./assets/Z/01/maintenance/footer_logo5.png": [
		"f16f",
		7,
		"chunk-2d22bdb1"
	],
	"./assets/Z/01/maintenance/footer_logo6.png": [
		"7b91",
		7,
		"chunk-2d0e1859"
	],
	"./assets/Z/01/promotion/event01.jpg": [
		"2553",
		7,
		"chunk-2d0b2917"
	],
	"./assets/Z/01/promotion/event02.jpg": [
		"453b",
		7,
		"chunk-2d0c11c6"
	],
	"./assets/Z/01/promotion/event03.jpg": [
		"e120",
		7,
		"chunk-2d2248a0"
	],
	"./assets/Z/01/promotion/event04.jpg": [
		"ff7f",
		7,
		"chunk-2d2384c5"
	],
	"./assets/Z/01/promotion/event06.jpg": [
		"6601",
		7,
		"chunk-2d0cfdb7"
	],
	"./assets/Z/01/promotion/event07.jpg": [
		"0f01",
		7,
		"chunk-2d0af7ad"
	],
	"./assets/Z/01/ui/bg-maskLeft.png": [
		"3795",
		7,
		"chunk-2d0ba576"
	],
	"./assets/Z/01/ui/bg-maskRight.png": [
		"d3d6",
		7,
		"chunk-2d21e1d7"
	],
	"./assets/Z/01/ui/ddl_pager.jpg": [
		"2da7",
		7,
		"chunk-2d0bdede"
	],
	"./assets/Z/01/ui/goTOP.png": [
		"9a2d",
		7,
		"chunk-2d0efcb0"
	],
	"./assets/Z/01/ui/icon-tdControl.png": [
		"3870",
		7,
		"chunk-2d0ba8f4"
	],
	"./assets/Z/01/ui/lnk-trans-on.png": [
		"7066",
		7,
		"chunk-2d0d5c4f"
	],
	"./assets/Z/01/ui/lnk-trans.png": [
		"77c2",
		7,
		"chunk-2d0d7c05"
	],
	"./assets/Z/01/ui/lnk-trans2-on.png": [
		"38f6",
		7,
		"chunk-2d0baeab"
	],
	"./assets/Z/01/ui/lnk-trans2.png": [
		"1c3f",
		7,
		"chunk-2d0b615b"
	],
	"./assets/Z/01/ui/lnk_next.png": [
		"f00d",
		7,
		"chunk-2d22b934"
	],
	"./assets/Z/01/ui/lnk_nextMore.png": [
		"67a6",
		7,
		"chunk-2d0d076c"
	],
	"./assets/Z/01/ui/lnk_previous.png": [
		"eb0b",
		7,
		"chunk-2d230085"
	],
	"./assets/Z/01/ui/lnk_previousMore.png": [
		"4ac8",
		7,
		"chunk-2d0cbc98"
	],
	"./assets/Z/01/ui/swiper-button-next.png": [
		"6309",
		7,
		"chunk-2d0cf27c"
	],
	"./assets/Z/01/ui/swiper-button-prev.png": [
		"7be3",
		7,
		"chunk-2d0e1daf"
	],
	"./assets/Z/01/ui/ui-arrow-maskLeft.png": [
		"c722",
		7,
		"chunk-2d21766a"
	],
	"./assets/Z/01/ui/ui-arrow-maskRight.png": [
		"48f1",
		7,
		"chunk-2d0c2305"
	],
	"./assets/Z/01/ui/ui-arrow-select.png": [
		"0fa7",
		7,
		"chunk-2d0afda2"
	],
	"./assets/Z/01/ui/ui-arrow.png": [
		"6898",
		7,
		"chunk-2d0d0657"
	],
	"./assets/Z/01/ui/ui-arrow2-select.png": [
		"1110",
		7,
		"chunk-2d0aa535"
	],
	"./assets/Z/01/ui/ui-arrowL.png": [
		"e7d0",
		7,
		"chunk-2d226534"
	],
	"./assets/Z/01/ui/ui-collapse.png": [
		"fce9",
		7,
		"chunk-2d237ee7"
	],
	"./assets/Z/01/ui/ui-event.png": [
		"4bcf",
		7,
		"chunk-2d0cc087"
	],
	"./assets/Z/01/ui/ui-horn.png": [
		"fde6",
		7,
		"chunk-2d2382a5"
	],
	"./assets/Z/01/ui/ui-lobbyLeftSmall.png": [
		"bd14",
		7,
		"chunk-2d21aadb"
	],
	"./assets/Z/01/ui/ui-lobbyRightSmall.png": [
		"fc85",
		7,
		"chunk-2d237970"
	],
	"./assets/Z/01/ui/ui-status.png": [
		"b4be",
		7,
		"chunk-2d20fccb"
	],
	"./assets/Z/01/ui/ui-transfer.png": [
		"f3e8",
		7,
		"chunk-2d22cab6"
	],
	"./assets/Z/02/contact/mail.png": [
		"402b",
		7,
		"chunk-2d0bfee2"
	],
	"./assets/Z/02/contact/ui-contact.png": [
		"d2aa",
		7,
		"chunk-2d21dde4"
	],
	"./assets/Z/02/contact/ui-facebook.png": [
		"308f",
		7,
		"chunk-2d0b8b41"
	],
	"./assets/Z/02/contact/ui-telegram.png": [
		"e3ca",
		7,
		"chunk-2d225642"
	],
	"./assets/Z/02/footer/footerBg.png": [
		"e7fb",
		7,
		"chunk-2d2265a4"
	],
	"./assets/Z/02/footer/lnk_toolbar.png": [
		"20a6",
		7,
		"chunk-2d0b1ba9"
	],
	"./assets/Z/02/footer/toolbarBg.jpg": [
		"07a5",
		7,
		"chunk-2d0a4d31"
	],
	"./assets/Z/02/footer/toolbarBgActive.jpg": [
		"981d",
		7,
		"chunk-2d0e62a8"
	],
	"./assets/Z/02/footer/ui-footer-toolbar-bg.jpg": [
		"5305",
		7,
		"chunk-2d0c7e19"
	],
	"./assets/Z/02/footer/ui-footer-toolbar-contact.png": [
		"dd71",
		7,
		"chunk-2d229450"
	],
	"./assets/Z/02/footer/ui-footer-toolbar-event.png": [
		"d424",
		7,
		"chunk-2d21df88"
	],
	"./assets/Z/02/footer/ui-footer-toolbar-home.png": [
		"fac7",
		7,
		"chunk-2d237725"
	],
	"./assets/Z/02/footer/ui-footer-toolbar-line.png": [
		"5554",
		7,
		"chunk-2d0c8635"
	],
	"./assets/Z/02/footer/ui-footer-toolbar-registOrlogin.png": [
		"0ef0",
		7,
		"chunk-2d0afa75"
	],
	"./assets/Z/02/footer/ui-footer-toolbar-trading.png": [
		"3f82",
		7,
		"chunk-2d0c55c3"
	],
	"./assets/Z/02/forget-password/forgetDescBg.png": [
		"5fc3",
		7,
		"chunk-2d0d43b7"
	],
	"./assets/Z/02/game-lobby/1180-active.png": [
		"772d",
		7,
		"chunk-2d0d7648"
	],
	"./assets/Z/02/game-lobby/1180.png": [
		"1cfd",
		7,
		"chunk-2d0b6786"
	],
	"./assets/Z/02/game-lobby/1240-active.png": [
		"7ff3",
		7,
		"chunk-2d0e2cd2"
	],
	"./assets/Z/02/game-lobby/1240.png": [
		"ad2c",
		7,
		"chunk-2d2136ca"
	],
	"./assets/Z/02/game-lobby/1250-active.png": [
		"b208",
		7,
		"chunk-2d20ef0e"
	],
	"./assets/Z/02/game-lobby/1250.png": [
		"1495",
		7,
		"chunk-2d0ab175"
	],
	"./assets/Z/02/game-lobby/1260-active.png": [
		"bb1a",
		7,
		"chunk-2d21a386"
	],
	"./assets/Z/02/game-lobby/1260.png": [
		"d19d",
		7,
		"chunk-2d21d54e"
	],
	"./assets/Z/02/game-lobby/1270-active.png": [
		"3e29",
		7,
		"chunk-2d0c514f"
	],
	"./assets/Z/02/game-lobby/1270.png": [
		"96e3",
		7,
		"chunk-2d0e6141"
	],
	"./assets/Z/02/game-lobby/1280-active.png": [
		"9a0b",
		7,
		"chunk-2d0efc70"
	],
	"./assets/Z/02/game-lobby/1280.png": [
		"821c",
		7,
		"chunk-2d0dd7c2"
	],
	"./assets/Z/02/game-lobby/1300-active.png": [
		"95de",
		7,
		"chunk-2d0e5d93"
	],
	"./assets/Z/02/game-lobby/1300.png": [
		"e470",
		7,
		"chunk-2d22547e"
	],
	"./assets/Z/02/game-lobby/1310-active.png": [
		"48a6",
		7,
		"chunk-2d0c226f"
	],
	"./assets/Z/02/game-lobby/1310.png": [
		"cd75",
		7,
		"chunk-2d221ff5"
	],
	"./assets/Z/02/game-lobby/1340-active.png": [
		"88de",
		7,
		"chunk-2d0df477"
	],
	"./assets/Z/02/game-lobby/1340.png": [
		"684d",
		7,
		"chunk-2d0d05e8"
	],
	"./assets/Z/02/game-lobby/1350-active.png": [
		"ad31",
		7,
		"chunk-2d2136b7"
	],
	"./assets/Z/02/game-lobby/1350.png": [
		"b315",
		7,
		"chunk-2d20f2eb"
	],
	"./assets/Z/02/game-lobby/1360-active.png": [
		"1c48",
		7,
		"chunk-2d0b614c"
	],
	"./assets/Z/02/game-lobby/1360.png": [
		"a17a",
		7,
		"chunk-2d2077f0"
	],
	"./assets/Z/02/game-lobby/1370-active.png": [
		"a7609",
		7,
		"chunk-76f136d3"
	],
	"./assets/Z/02/game-lobby/1370.png": [
		"2a87",
		7,
		"chunk-2d0bcea4"
	],
	"./assets/Z/02/game-lobby/1380-active.png": [
		"4b57",
		7,
		"chunk-2d0cbac6"
	],
	"./assets/Z/02/game-lobby/1380.png": [
		"92b8",
		7,
		"chunk-2d0e51e5"
	],
	"./assets/Z/02/game-lobby/1390-active.png": [
		"b34e",
		7,
		"chunk-2d20f378"
	],
	"./assets/Z/02/game-lobby/1390.png": [
		"1d84",
		7,
		"chunk-2d0b6585"
	],
	"./assets/Z/02/game-lobby/1400-active.png": [
		"3352",
		7,
		"chunk-2d0b95f3"
	],
	"./assets/Z/02/game-lobby/1400.png": [
		"db71",
		7,
		"chunk-2d228cce"
	],
	"./assets/Z/02/game-lobby/1410-active.png": [
		"d9b0",
		7,
		"chunk-2d21f819"
	],
	"./assets/Z/02/game-lobby/1410.png": [
		"0887",
		7,
		"chunk-2d0a4bfd"
	],
	"./assets/Z/02/game-lobby/1420-active.png": [
		"c20d",
		7,
		"chunk-2d216399"
	],
	"./assets/Z/02/game-lobby/1420.png": [
		"7667",
		7,
		"chunk-2d0d72d6"
	],
	"./assets/Z/02/game-lobby/1430-active.png": [
		"a97b",
		7,
		"chunk-2d2095f9"
	],
	"./assets/Z/02/game-lobby/1430.png": [
		"6f05",
		7,
		"chunk-2d0db1eb"
	],
	"./assets/Z/02/game-lobby/1440-active.png": [
		"11d0",
		7,
		"chunk-2d0aab62"
	],
	"./assets/Z/02/game-lobby/1440.png": [
		"3053",
		7,
		"chunk-2d0b8ab1"
	],
	"./assets/Z/02/game-lobby/1450-active.png": [
		"f95c",
		7,
		"chunk-2d22db97"
	],
	"./assets/Z/02/game-lobby/1450.png": [
		"da8c",
		7,
		"chunk-2d22895e"
	],
	"./assets/Z/02/game-lobby/1460-active.png": [
		"90b9",
		7,
		"chunk-2d0e4a64"
	],
	"./assets/Z/02/game-lobby/1460.png": [
		"47cf",
		7,
		"chunk-2d0c1f1c"
	],
	"./assets/Z/02/game-lobby/1470-active.png": [
		"550d",
		7,
		"chunk-2d0c85ca"
	],
	"./assets/Z/02/game-lobby/1470.png": [
		"4bb5",
		7,
		"chunk-2d0cc037"
	],
	"./assets/Z/02/game-lobby/bg-category.jpg": [
		"02d0",
		7,
		"chunk-2d0a3ac4"
	],
	"./assets/Z/02/game-lobby/bg_jackpot-en-us.png": [
		"3301",
		7,
		"chunk-2d0b9557"
	],
	"./assets/Z/02/game-lobby/bg_jackpot-th-th.png": [
		"d785",
		7,
		"chunk-2d21eb86"
	],
	"./assets/Z/02/game-lobby/bg_jackpot-zh-cn.png": [
		"edc6",
		7,
		"chunk-2d230e08"
	],
	"./assets/Z/02/game-lobby/bg_lnk_inquire.png": [
		"8b73",
		7,
		"chunk-2d0e8c7c"
	],
	"./assets/Z/02/game-lobby/bg_lnk_inquire2.png": [
		"807e",
		7,
		"chunk-2d0dd0fc"
	],
	"./assets/Z/02/game-lobby/btnTrans.png": [
		"ddfe",
		7,
		"chunk-2d229a35"
	],
	"./assets/Z/02/game-lobby/btn_favorites.png": [
		"cf9d",
		7,
		"chunk-2d2227e4"
	],
	"./assets/Z/02/game-lobby/btn_favorites_active.png": [
		"fabe",
		7,
		"chunk-2d237734"
	],
	"./assets/Z/02/game-lobby/btn_freeplay.png": [
		"3ad0",
		7,
		"chunk-2d0c4850"
	],
	"./assets/Z/02/game-lobby/btn_start.png": [
		"12bf",
		7,
		"chunk-2d0aaf1b"
	],
	"./assets/Z/02/game-lobby/ipt_favorites.png": [
		"0893",
		7,
		"chunk-2d0a4c18"
	],
	"./assets/Z/02/game-lobby/popular.png": [
		"c18d",
		7,
		"chunk-2d2160d0"
	],
	"./assets/Z/02/header/btn_home.png": [
		"d6da",
		7,
		"chunk-2d21ed45"
	],
	"./assets/Z/02/header/headerBg.png": [
		"2639",
		7,
		"chunk-2d0b2ca0"
	],
	"./assets/Z/02/header/ui-langBg.jpg": [
		"a124",
		7,
		"chunk-2d207728"
	],
	"./assets/Z/02/home/btn_maintain.png": [
		"69d5",
		7,
		"chunk-2d0d0f4a"
	],
	"./assets/Z/02/lottery/luckyDraw.png": [
		"86df",
		7,
		"chunk-2d0decf6"
	],
	"./assets/Z/02/lottery/rotaryTable.png": [
		"4767",
		7,
		"chunk-2d0c197a"
	],
	"./assets/Z/02/maintenance/footer_logo1.png": [
		"e358",
		7,
		"chunk-2d225087"
	],
	"./assets/Z/02/maintenance/footer_logo2.png": [
		"d64a",
		7,
		"chunk-2d21e775"
	],
	"./assets/Z/02/maintenance/footer_logo3.png": [
		"381b",
		7,
		"chunk-2d0ba86c"
	],
	"./assets/Z/02/maintenance/footer_logo4.png": [
		"f2b4",
		7,
		"chunk-2d22c694"
	],
	"./assets/Z/02/maintenance/footer_logo5.png": [
		"d6da3",
		7,
		"chunk-771bbb8e"
	],
	"./assets/Z/02/maintenance/footer_logo6.png": [
		"c2df",
		7,
		"chunk-2d2169e7"
	],
	"./assets/Z/02/promotion/event01.jpg": [
		"8280",
		7,
		"chunk-2d0dd868"
	],
	"./assets/Z/02/promotion/event02.jpg": [
		"1701",
		7,
		"chunk-2d0abb9d"
	],
	"./assets/Z/02/promotion/event03.jpg": [
		"e3ae",
		7,
		"chunk-2d225608"
	],
	"./assets/Z/02/promotion/event04.jpg": [
		"07ed",
		7,
		"chunk-2d0a4ddc"
	],
	"./assets/Z/02/promotion/event06.jpg": [
		"9b4c",
		7,
		"chunk-2d0f00ae"
	],
	"./assets/Z/02/promotion/event07.jpg": [
		"815b",
		7,
		"chunk-2d0dd47c"
	],
	"./assets/Z/02/ui/bg-maskLeft.png": [
		"9ee9",
		7,
		"chunk-2d0f11b6"
	],
	"./assets/Z/02/ui/bg-maskRight.png": [
		"d71c",
		7,
		"chunk-2d21eadb"
	],
	"./assets/Z/02/ui/btnTrans.png": [
		"5a44",
		7,
		"chunk-2d0d2b42"
	],
	"./assets/Z/02/ui/ddl_pager.jpg": [
		"89e9",
		7,
		"chunk-2d0df82b"
	],
	"./assets/Z/02/ui/goTOP.png": [
		"5a7e",
		7,
		"chunk-2d0d2bd0"
	],
	"./assets/Z/02/ui/icon-tdControl.png": [
		"312b",
		7,
		"chunk-2d0b8e44"
	],
	"./assets/Z/02/ui/lnk-home.png": [
		"0d72",
		7,
		"chunk-2d0af105"
	],
	"./assets/Z/02/ui/lnk-trans-on.png": [
		"70a7",
		7,
		"chunk-2d0d6185"
	],
	"./assets/Z/02/ui/lnk-trans.png": [
		"2765",
		7,
		"chunk-2d0b30ba"
	],
	"./assets/Z/02/ui/lnk-trans2-on.png": [
		"9d63",
		7,
		"chunk-2d0f083e"
	],
	"./assets/Z/02/ui/lnk-trans2.png": [
		"6c32",
		7,
		"chunk-2d0da702"
	],
	"./assets/Z/02/ui/lnk_next.png": [
		"f2fb",
		7,
		"chunk-2d22c73e"
	],
	"./assets/Z/02/ui/lnk_nextMore.png": [
		"fb56",
		7,
		"chunk-2d237553"
	],
	"./assets/Z/02/ui/lnk_previous.png": [
		"fb8e",
		7,
		"chunk-2d2375df"
	],
	"./assets/Z/02/ui/lnk_previousMore.png": [
		"761a",
		7,
		"chunk-2d0d7265"
	],
	"./assets/Z/02/ui/swiper-button-next.png": [
		"005f",
		7,
		"chunk-2d0a2dc7"
	],
	"./assets/Z/02/ui/swiper-button-prev.png": [
		"cfc8",
		7,
		"chunk-2d222cce"
	],
	"./assets/Z/02/ui/ui-arrow-maskLeft.png": [
		"44c0",
		7,
		"chunk-2d0c13a3"
	],
	"./assets/Z/02/ui/ui-arrow-maskRight.png": [
		"2131",
		7,
		"chunk-2d0b19d3"
	],
	"./assets/Z/02/ui/ui-arrow-select.png": [
		"d815",
		7,
		"chunk-2d21ee6e"
	],
	"./assets/Z/02/ui/ui-arrow.png": [
		"0d83",
		7,
		"chunk-2d0af125"
	],
	"./assets/Z/02/ui/ui-arrow2-select.png": [
		"f766",
		7,
		"chunk-2d22d407"
	],
	"./assets/Z/02/ui/ui-arrowL.png": [
		"5651",
		7,
		"chunk-2d0c89f3"
	],
	"./assets/Z/02/ui/ui-collapse.png": [
		"64eb",
		7,
		"chunk-2d0cfcd1"
	],
	"./assets/Z/02/ui/ui-event.png": [
		"29ad",
		7,
		"chunk-2d0b3da0"
	],
	"./assets/Z/02/ui/ui-horn.png": [
		"e0df",
		7,
		"chunk-2d224b23"
	],
	"./assets/Z/02/ui/ui-indexBg.jpg": [
		"9504",
		7,
		"chunk-2d0e5716"
	],
	"./assets/Z/02/ui/ui-lobbyLeftSmall.png": [
		"f928",
		7,
		"chunk-2d22db0f"
	],
	"./assets/Z/02/ui/ui-lobbyRightSmall.png": [
		"5e04",
		7,
		"chunk-2d0d39ca"
	],
	"./assets/Z/02/ui/ui-page-bg.jpg": [
		"5439",
		7,
		"chunk-2d0c823b"
	],
	"./assets/Z/02/ui/ui-status.png": [
		"8d07",
		7,
		"chunk-2d0e9329"
	],
	"./assets/Z/02/ui/ui-transfer.png": [
		"053c",
		7,
		"chunk-2d0a404b"
	],
	"./assets/Z/03/contact/mail.png": [
		"08ef",
		7,
		"chunk-2d0a519f"
	],
	"./assets/Z/03/contact/ui-contact.png": [
		"19aa",
		7,
		"chunk-2d0ac93e"
	],
	"./assets/Z/03/contact/ui-facebook.png": [
		"f890",
		7,
		"chunk-2d22d81f"
	],
	"./assets/Z/03/contact/ui-telegram.png": [
		"1704",
		7,
		"chunk-2d0abba0"
	],
	"./assets/Z/03/footer/footerBg.png": [
		"e7b8",
		7,
		"chunk-2d2264fe"
	],
	"./assets/Z/03/footer/lnk_toolbar.png": [
		"198c",
		7,
		"chunk-2d0ac449"
	],
	"./assets/Z/03/footer/toolbarBg.jpg": [
		"40e2",
		7,
		"chunk-2d0c04df"
	],
	"./assets/Z/03/footer/toolbarBgActive.jpg": [
		"7904",
		7,
		"chunk-2d0d7d5c"
	],
	"./assets/Z/03/footer/ui-footer-toolbar-bg.jpg": [
		"823a",
		7,
		"chunk-2d0dd7fe"
	],
	"./assets/Z/03/footer/ui-footer-toolbar-contact.png": [
		"2fb1",
		7,
		"chunk-2d0be679"
	],
	"./assets/Z/03/footer/ui-footer-toolbar-event.png": [
		"867c",
		7,
		"chunk-2d0de780"
	],
	"./assets/Z/03/footer/ui-footer-toolbar-home.png": [
		"00ce",
		7,
		"chunk-2d0a3358"
	],
	"./assets/Z/03/footer/ui-footer-toolbar-line.png": [
		"d648",
		7,
		"chunk-2d21e74c"
	],
	"./assets/Z/03/footer/ui-footer-toolbar-registOrlogin.png": [
		"fbd0",
		7,
		"chunk-2d237afe"
	],
	"./assets/Z/03/footer/ui-footer-toolbar-trading.png": [
		"8339",
		7,
		"chunk-2d0ddb97"
	],
	"./assets/Z/03/forget-password/forgetDescBg.png": [
		"6b8b",
		7,
		"chunk-2d0da40c"
	],
	"./assets/Z/03/game-lobby/1180-active.png": [
		"23f9",
		7,
		"chunk-2d0b278a"
	],
	"./assets/Z/03/game-lobby/1180.png": [
		"f1b9",
		7,
		"chunk-2d22c2d8"
	],
	"./assets/Z/03/game-lobby/1240-active.png": [
		"2c36",
		7,
		"chunk-2d0bd58a"
	],
	"./assets/Z/03/game-lobby/1240.png": [
		"b199",
		7,
		"chunk-2d20ec65"
	],
	"./assets/Z/03/game-lobby/1250-active.png": [
		"383e",
		7,
		"chunk-2d0ba8ad"
	],
	"./assets/Z/03/game-lobby/1250.png": [
		"86c5",
		7,
		"chunk-2d0deca6"
	],
	"./assets/Z/03/game-lobby/1260-active.png": [
		"141d",
		7,
		"chunk-2d0ab0ac"
	],
	"./assets/Z/03/game-lobby/1260.png": [
		"2f26",
		7,
		"chunk-2d0be0ae"
	],
	"./assets/Z/03/game-lobby/1270-active.png": [
		"893c",
		7,
		"chunk-2d0df247"
	],
	"./assets/Z/03/game-lobby/1270.png": [
		"a096",
		7,
		"chunk-2d207442"
	],
	"./assets/Z/03/game-lobby/1280-active.png": [
		"dc70",
		7,
		"chunk-2d22908e"
	],
	"./assets/Z/03/game-lobby/1280.png": [
		"af49",
		7,
		"chunk-2d213e60"
	],
	"./assets/Z/03/game-lobby/1300-active.png": [
		"baf8",
		7,
		"chunk-2d21a607"
	],
	"./assets/Z/03/game-lobby/1300.png": [
		"3ed2",
		7,
		"chunk-2d0c5756"
	],
	"./assets/Z/03/game-lobby/1310-active.png": [
		"e5f3",
		7,
		"chunk-2d225df3"
	],
	"./assets/Z/03/game-lobby/1310.png": [
		"a8a7",
		7,
		"chunk-2d209723"
	],
	"./assets/Z/03/game-lobby/1340-active.png": [
		"254a",
		7,
		"chunk-2d0b2926"
	],
	"./assets/Z/03/game-lobby/1340.png": [
		"4615",
		7,
		"chunk-2d0c151c"
	],
	"./assets/Z/03/game-lobby/1350-active.png": [
		"ccfc",
		7,
		"chunk-2d222213"
	],
	"./assets/Z/03/game-lobby/1350.png": [
		"9d2a",
		7,
		"chunk-2d0f07f0"
	],
	"./assets/Z/03/game-lobby/1360-active.png": [
		"9bb6",
		7,
		"chunk-2d0f0613"
	],
	"./assets/Z/03/game-lobby/1360.png": [
		"7b6b",
		7,
		"chunk-2d0e182d"
	],
	"./assets/Z/03/game-lobby/1370-active.png": [
		"5eb9",
		7,
		"chunk-2d0d3fdd"
	],
	"./assets/Z/03/game-lobby/1370.png": [
		"e8d3",
		7,
		"chunk-2d2268f8"
	],
	"./assets/Z/03/game-lobby/1380-active.png": [
		"e9fc",
		7,
		"chunk-2d226d27"
	],
	"./assets/Z/03/game-lobby/1380.png": [
		"c40d",
		7,
		"chunk-2d216b1b"
	],
	"./assets/Z/03/game-lobby/1390-active.png": [
		"0cf4",
		7,
		"chunk-2d0af2f7"
	],
	"./assets/Z/03/game-lobby/1390.png": [
		"e7c0",
		7,
		"chunk-2d226515"
	],
	"./assets/Z/03/game-lobby/1400-active.png": [
		"a606",
		7,
		"chunk-2d2089b1"
	],
	"./assets/Z/03/game-lobby/1400.png": [
		"100a",
		7,
		"chunk-2d0aa186"
	],
	"./assets/Z/03/game-lobby/1410-active.png": [
		"34ba",
		7,
		"chunk-2d0b9f56"
	],
	"./assets/Z/03/game-lobby/1410.png": [
		"a904",
		7,
		"chunk-2d2094f2"
	],
	"./assets/Z/03/game-lobby/1420-active.png": [
		"0afa",
		7,
		"chunk-2d0aeba2"
	],
	"./assets/Z/03/game-lobby/1420.png": [
		"532d",
		7,
		"chunk-2d0c7e86"
	],
	"./assets/Z/03/game-lobby/1430-active.png": [
		"7a11",
		7,
		"chunk-2d0e13a0"
	],
	"./assets/Z/03/game-lobby/1430.png": [
		"d8fa",
		7,
		"chunk-2d21f505"
	],
	"./assets/Z/03/game-lobby/1440-active.png": [
		"1dc6",
		7,
		"chunk-2d0b6abc"
	],
	"./assets/Z/03/game-lobby/1440.png": [
		"6341",
		7,
		"chunk-2d0cf2f0"
	],
	"./assets/Z/03/game-lobby/1450-active.png": [
		"968d",
		7,
		"chunk-2d0e5bff"
	],
	"./assets/Z/03/game-lobby/1450.png": [
		"bf99",
		7,
		"chunk-2d21b35a"
	],
	"./assets/Z/03/game-lobby/1460-active.png": [
		"efb5",
		7,
		"chunk-2d23156a"
	],
	"./assets/Z/03/game-lobby/1460.png": [
		"7a56",
		7,
		"chunk-2d0e1421"
	],
	"./assets/Z/03/game-lobby/1470-active.png": [
		"83d4",
		7,
		"chunk-2d0de181"
	],
	"./assets/Z/03/game-lobby/1470.png": [
		"27dc",
		7,
		"chunk-2d0b367a"
	],
	"./assets/Z/03/game-lobby/bg-category.jpg": [
		"7236",
		7,
		"chunk-2d0d6374"
	],
	"./assets/Z/03/game-lobby/bg_Trans.png": [
		"5bb8",
		7,
		"chunk-2d0d3499"
	],
	"./assets/Z/03/game-lobby/bg_jackpot-en-us.png": [
		"5c48",
		7,
		"chunk-2d0d32c8"
	],
	"./assets/Z/03/game-lobby/bg_jackpot-th-th.png": [
		"0335",
		7,
		"chunk-2d0a389b"
	],
	"./assets/Z/03/game-lobby/bg_jackpot-zh-cn.png": [
		"d744",
		7,
		"chunk-2d21eb09"
	],
	"./assets/Z/03/game-lobby/bg_lnk_inquire2.png": [
		"a32b",
		7,
		"chunk-2d207ed8"
	],
	"./assets/Z/03/game-lobby/btnTrans.png": [
		"bc0e",
		7,
		"chunk-2d21a72c"
	],
	"./assets/Z/03/game-lobby/btn_favorites.png": [
		"235d",
		7,
		"chunk-2d0b21c6"
	],
	"./assets/Z/03/game-lobby/btn_favorites_active.png": [
		"2ed1",
		7,
		"chunk-2d0be2f6"
	],
	"./assets/Z/03/game-lobby/btn_freeplay.png": [
		"43c1",
		7,
		"chunk-2d0c0fe3"
	],
	"./assets/Z/03/game-lobby/btn_start.png": [
		"ace8",
		7,
		"chunk-2d21390b"
	],
	"./assets/Z/03/game-lobby/ipt_favorites.png": [
		"3ff5",
		7,
		"chunk-2d0c5b58"
	],
	"./assets/Z/03/game-lobby/popular.png": [
		"2e68",
		7,
		"chunk-2d0bdd6b"
	],
	"./assets/Z/03/header/btn_home.png": [
		"4246",
		7,
		"chunk-2d0c0676"
	],
	"./assets/Z/03/header/headerBg.png": [
		"7931",
		7,
		"chunk-2d0d7db6"
	],
	"./assets/Z/03/header/ui-langBg.jpg": [
		"c8c9",
		7,
		"chunk-2d218021"
	],
	"./assets/Z/03/home/btn_maintain.png": [
		"699b",
		7,
		"chunk-2d0d0a42"
	],
	"./assets/Z/03/lottery/luckyDraw.png": [
		"0253",
		7,
		"chunk-2d0a3516"
	],
	"./assets/Z/03/lottery/rotaryTable.png": [
		"05d0",
		7,
		"chunk-2d0a4607"
	],
	"./assets/Z/03/maintenance/footer_logo1.png": [
		"d5af",
		7,
		"chunk-2d21e92c"
	],
	"./assets/Z/03/maintenance/footer_logo2.png": [
		"3d76",
		7,
		"chunk-2d0c4e26"
	],
	"./assets/Z/03/maintenance/footer_logo3.png": [
		"174d",
		7,
		"chunk-2d0abc4c"
	],
	"./assets/Z/03/maintenance/footer_logo4.png": [
		"7a6c",
		7,
		"chunk-2d0e146d"
	],
	"./assets/Z/03/maintenance/footer_logo5.png": [
		"93ac",
		7,
		"chunk-2d0e55b2"
	],
	"./assets/Z/03/maintenance/footer_logo6.png": [
		"fbac",
		7,
		"chunk-2d237ad4"
	],
	"./assets/Z/03/promotion/event01.jpg": [
		"b660",
		7,
		"chunk-2d20fec4"
	],
	"./assets/Z/03/promotion/event02.jpg": [
		"a3ef",
		7,
		"chunk-2d208509"
	],
	"./assets/Z/03/promotion/event03.jpg": [
		"58b4",
		7,
		"chunk-2d0c96eb"
	],
	"./assets/Z/03/promotion/event04.jpg": [
		"0e82",
		7,
		"chunk-2d0af4e5"
	],
	"./assets/Z/03/promotion/event06.jpg": [
		"04be",
		7,
		"chunk-2d0a423d"
	],
	"./assets/Z/03/promotion/event07.jpg": [
		"b89d",
		7,
		"chunk-2d2106d7"
	],
	"./assets/Z/03/ui/bg-maskLeft.png": [
		"4bf4",
		7,
		"chunk-2d0cc0b2"
	],
	"./assets/Z/03/ui/bg-maskRight.png": [
		"22f2",
		7,
		"chunk-2d0b23c2"
	],
	"./assets/Z/03/ui/ddl_pager.jpg": [
		"c91d",
		7,
		"chunk-2d217dff"
	],
	"./assets/Z/03/ui/goTOP.png": [
		"cd43",
		7,
		"chunk-2d221f96"
	],
	"./assets/Z/03/ui/icon-tdControl.png": [
		"a474",
		7,
		"chunk-2d208306"
	],
	"./assets/Z/03/ui/lnk-trans-on.png": [
		"4d5a",
		7,
		"chunk-2d0cc272"
	],
	"./assets/Z/03/ui/lnk-trans.png": [
		"472f",
		7,
		"chunk-2d0c192d"
	],
	"./assets/Z/03/ui/lnk-trans2-on.png": [
		"9e87",
		7,
		"chunk-2d0f0c41"
	],
	"./assets/Z/03/ui/lnk-trans2.png": [
		"2519",
		7,
		"chunk-2d0b28a1"
	],
	"./assets/Z/03/ui/lnk_next.png": [
		"1da2",
		7,
		"chunk-2d0b6a7a"
	],
	"./assets/Z/03/ui/lnk_nextMore.png": [
		"0ca6",
		7,
		"chunk-2d0af25e"
	],
	"./assets/Z/03/ui/lnk_previous.png": [
		"8e85",
		7,
		"chunk-2d0e97e0"
	],
	"./assets/Z/03/ui/lnk_previousMore.png": [
		"8e91",
		7,
		"chunk-2d0e97fb"
	],
	"./assets/Z/03/ui/swiper-button-next.png": [
		"eee4",
		7,
		"chunk-2d231205"
	],
	"./assets/Z/03/ui/swiper-button-prev.png": [
		"4c7b",
		7,
		"chunk-2d0cbef0"
	],
	"./assets/Z/03/ui/ui-arrow-maskLeft.png": [
		"29f6",
		7,
		"chunk-2d0b3e0d"
	],
	"./assets/Z/03/ui/ui-arrow-maskRight.png": [
		"f4f7",
		7,
		"chunk-2d22ce95"
	],
	"./assets/Z/03/ui/ui-arrow-select.png": [
		"020e1",
		7,
		"chunk-743c6124"
	],
	"./assets/Z/03/ui/ui-arrow.png": [
		"e518",
		7,
		"chunk-2d22578d"
	],
	"./assets/Z/03/ui/ui-arrow2-select.png": [
		"aeab",
		7,
		"chunk-2d21403b"
	],
	"./assets/Z/03/ui/ui-arrowL.png": [
		"df05",
		7,
		"chunk-2d229afd"
	],
	"./assets/Z/03/ui/ui-collapse.png": [
		"57e9",
		7,
		"chunk-2d0c938c"
	],
	"./assets/Z/03/ui/ui-event.png": [
		"8c20",
		7,
		"chunk-2d0e8f9f"
	],
	"./assets/Z/03/ui/ui-horn.png": [
		"d889",
		7,
		"chunk-2d21ef4b"
	],
	"./assets/Z/03/ui/ui-indexBg.jpg": [
		"d1c3",
		7,
		"chunk-2d21da33"
	],
	"./assets/Z/03/ui/ui-lobbyLeftSmall.png": [
		"c1ab",
		7,
		"chunk-2d2165c5"
	],
	"./assets/Z/03/ui/ui-lobbyRightSmall.png": [
		"03d3",
		7,
		"chunk-2d0a3e88"
	],
	"./assets/Z/03/ui/ui-status.png": [
		"3e65",
		7,
		"chunk-2d0c51c7"
	],
	"./assets/Z/03/ui/ui-transfer.png": [
		"c213",
		7,
		"chunk-2d216387"
	],
	"./assets/Z/04/contact/mail.png": [
		"6b0d",
		7,
		"chunk-2d0da316"
	],
	"./assets/Z/04/contact/ui-contact.png": [
		"2d24",
		7,
		"chunk-2d0bd92a"
	],
	"./assets/Z/04/contact/ui-facebook.png": [
		"4f5c",
		7,
		"chunk-2d0cc9f6"
	],
	"./assets/Z/04/contact/ui-telegram.png": [
		"98f8",
		7,
		"chunk-2d0e68e7"
	],
	"./assets/Z/04/footer/footerBg.png": [
		"4c31",
		7,
		"chunk-2d0cbe43"
	],
	"./assets/Z/04/footer/lnk_toolbar.png": [
		"38e3",
		7,
		"chunk-2d0bae89"
	],
	"./assets/Z/04/footer/toolbarBg.jpg": [
		"f858",
		7,
		"chunk-2d22d7ab"
	],
	"./assets/Z/04/footer/toolbarBgActive.jpg": [
		"2861",
		7,
		"chunk-2d0b3477"
	],
	"./assets/Z/04/footer/ui-footer-toolbar-bg.jpg": [
		"ca86",
		7,
		"chunk-2d2214d2"
	],
	"./assets/Z/04/footer/ui-footer-toolbar-contact.png": [
		"2842",
		7,
		"chunk-2d0b343a"
	],
	"./assets/Z/04/footer/ui-footer-toolbar-event.png": [
		"7fb3",
		7,
		"chunk-2d0e2c56"
	],
	"./assets/Z/04/footer/ui-footer-toolbar-home.png": [
		"6de3",
		7,
		"chunk-2d0db0d2"
	],
	"./assets/Z/04/footer/ui-footer-toolbar-line.png": [
		"7d97",
		7,
		"chunk-2d0e1fe1"
	],
	"./assets/Z/04/footer/ui-footer-toolbar-registOrlogin.png": [
		"c638",
		7,
		"chunk-2d2172ce"
	],
	"./assets/Z/04/footer/ui-footer-toolbar-trading.png": [
		"3fa5",
		7,
		"chunk-2d0c5abd"
	],
	"./assets/Z/04/forget-password/forgetDescBg.png": [
		"8138",
		7,
		"chunk-2d0dd414"
	],
	"./assets/Z/04/game-lobby/1180-active.png": [
		"cb79",
		7,
		"chunk-2d221877"
	],
	"./assets/Z/04/game-lobby/1180.png": [
		"13ee",
		7,
		"chunk-2d0ab338"
	],
	"./assets/Z/04/game-lobby/1240-active.png": [
		"e6a2",
		7,
		"chunk-2d226118"
	],
	"./assets/Z/04/game-lobby/1240.png": [
		"5ce7",
		7,
		"chunk-2d0d38b6"
	],
	"./assets/Z/04/game-lobby/1250-active.png": [
		"72d6",
		7,
		"chunk-2d0d6963"
	],
	"./assets/Z/04/game-lobby/1250.png": [
		"bcd4",
		7,
		"chunk-2d21ad47"
	],
	"./assets/Z/04/game-lobby/1260-active.png": [
		"5f33",
		7,
		"chunk-2d0d3de7"
	],
	"./assets/Z/04/game-lobby/1260.png": [
		"58781",
		7,
		"chunk-7485a5b7"
	],
	"./assets/Z/04/game-lobby/1270-active.png": [
		"a703",
		7,
		"chunk-2d208d6f"
	],
	"./assets/Z/04/game-lobby/1270.png": [
		"8688",
		7,
		"chunk-2d0de774"
	],
	"./assets/Z/04/game-lobby/1280-active.png": [
		"2e13",
		7,
		"chunk-2d0bdccb"
	],
	"./assets/Z/04/game-lobby/1280.png": [
		"8239",
		7,
		"chunk-2d0dd7d6"
	],
	"./assets/Z/04/game-lobby/1300-active.png": [
		"0440",
		7,
		"chunk-2d0a3c76"
	],
	"./assets/Z/04/game-lobby/1300.png": [
		"2ba6",
		7,
		"chunk-2d0bd75b"
	],
	"./assets/Z/04/game-lobby/1310-active.png": [
		"7739",
		7,
		"chunk-2d0d763c"
	],
	"./assets/Z/04/game-lobby/1310.png": [
		"4c6f",
		7,
		"chunk-2d0cbed5"
	],
	"./assets/Z/04/game-lobby/1340-active.png": [
		"67ff",
		7,
		"chunk-2d0d0837"
	],
	"./assets/Z/04/game-lobby/1340.png": [
		"b627",
		7,
		"chunk-2d20fe4f"
	],
	"./assets/Z/04/game-lobby/1350-active.png": [
		"a91b",
		7,
		"chunk-2d20953f"
	],
	"./assets/Z/04/game-lobby/1350.png": [
		"7575",
		7,
		"chunk-2d0d6f32"
	],
	"./assets/Z/04/game-lobby/1360-active.png": [
		"c9b7",
		7,
		"chunk-2d2183c1"
	],
	"./assets/Z/04/game-lobby/1360.png": [
		"149e",
		7,
		"chunk-2d0ab1a5"
	],
	"./assets/Z/04/game-lobby/1370-active.png": [
		"b45f",
		7,
		"chunk-2d20f759"
	],
	"./assets/Z/04/game-lobby/1370.png": [
		"3510",
		7,
		"chunk-2d0b9cf7"
	],
	"./assets/Z/04/game-lobby/1380-active.png": [
		"40eb",
		7,
		"chunk-2d0c050f"
	],
	"./assets/Z/04/game-lobby/1380.png": [
		"9f14",
		7,
		"chunk-2d0f0f26"
	],
	"./assets/Z/04/game-lobby/1390-active.png": [
		"edc0",
		7,
		"chunk-2d230e02"
	],
	"./assets/Z/04/game-lobby/1390.png": [
		"9ac1",
		7,
		"chunk-2d0f026c"
	],
	"./assets/Z/04/game-lobby/1400-active.png": [
		"6474",
		7,
		"chunk-2d0cf711"
	],
	"./assets/Z/04/game-lobby/1400.png": [
		"d8ea",
		7,
		"chunk-2d21f4e6"
	],
	"./assets/Z/04/game-lobby/1410-active.png": [
		"3b1c",
		7,
		"chunk-2d0c4617"
	],
	"./assets/Z/04/game-lobby/1410.png": [
		"4a36",
		7,
		"chunk-2d0cb6c6"
	],
	"./assets/Z/04/game-lobby/1420-active.png": [
		"df09",
		7,
		"chunk-2d229b01"
	],
	"./assets/Z/04/game-lobby/1420.png": [
		"6fa8",
		7,
		"chunk-2d0db7dd"
	],
	"./assets/Z/04/game-lobby/1430-active.png": [
		"4eb1",
		7,
		"chunk-2d0ccb76"
	],
	"./assets/Z/04/game-lobby/1430.png": [
		"5a8e",
		7,
		"chunk-2d0d2bef"
	],
	"./assets/Z/04/game-lobby/1440-active.png": [
		"0741",
		7,
		"chunk-2d0a47ba"
	],
	"./assets/Z/04/game-lobby/1440.png": [
		"b03d",
		7,
		"chunk-2d20e815"
	],
	"./assets/Z/04/game-lobby/1450-active.png": [
		"1a9c",
		7,
		"chunk-2d0b5a90"
	],
	"./assets/Z/04/game-lobby/1450.png": [
		"c6fd",
		7,
		"chunk-2d217927"
	],
	"./assets/Z/04/game-lobby/1460-active.png": [
		"0137",
		7,
		"chunk-2d0a311b"
	],
	"./assets/Z/04/game-lobby/1460.png": [
		"5053",
		7,
		"chunk-2d0c736f"
	],
	"./assets/Z/04/game-lobby/1470-active.png": [
		"c585",
		7,
		"chunk-2d216fa5"
	],
	"./assets/Z/04/game-lobby/1470.png": [
		"23e2",
		7,
		"chunk-2d0b2764"
	],
	"./assets/Z/04/game-lobby/bg-category.jpg": [
		"c454",
		7,
		"chunk-2d216b86"
	],
	"./assets/Z/04/game-lobby/bg_Trans.png": [
		"e0b6",
		7,
		"chunk-2d224ab5"
	],
	"./assets/Z/04/game-lobby/bg_jackpot-en-us.png": [
		"43c7",
		7,
		"chunk-2d0c0fe9"
	],
	"./assets/Z/04/game-lobby/bg_jackpot-th-th.png": [
		"03a6",
		7,
		"chunk-2d0a3e2e"
	],
	"./assets/Z/04/game-lobby/bg_jackpot-zh-cn.png": [
		"6eb7",
		7,
		"chunk-2d0db43a"
	],
	"./assets/Z/04/game-lobby/bg_lnk_inquire2.png": [
		"0605",
		7,
		"chunk-2d0a4381"
	],
	"./assets/Z/04/game-lobby/btnTrans.png": [
		"34ec",
		7,
		"chunk-2d0b9fb5"
	],
	"./assets/Z/04/game-lobby/btn_favorites.png": [
		"6efb",
		7,
		"chunk-2d0db4e1"
	],
	"./assets/Z/04/game-lobby/btn_favorites_active.png": [
		"70a4",
		7,
		"chunk-2d0d6182"
	],
	"./assets/Z/04/game-lobby/btn_freeplay.png": [
		"f2a6",
		7,
		"chunk-2d22c677"
	],
	"./assets/Z/04/game-lobby/btn_start.png": [
		"eade",
		7,
		"chunk-2d230313"
	],
	"./assets/Z/04/game-lobby/ipt_favorites.png": [
		"f0ac",
		7,
		"chunk-2d22bf22"
	],
	"./assets/Z/04/game-lobby/popular.png": [
		"c5855",
		7,
		"chunk-770c8530"
	],
	"./assets/Z/04/header/btn_home.png": [
		"c99a",
		7,
		"chunk-2d217ef4"
	],
	"./assets/Z/04/header/headerBg.png": [
		"3fb9",
		7,
		"chunk-2d0c5ae0"
	],
	"./assets/Z/04/home/btn_maintain.png": [
		"f5b7",
		7,
		"chunk-2d22d1da"
	],
	"./assets/Z/04/lottery/luckyDraw.png": [
		"b927",
		7,
		"chunk-2d210992"
	],
	"./assets/Z/04/lottery/rotaryTable.png": [
		"41f2",
		7,
		"chunk-2d0c08bf"
	],
	"./assets/Z/04/maintenance/footer_logo1.png": [
		"b1c5",
		7,
		"chunk-2d20f177"
	],
	"./assets/Z/04/maintenance/footer_logo2.png": [
		"7e8e",
		7,
		"chunk-2d0e23b1"
	],
	"./assets/Z/04/maintenance/footer_logo3.png": [
		"832d",
		7,
		"chunk-2d0ddba3"
	],
	"./assets/Z/04/maintenance/footer_logo4.png": [
		"7042",
		7,
		"chunk-2d0d5c0d"
	],
	"./assets/Z/04/maintenance/footer_logo5.png": [
		"0896",
		7,
		"chunk-2d0a4c1b"
	],
	"./assets/Z/04/maintenance/footer_logo6.png": [
		"52b5",
		7,
		"chunk-2d0c8066"
	],
	"./assets/Z/04/promotion/event01.jpg": [
		"a63d",
		7,
		"chunk-2d208a3c"
	],
	"./assets/Z/04/promotion/event02.jpg": [
		"ad57",
		7,
		"chunk-2d2136fb"
	],
	"./assets/Z/04/promotion/event03.jpg": [
		"b3c3",
		7,
		"chunk-2d20f8f7"
	],
	"./assets/Z/04/promotion/event04.jpg": [
		"ad91",
		7,
		"chunk-2d213771"
	],
	"./assets/Z/04/promotion/event06.jpg": [
		"140b",
		7,
		"chunk-2d0ab08b"
	],
	"./assets/Z/04/promotion/event07.jpg": [
		"3ef4",
		7,
		"chunk-2d0c5796"
	],
	"./assets/Z/04/ui/bg-maskLeft.png": [
		"dc5b",
		7,
		"chunk-2d229082"
	],
	"./assets/Z/04/ui/bg-maskRight.png": [
		"5d4a",
		7,
		"chunk-2d0d36b2"
	],
	"./assets/Z/04/ui/ddl_pager.jpg": [
		"684a",
		7,
		"chunk-2d0d05e5"
	],
	"./assets/Z/04/ui/goTOP.png": [
		"f1f2",
		7,
		"chunk-2d22c34d"
	],
	"./assets/Z/04/ui/icon-tdControl.png": [
		"6283",
		7,
		"chunk-2d0cefad"
	],
	"./assets/Z/04/ui/lnk-trans-on.png": [
		"7dbf",
		7,
		"chunk-2d0e2507"
	],
	"./assets/Z/04/ui/lnk-trans.png": [
		"1595",
		7,
		"chunk-2d0ab536"
	],
	"./assets/Z/04/ui/lnk-trans2-on.png": [
		"9a0a",
		7,
		"chunk-2d0efc6f"
	],
	"./assets/Z/04/ui/lnk-trans2.png": [
		"e364",
		7,
		"chunk-2d2250a2"
	],
	"./assets/Z/04/ui/lnk_next.png": [
		"1bdf",
		7,
		"chunk-2d0b6389"
	],
	"./assets/Z/04/ui/lnk_nextMore.png": [
		"8c37",
		7,
		"chunk-2d0e8fc5"
	],
	"./assets/Z/04/ui/lnk_previous.png": [
		"ef0e",
		7,
		"chunk-2d230f8c"
	],
	"./assets/Z/04/ui/lnk_previousMore.png": [
		"ff12",
		7,
		"chunk-2d2383d7"
	],
	"./assets/Z/04/ui/swiper-button-next.png": [
		"1455",
		7,
		"chunk-2d0ab0f9"
	],
	"./assets/Z/04/ui/swiper-button-prev.png": [
		"2c37",
		7,
		"chunk-2d0bd58b"
	],
	"./assets/Z/04/ui/ui-arrow-maskLeft.png": [
		"2bb0",
		7,
		"chunk-2d0bd774"
	],
	"./assets/Z/04/ui/ui-arrow-maskRight.png": [
		"f503",
		7,
		"chunk-2d22cbc8"
	],
	"./assets/Z/04/ui/ui-arrow-select.png": [
		"30f5",
		7,
		"chunk-2d0b90a2"
	],
	"./assets/Z/04/ui/ui-arrow.png": [
		"7869",
		7,
		"chunk-2d0d7a5a"
	],
	"./assets/Z/04/ui/ui-arrow2-select.png": [
		"a856",
		7,
		"chunk-2d2091ce"
	],
	"./assets/Z/04/ui/ui-arrowL.png": [
		"4992",
		7,
		"chunk-2d0c2154"
	],
	"./assets/Z/04/ui/ui-collapse.png": [
		"cd85",
		7,
		"chunk-2d222014"
	],
	"./assets/Z/04/ui/ui-event.png": [
		"9978",
		7,
		"chunk-2d0e66f7"
	],
	"./assets/Z/04/ui/ui-horn.png": [
		"c0d2",
		7,
		"chunk-2d216231"
	],
	"./assets/Z/04/ui/ui-lobbyLeftSmall.png": [
		"4bdf",
		7,
		"chunk-2d0cc0a6"
	],
	"./assets/Z/04/ui/ui-lobbyRightSmall.png": [
		"6f75",
		7,
		"chunk-2d0db2c4"
	],
	"./assets/Z/04/ui/ui-status.png": [
		"194d",
		7,
		"chunk-2d0ac3ce"
	],
	"./assets/Z/04/ui/ui-transfer.png": [
		"0db9",
		7,
		"chunk-2d0af641"
	],
	"./assets/Z/05/contact/mail.png": [
		"33c7",
		7,
		"chunk-2d0b9b8a"
	],
	"./assets/Z/05/contact/ui-contact.png": [
		"475e",
		7,
		"chunk-2d0c1989"
	],
	"./assets/Z/05/contact/ui-facebook.png": [
		"c90c",
		7,
		"chunk-2d217ddf"
	],
	"./assets/Z/05/contact/ui-telegram.png": [
		"d184",
		7,
		"chunk-2d21d4ff"
	],
	"./assets/Z/05/footer/footerBg.png": [
		"e13f",
		7,
		"chunk-2d2248f5"
	],
	"./assets/Z/05/footer/lnk_toolbar.png": [
		"b349",
		7,
		"chunk-2d20f34c"
	],
	"./assets/Z/05/footer/toolbarBg.jpg": [
		"d0be",
		7,
		"chunk-2d21d685"
	],
	"./assets/Z/05/footer/toolbarBgActive.jpg": [
		"c2af",
		7,
		"chunk-2d21698a"
	],
	"./assets/Z/05/footer/ui-footer-toolbar-contact.png": [
		"12d7",
		7,
		"chunk-2d0aaf2a"
	],
	"./assets/Z/05/footer/ui-footer-toolbar-event.png": [
		"a17e",
		7,
		"chunk-2d2077f4"
	],
	"./assets/Z/05/footer/ui-footer-toolbar-home.png": [
		"262e",
		7,
		"chunk-2d0b2cad"
	],
	"./assets/Z/05/footer/ui-footer-toolbar-registOrlogin.png": [
		"b5e2",
		7,
		"chunk-2d2100b6"
	],
	"./assets/Z/05/footer/ui-footer-toolbar-trading.png": [
		"a4da",
		7,
		"chunk-2d2088a6"
	],
	"./assets/Z/05/forget-password/forgetDescBg.png": [
		"7ea4",
		7,
		"chunk-2d0e2877"
	],
	"./assets/Z/05/game-lobby/1180-active.png": [
		"fe46",
		7,
		"chunk-2d238077"
	],
	"./assets/Z/05/game-lobby/1180.png": [
		"b7e5",
		7,
		"chunk-2d21083b"
	],
	"./assets/Z/05/game-lobby/1230-active.png": [
		"a3e4",
		7,
		"chunk-2d2084d7"
	],
	"./assets/Z/05/game-lobby/1230.png": [
		"5874",
		7,
		"chunk-2d0c91b6"
	],
	"./assets/Z/05/game-lobby/1240-active.png": [
		"a3f1",
		7,
		"chunk-2d2084f3"
	],
	"./assets/Z/05/game-lobby/1240.png": [
		"f65a",
		7,
		"chunk-2d22d052"
	],
	"./assets/Z/05/game-lobby/1250-active.png": [
		"b99f",
		7,
		"chunk-2d210a9a"
	],
	"./assets/Z/05/game-lobby/1250.png": [
		"6e2a",
		7,
		"chunk-2d0dae94"
	],
	"./assets/Z/05/game-lobby/1260-active.png": [
		"5486",
		7,
		"chunk-2d0c82d3"
	],
	"./assets/Z/05/game-lobby/1260.png": [
		"6df3",
		7,
		"chunk-2d0db0f1"
	],
	"./assets/Z/05/game-lobby/1270-active.png": [
		"1074",
		7,
		"chunk-2d0aa232"
	],
	"./assets/Z/05/game-lobby/1270.png": [
		"1672",
		7,
		"chunk-2d0ab8b6"
	],
	"./assets/Z/05/game-lobby/1280-active.png": [
		"9435",
		7,
		"chunk-2d0e53b3"
	],
	"./assets/Z/05/game-lobby/1280.png": [
		"ed26",
		7,
		"chunk-2d230819"
	],
	"./assets/Z/05/game-lobby/1300-active.png": [
		"6883",
		7,
		"chunk-2d0d0633"
	],
	"./assets/Z/05/game-lobby/1300.png": [
		"1771",
		7,
		"chunk-2d0abc76"
	],
	"./assets/Z/05/game-lobby/1310-active.png": [
		"411c",
		7,
		"chunk-2d0c0285"
	],
	"./assets/Z/05/game-lobby/1310.png": [
		"f42d",
		7,
		"chunk-2d22c876"
	],
	"./assets/Z/05/game-lobby/1340-active.png": [
		"e1da",
		7,
		"chunk-2d224edf"
	],
	"./assets/Z/05/game-lobby/1340.png": [
		"6fe0",
		7,
		"chunk-2d0db851"
	],
	"./assets/Z/05/game-lobby/1350-active.png": [
		"822c",
		7,
		"chunk-2d0dd7e1"
	],
	"./assets/Z/05/game-lobby/1350.png": [
		"a7bb",
		7,
		"chunk-2d2093ac"
	],
	"./assets/Z/05/game-lobby/1360-active.png": [
		"7f32",
		7,
		"chunk-2d0e26a4"
	],
	"./assets/Z/05/game-lobby/1360.png": [
		"ec7c",
		7,
		"chunk-2d230520"
	],
	"./assets/Z/05/game-lobby/1370-active.png": [
		"89ad",
		7,
		"chunk-2d0df7da"
	],
	"./assets/Z/05/game-lobby/1370.png": [
		"21e2",
		7,
		"chunk-2d0b1fe2"
	],
	"./assets/Z/05/game-lobby/1380-active.png": [
		"fee2",
		7,
		"chunk-2d238662"
	],
	"./assets/Z/05/game-lobby/1380.png": [
		"2637",
		7,
		"chunk-2d0b2c9e"
	],
	"./assets/Z/05/game-lobby/1390-active.png": [
		"4fdb",
		7,
		"chunk-2d0ccfa6"
	],
	"./assets/Z/05/game-lobby/1390.png": [
		"9396",
		7,
		"chunk-2d0e50ad"
	],
	"./assets/Z/05/game-lobby/1400-active.png": [
		"e298",
		7,
		"chunk-2d224d42"
	],
	"./assets/Z/05/game-lobby/1400.png": [
		"d8f9",
		7,
		"chunk-2d21f4dd"
	],
	"./assets/Z/05/game-lobby/1410-active.png": [
		"659e",
		7,
		"chunk-2d0cfb41"
	],
	"./assets/Z/05/game-lobby/1410.png": [
		"a204",
		7,
		"chunk-2d207aab"
	],
	"./assets/Z/05/game-lobby/1420-active.png": [
		"1086",
		7,
		"chunk-2d0aa253"
	],
	"./assets/Z/05/game-lobby/1420.png": [
		"b9fa",
		7,
		"chunk-2d211008"
	],
	"./assets/Z/05/game-lobby/1430-active.png": [
		"a633",
		7,
		"chunk-2d208a0b"
	],
	"./assets/Z/05/game-lobby/1430.png": [
		"9f82",
		7,
		"chunk-2d0f0ffd"
	],
	"./assets/Z/05/game-lobby/1440-active.png": [
		"1502",
		7,
		"chunk-2d0ab41c"
	],
	"./assets/Z/05/game-lobby/1440.png": [
		"6af5",
		7,
		"chunk-2d0da5b0"
	],
	"./assets/Z/05/game-lobby/1450-active.png": [
		"7073",
		7,
		"chunk-2d0d5c6b"
	],
	"./assets/Z/05/game-lobby/1450.png": [
		"a78c",
		7,
		"chunk-2d208e97"
	],
	"./assets/Z/05/game-lobby/1460-active.png": [
		"51f0",
		7,
		"chunk-2d0c7d1c"
	],
	"./assets/Z/05/game-lobby/1460.png": [
		"e40d",
		7,
		"chunk-2d2253d9"
	],
	"./assets/Z/05/game-lobby/1470-active.png": [
		"f4ca",
		7,
		"chunk-2d22ce62"
	],
	"./assets/Z/05/game-lobby/1470.png": [
		"7586",
		7,
		"chunk-2d0d6f52"
	],
	"./assets/Z/05/game-lobby/bg_jackpot.png": [
		"28db",
		7,
		"chunk-2d0b3a3a"
	],
	"./assets/Z/05/game-lobby/bg_lnk_inquire.png": [
		"a9fb",
		7,
		"chunk-2d209baa"
	],
	"./assets/Z/05/game-lobby/btnTrans.png": [
		"a7a5",
		7,
		"chunk-2d209360"
	],
	"./assets/Z/05/game-lobby/btn_favorites.png": [
		"bbdc",
		7,
		"chunk-2d21a9b5"
	],
	"./assets/Z/05/game-lobby/btn_favorites_active.png": [
		"5f2d",
		7,
		"chunk-2d0d3df9"
	],
	"./assets/Z/05/game-lobby/btn_freeplay.png": [
		"b37f",
		7,
		"chunk-2d20f3d6"
	],
	"./assets/Z/05/game-lobby/btn_start.png": [
		"a1fc",
		7,
		"chunk-2d207da3"
	],
	"./assets/Z/05/game-lobby/ipt_favorites.png": [
		"bcee",
		7,
		"chunk-2d21ad97"
	],
	"./assets/Z/05/game-lobby/popular.png": [
		"f603",
		7,
		"chunk-2d22cf89"
	],
	"./assets/Z/05/header/btn_home.png": [
		"b385",
		7,
		"chunk-2d20f3c4"
	],
	"./assets/Z/05/header/headerBg.png": [
		"25e4",
		7,
		"chunk-2d0b2ee8"
	],
	"./assets/Z/05/home/btn_maintain.png": [
		"4d24",
		7,
		"chunk-2d0cc1e8"
	],
	"./assets/Z/05/lottery/luckyDraw.png": [
		"3540",
		7,
		"chunk-2d0b9d54"
	],
	"./assets/Z/05/lottery/rotaryTable.png": [
		"75a6",
		7,
		"chunk-2d0d7449"
	],
	"./assets/Z/05/maintenance/footer_logo1.png": [
		"8933",
		7,
		"chunk-2d0df217"
	],
	"./assets/Z/05/maintenance/footer_logo2.png": [
		"c988",
		7,
		"chunk-2d217eac"
	],
	"./assets/Z/05/maintenance/footer_logo3.png": [
		"edce",
		7,
		"chunk-2d230e37"
	],
	"./assets/Z/05/maintenance/footer_logo4.png": [
		"23ac",
		7,
		"chunk-2d0b2719"
	],
	"./assets/Z/05/maintenance/footer_logo5.png": [
		"e763",
		7,
		"chunk-2d225fa5"
	],
	"./assets/Z/05/maintenance/footer_logo6.png": [
		"4a96",
		7,
		"chunk-2d0cb780"
	],
	"./assets/Z/05/promotion/event01.jpg": [
		"4af0",
		7,
		"chunk-2d0cbced"
	],
	"./assets/Z/05/promotion/event02.jpg": [
		"e2bc",
		7,
		"chunk-2d225264"
	],
	"./assets/Z/05/promotion/event03.jpg": [
		"5669",
		7,
		"chunk-2d0c8a1a"
	],
	"./assets/Z/05/promotion/event04.jpg": [
		"074b",
		7,
		"chunk-2d0a47eb"
	],
	"./assets/Z/05/promotion/event06.jpg": [
		"39c3e",
		7,
		"chunk-746a8fd9"
	],
	"./assets/Z/05/promotion/event07.jpg": [
		"12dd",
		7,
		"chunk-2d0aaf57"
	],
	"./assets/Z/05/ui/bg-maskLeft.png": [
		"e8c8",
		7,
		"chunk-2d2268de"
	],
	"./assets/Z/05/ui/bg-maskRight.png": [
		"fd85",
		7,
		"chunk-2d237d31"
	],
	"./assets/Z/05/ui/ddl_pager.jpg": [
		"e648",
		7,
		"chunk-2d225bab"
	],
	"./assets/Z/05/ui/goTOP.png": [
		"b3be",
		7,
		"chunk-2d20f90a"
	],
	"./assets/Z/05/ui/icon-tdControl.png": [
		"6a13",
		7,
		"chunk-2d0d9f43"
	],
	"./assets/Z/05/ui/lnk-trans-on.png": [
		"16dc",
		7,
		"chunk-2d0abe5a"
	],
	"./assets/Z/05/ui/lnk-trans.png": [
		"7476",
		7,
		"chunk-2d0d6b72"
	],
	"./assets/Z/05/ui/lnk-trans2-on.png": [
		"59d3",
		7,
		"chunk-2d0c9ae9"
	],
	"./assets/Z/05/ui/lnk-trans2.png": [
		"5e50",
		7,
		"chunk-2d0d3a61"
	],
	"./assets/Z/05/ui/lnk_next.png": [
		"e67b",
		7,
		"chunk-2d225c32"
	],
	"./assets/Z/05/ui/lnk_nextMore.png": [
		"da41",
		7,
		"chunk-2d2288b0"
	],
	"./assets/Z/05/ui/lnk_previous.png": [
		"67ca",
		7,
		"chunk-2d0d07d5"
	],
	"./assets/Z/05/ui/lnk_previousMore.png": [
		"9f4a",
		7,
		"chunk-2d0f0fb0"
	],
	"./assets/Z/05/ui/swiper-button-next.png": [
		"8043",
		7,
		"chunk-2d0dd06d"
	],
	"./assets/Z/05/ui/swiper-button-prev.png": [
		"739e",
		7,
		"chunk-2d0d681e"
	],
	"./assets/Z/05/ui/ui-arrow-maskLeft-home.png": [
		"c221",
		7,
		"chunk-2d2163a4"
	],
	"./assets/Z/05/ui/ui-arrow-maskLeft.png": [
		"fe37",
		7,
		"chunk-2d238059"
	],
	"./assets/Z/05/ui/ui-arrow-maskRight-home.png": [
		"817b",
		7,
		"chunk-2d0dd4ba"
	],
	"./assets/Z/05/ui/ui-arrow-maskRight.png": [
		"7b29",
		7,
		"chunk-2d0e1788"
	],
	"./assets/Z/05/ui/ui-arrow-select.png": [
		"4ded",
		7,
		"chunk-2d0cc845"
	],
	"./assets/Z/05/ui/ui-arrow.png": [
		"6a61",
		7,
		"chunk-2d0d9fdc"
	],
	"./assets/Z/05/ui/ui-arrow2-select.png": [
		"62df",
		7,
		"chunk-2d0cf534"
	],
	"./assets/Z/05/ui/ui-arrowL.png": [
		"cde2",
		7,
		"chunk-2d222584"
	],
	"./assets/Z/05/ui/ui-collapse.png": [
		"2b0b",
		7,
		"chunk-2d0bd198"
	],
	"./assets/Z/05/ui/ui-event.png": [
		"2e04",
		7,
		"chunk-2d0bdcad"
	],
	"./assets/Z/05/ui/ui-horn.png": [
		"d1c0",
		7,
		"chunk-2d21da30"
	],
	"./assets/Z/05/ui/ui-lobbyLeftSmall.png": [
		"8fdb",
		7,
		"chunk-2d0ea122"
	],
	"./assets/Z/05/ui/ui-lobbyRightSmall.png": [
		"acec",
		7,
		"chunk-2d213936"
	],
	"./assets/Z/05/ui/ui-status.png": [
		"ae4f",
		7,
		"chunk-2d213acc"
	],
	"./assets/Z/05/ui/ui-transfer.png": [
		"3216",
		7,
		"chunk-2d0b91ba"
	],
	"./assets/common/about/gameIntro-01.jpg": [
		"e346",
		7,
		"chunk-2d225066"
	],
	"./assets/common/about/gameIntro-02.jpg": [
		"8921",
		7,
		"chunk-2d0df1f6"
	],
	"./assets/common/about/gameIntro-03.jpg": [
		"6824",
		7,
		"chunk-2d0d057a"
	],
	"./assets/common/banner/banner16.jpg": [
		"1862",
		7,
		"chunk-2d0ac019"
	],
	"./assets/common/banner/banner17.jpg": [
		"904b",
		7,
		"chunk-2d0e44fb"
	],
	"./assets/common/banner/banner18.jpg": [
		"d8b9",
		7,
		"chunk-2d21f461"
	],
	"./assets/common/header/headerBg.png": [
		"2adb",
		7,
		"chunk-2d0bd423"
	],
	"./assets/common/lang/lang_en-us.png": [
		"e8fe",
		7,
		"chunk-2d226968"
	],
	"./assets/common/lang/lang_en-us_s.png": [
		"45c8",
		7,
		"chunk-2d0c176c"
	],
	"./assets/common/lang/lang_my-mm.png": [
		"5ec6",
		7,
		"chunk-2d0d3ff9"
	],
	"./assets/common/lang/lang_my-mm_s.png": [
		"66cc",
		7,
		"chunk-2d0d0416"
	],
	"./assets/common/lang/lang_th-th.png": [
		"ca85",
		7,
		"chunk-2d2214d1"
	],
	"./assets/common/lang/lang_th-th_s.png": [
		"1bf8",
		7,
		"chunk-2d0b6399"
	],
	"./assets/common/lang/lang_zh-cn.png": [
		"d79b",
		7,
		"chunk-2d21ebd2"
	],
	"./assets/common/lang/lang_zh-cn_s.png": [
		"c46a",
		7,
		"chunk-2d216bd2"
	],
	"./assets/common/lang/lang_zh-tw.png": [
		"8a4d",
		7,
		"chunk-2d0e888f"
	],
	"./assets/common/lang/lang_zh-tw_s.png": [
		"7605",
		7,
		"chunk-2d0d721a"
	],
	"./assets/common/lottery/loading.svg": [
		"5fdf",
		7,
		"chunk-2d0d4409"
	],
	"./assets/common/lottery/redEnvelope/bg-winPrize.png": [
		"02ba",
		7,
		"chunk-2d0a3ab7"
	],
	"./assets/common/lottery/redEnvelope/bg.jpg": [
		"4e34",
		7,
		"chunk-2d0cc5c8"
	],
	"./assets/common/lottery/redEnvelope/eclipse.svg": [
		"6320",
		7,
		"chunk-2d0cf2b1"
	],
	"./assets/common/lottery/redEnvelope/landscape/bg-en-us.png": [
		"c453",
		7,
		"chunk-2d216b85"
	],
	"./assets/common/lottery/redEnvelope/landscape/bg-my-mm.png": [
		"5633",
		7,
		"chunk-2d0c89b7"
	],
	"./assets/common/lottery/redEnvelope/landscape/bg-th-th.png": [
		"e3e5",
		7,
		"chunk-2d225654"
	],
	"./assets/common/lottery/redEnvelope/landscape/bg-zh-cn.png": [
		"9fc8",
		7,
		"chunk-2d0f1538"
	],
	"./assets/common/lottery/redEnvelope/landscape/bg-zh-tw.png": [
		"2ba0",
		7,
		"chunk-2d0bd755"
	],
	"./assets/common/lottery/redEnvelope/landscape/bg.png": [
		"3bcc",
		7,
		"chunk-2d0c4c25"
	],
	"./assets/common/lottery/redEnvelope/landscape/prize-01.png": [
		"1cad",
		7,
		"chunk-2d0b66eb"
	],
	"./assets/common/lottery/redEnvelope/landscape/title.png": [
		"b492",
		7,
		"chunk-2d20f7a1"
	],
	"./assets/common/lottery/redEnvelope/lucky--close1.png": [
		"37a9",
		7,
		"chunk-2d0baa52"
	],
	"./assets/common/lottery/redEnvelope/lucky--open3.png": [
		"e97b",
		7,
		"chunk-2d226775"
	],
	"./assets/common/lottery/winWheel/container-bg.png": [
		"a28d",
		7,
		"chunk-2d207bd3"
	],
	"./assets/common/lottery/winWheel/landscape/prize.png": [
		"fabc",
		7,
		"chunk-2d237732"
	],
	"./assets/common/lottery/winWheel/landscape/win-wheel-bg--.png": [
		"6512",
		7,
		"chunk-2d0cfa16"
	],
	"./assets/common/lottery/winWheel/landscape/win-wheel-bg.png": [
		"1051",
		7,
		"chunk-2d0aa1f1"
	],
	"./assets/common/lottery/winWheel/landscape/win-wheel-pointer.png": [
		"175c",
		7,
		"chunk-2d0abc6a"
	],
	"./assets/common/lottery/winWheel/pointercn.png": [
		"08a2",
		7,
		"chunk-2d0a50ef"
	],
	"./assets/common/lottery/winWheel/prize-2.png": [
		"d2a0",
		7,
		"chunk-2d21ddb3"
	],
	"./assets/common/lottery/winWheel/prize.png": [
		"45d4e",
		7,
		"chunk-7476d9be"
	],
	"./assets/common/lottery/winWheel/wheel-bg.png": [
		"93c7",
		7,
		"chunk-2d0e55c4"
	],
	"./assets/common/lottery/winWheel/wheel-loading.svg": [
		"de33",
		7,
		"chunk-2d229797"
	],
	"./assets/common/maintenance/footer_logo1.png": [
		"249f",
		7,
		"chunk-2d0b2605"
	],
	"./assets/common/maintenance/footer_logo2.png": [
		"b3c5",
		7,
		"chunk-2d20f8f9"
	],
	"./assets/common/maintenance/footer_logo3.png": [
		"c6c3",
		7,
		"chunk-2d217899"
	],
	"./assets/common/maintenance/footer_logo4.png": [
		"964c",
		7,
		"chunk-2d0e5b82"
	],
	"./assets/common/maintenance/footer_logo5.png": [
		"26b0",
		7,
		"chunk-2d0b3248"
	],
	"./assets/common/maintenance/footer_logo6.png": [
		"bac5",
		7,
		"chunk-2d21a5a7"
	],
	"./assets/common/modal/modal-bg--black-sm.png": [
		"72e2",
		7,
		"chunk-2d0d697e"
	],
	"./assets/common/sign-in/cm_login_3.png": [
		"d731",
		7,
		"chunk-2d21eae7"
	],
	"./assets/common/ui/loading-2.gif": [
		"d7ae",
		7,
		"chunk-2d21f0ad"
	],
	"./assets/common/ui/loading.gif": [
		"a615",
		7,
		"chunk-2d2089cf"
	],
	"./assets/common/ui/luckyDrawIcn.png": [
		"2665",
		7,
		"chunk-2d0b2cf9"
	],
	"./assets/common/ui/prizeBg.png": [
		"f295",
		7,
		"chunk-2d22c19e"
	],
	"./assets/common/ui/prizeIcn.png": [
		"e2c2",
		7,
		"chunk-2d225252"
	],
	"./assets/common/ui/ui-arrow-left--yellow.png": [
		"5e74",
		7,
		"chunk-2d0d3aa3"
	],
	"./assets/common/ui/ui-success--auth.png": [
		"9d0d",
		7,
		"chunk-2d0f07b5"
	],
	"./assets/common/ui/ui-tick.png": [
		"38db",
		7,
		"chunk-2d0bae99"
	],
	"./assets/common/ui/ui-warn--auth.png": [
		"79ac",
		7,
		"chunk-2d0d837a"
	],
	"./assets/common/ui/ui-warning--red.png": [
		"3536",
		7,
		"chunk-2d0b9d3b"
	],
	"./assets/common/ui/warning-icon.png": [
		"270a",
		7,
		"chunk-2d0b302c"
	],
	"./components/AppGoTopButton": [
		"099e",
		9,
		"chunk-2d0a500b"
	],
	"./components/AppGoTopButton.vue": [
		"099e",
		9,
		"chunk-2d0a500b"
	],
	"./components/AppLoading": [
		"29e5",
		9,
		"chunk-55b51bd6"
	],
	"./components/AppLoading.vue": [
		"29e5",
		9,
		"chunk-55b51bd6"
	],
	"./components/AppModal": [
		"41df",
		9,
		"chunk-0e664f8c"
	],
	"./components/AppModal.vue": [
		"41df",
		9,
		"chunk-0e664f8c"
	],
	"./components/AppPagination": [
		"55b1",
		9,
		"chunk-2d0c8ba5"
	],
	"./components/AppPagination.vue": [
		"55b1",
		9,
		"chunk-2d0c8ba5"
	],
	"./components/Iframe": [
		"9bbf",
		9,
		"chunk-9e192d9e"
	],
	"./components/Iframe.vue": [
		"9bbf",
		9,
		"chunk-9e192d9e"
	],
	"./components/ModalAlertSmall": [
		"6f07",
		9,
		"chunk-e11cf418"
	],
	"./components/ModalAlertSmall.vue": [
		"6f07",
		9,
		"chunk-e11cf418"
	],
	"./components/ModalDepositThirdParty": [
		"6426",
		9,
		"chunk-d0cf9884"
	],
	"./components/ModalDepositThirdParty.vue": [
		"6426",
		9,
		"chunk-d0cf9884"
	],
	"./components/ModalMessage": [
		"0014",
		9,
		"chunk-90b4d02c"
	],
	"./components/ModalMessage.vue": [
		"0014",
		9,
		"chunk-90b4d02c"
	],
	"./components/ModalMessageApkDownload": [
		"b7c2",
		9,
		"chunk-013fd85e"
	],
	"./components/ModalMessageApkDownload.vue": [
		"b7c2",
		9,
		"chunk-013fd85e"
	],
	"./components/ModalMessageC": [
		"cff4",
		9,
		"chunk-1a8f752a"
	],
	"./components/ModalMessageC.vue": [
		"cff4",
		9,
		"chunk-1a8f752a"
	],
	"./components/ModalMessageSiteBlocked": [
		"8e16",
		9,
		"chunk-09be1e6c"
	],
	"./components/ModalMessageSiteBlocked.vue": [
		"8e16",
		9,
		"chunk-09be1e6c"
	],
	"./components/ModalNoticeImage": [
		"f3bc",
		9,
		"chunk-2867e112"
	],
	"./components/ModalNoticeImage.vue": [
		"f3bc",
		9,
		"chunk-2867e112"
	],
	"./components/PA/ModalAlert": [
		"59fe",
		9,
		"chunk-2d0c9b59"
	],
	"./components/PA/ModalAlert.vue": [
		"59fe",
		9,
		"chunk-2d0c9b59"
	],
	"./components/PA/ModalConfirm": [
		"bf45",
		9,
		"chunk-2d21b2bb"
	],
	"./components/PA/ModalConfirm.vue": [
		"bf45",
		9,
		"chunk-2d21b2bb"
	],
	"./components/PA/ModalContact": [
		"ecf3",
		9,
		"chunk-249e77a5"
	],
	"./components/PA/ModalContact.vue": [
		"ecf3",
		9,
		"chunk-249e77a5"
	],
	"./components/PA/ModalNoticeList": [
		"8359",
		9,
		"chunk-2d0ddbd5"
	],
	"./components/PA/ModalNoticeList.vue": [
		"8359",
		9,
		"chunk-2d0ddbd5"
	],
	"./components/PA/ModalRedEnvelope": [
		"ad80",
		9,
		"chunk-5813c888"
	],
	"./components/PA/ModalRedEnvelope.vue": [
		"ad80",
		9,
		"chunk-5813c888"
	],
	"./components/PA/ModalServiceTerm": [
		"46ed",
		9,
		"chunk-16010944"
	],
	"./components/PA/ModalServiceTerm.vue": [
		"46ed",
		9,
		"chunk-16010944"
	],
	"./components/PA/ModalTransfer": [
		"3904",
		9,
		"chunk-3d4210a4"
	],
	"./components/PA/ModalTransfer.vue": [
		"3904",
		9,
		"chunk-3d4210a4"
	],
	"./components/PA/ModalWinWheel": [
		"14a9",
		9,
		"chunk-5a55aed5"
	],
	"./components/PA/ModalWinWheel.vue": [
		"14a9",
		9,
		"chunk-5a55aed5"
	],
	"./components/PA/PanelTabs": [
		"9929",
		9,
		"chunk-2d0e665d"
	],
	"./components/PA/PanelTabs.vue": [
		"9929",
		9,
		"chunk-2d0e665d"
	],
	"./components/PA/about/About": [
		"d373",
		9,
		"chunk-764fadf2"
	],
	"./components/PA/about/About.vue": [
		"d373",
		9,
		"chunk-764fadf2"
	],
	"./components/PA/game/GameCategoryNavigation": [
		"59a4",
		9,
		"chunk-4a6f3d04"
	],
	"./components/PA/game/GameCategoryNavigation.vue": [
		"59a4",
		9,
		"chunk-4a6f3d04"
	],
	"./components/PA/game/GameHome": [
		"4f14",
		9,
		"chunk-2d0cc94b"
	],
	"./components/PA/game/GameHome.vue": [
		"4f14",
		9,
		"chunk-2d0cc94b"
	],
	"./components/PA/game/GameListIcon": [
		"d07b",
		9,
		"chunk-5e637a60"
	],
	"./components/PA/game/GameListIcon.vue": [
		"d07b",
		9,
		"chunk-5e637a60"
	],
	"./components/PA/game/GameLobby": [
		"c478",
		9,
		"chunk-e448fea4"
	],
	"./components/PA/game/GameLobby.vue": [
		"c478",
		9,
		"chunk-e448fea4"
	],
	"./components/PA/game/GameProductNavigation": [
		"942d",
		9,
		"chunk-7fd00bf0"
	],
	"./components/PA/game/GameProductNavigation.vue": [
		"942d",
		9,
		"chunk-7fd00bf0"
	],
	"./components/PA/game/GameSearchBlock": [
		"b244",
		9,
		"chunk-21fc38ea"
	],
	"./components/PA/game/GameSearchBlock.vue": [
		"b244",
		9,
		"chunk-21fc38ea"
	],
	"./components/PA/header/AppHeader": [
		"4e80",
		9,
		"chunk-25ee3307"
	],
	"./components/PA/header/AppHeader.vue": [
		"4e80",
		9,
		"chunk-25ee3307"
	],
	"./components/PA/header/ModalAuth": [
		"976c",
		9,
		"chunk-2d0e5f81"
	],
	"./components/PA/header/ModalAuth.vue": [
		"976c",
		9,
		"chunk-2d0e5f81"
	],
	"./components/PA/header/ModalLang": [
		"df59",
		9,
		"chunk-46ce4902"
	],
	"./components/PA/header/ModalLang.vue": [
		"df59",
		9,
		"chunk-46ce4902"
	],
	"./components/PA/header/ModalLogin": [
		"86ca",
		9,
		"chunk-02dd64fd"
	],
	"./components/PA/header/ModalLogin.vue": [
		"86ca",
		9,
		"chunk-02dd64fd"
	],
	"./components/PA/header/ModalRegister": [
		"311d",
		9,
		"chunk-40650414"
	],
	"./components/PA/header/ModalRegister.vue": [
		"311d",
		9,
		"chunk-40650414"
	],
	"./components/PA/home/Home": [
		"8dd0",
		9,
		"chunk-bb70f186"
	],
	"./components/PA/home/Home.vue": [
		"8dd0",
		9,
		"chunk-bb70f186"
	],
	"./components/PA/home/HomeFooter": [
		"12f6",
		9,
		"chunk-88ddd270"
	],
	"./components/PA/home/HomeFooter.vue": [
		"12f6",
		9,
		"chunk-88ddd270"
	],
	"./components/PA/home/HomeProductBlock": [
		"0bf9",
		9,
		"chunk-6d597c30"
	],
	"./components/PA/home/HomeProductBlock.vue": [
		"0bf9",
		9,
		"chunk-6d597c30"
	],
	"./components/PA/login/Login": [
		"547f",
		9,
		"chunk-2d0c82e4"
	],
	"./components/PA/login/Login.vue": [
		"547f",
		9,
		"chunk-2d0c82e4"
	],
	"./components/PA/news/News": [
		"2797",
		9,
		"chunk-9c5b6708"
	],
	"./components/PA/news/News.vue": [
		"2797",
		9,
		"chunk-9c5b6708"
	],
	"./components/PA/promotion/Promotion": [
		"500e",
		9,
		"chunk-86466e30"
	],
	"./components/PA/promotion/Promotion.vue": [
		"500e",
		9,
		"chunk-86466e30"
	],
	"./components/PA/promotion/PromotionDetail": [
		"45f1",
		9,
		"chunk-94dc6e7a"
	],
	"./components/PA/promotion/PromotionDetail.vue": [
		"45f1",
		9,
		"chunk-94dc6e7a"
	],
	"./components/PA/transaction/TransactionHome": [
		"89aa",
		9,
		"chunk-2d0df7d7"
	],
	"./components/PA/transaction/TransactionHome.vue": [
		"89aa",
		9,
		"chunk-2d0df7d7"
	],
	"./components/PA/transaction/TransactionTransfer": [
		"8584",
		9,
		"chunk-1ac2b0d4"
	],
	"./components/PA/transaction/TransactionTransfer.vue": [
		"8584",
		9,
		"chunk-1ac2b0d4"
	],
	"./components/PA/transaction/TransactionWallet": [
		"bcf3",
		9,
		"chunk-3544495e"
	],
	"./components/PA/transaction/TransactionWallet.vue": [
		"bcf3",
		9,
		"chunk-3544495e"
	],
	"./components/PA/transaction/TransactionWithdrawal": [
		"a294",
		9,
		"chunk-109ccc56"
	],
	"./components/PA/transaction/TransactionWithdrawal.vue": [
		"a294",
		9,
		"chunk-109ccc56"
	],
	"./components/PA/transaction/deposit/TransactionDepositAutoCash": [
		"5cc8",
		9,
		"chunk-958a83d0"
	],
	"./components/PA/transaction/deposit/TransactionDepositAutoCash.vue": [
		"5cc8",
		9,
		"chunk-958a83d0"
	],
	"./components/PA/transaction/deposit/TransactionDepositBase": [
		"e9e7",
		9,
		"chunk-67ba4ce9"
	],
	"./components/PA/transaction/deposit/TransactionDepositBase.vue": [
		"e9e7",
		9,
		"chunk-67ba4ce9"
	],
	"./components/PA/transaction/deposit/TransactionDepositHome": [
		"6ca2",
		9,
		"chunk-0a5a89f5"
	],
	"./components/PA/transaction/deposit/TransactionDepositHome.vue": [
		"6ca2",
		9,
		"chunk-0a5a89f5"
	],
	"./components/PA/transaction/deposit/TransactionDepositThirdParty": [
		"965c",
		9,
		"chunk-e77c536a"
	],
	"./components/PA/transaction/deposit/TransactionDepositThirdParty.vue": [
		"965c",
		9,
		"chunk-e77c536a"
	],
	"./components/PA/transaction/record/TransactionRecordAdjustment": [
		"10a7",
		9,
		"chunk-2674743e"
	],
	"./components/PA/transaction/record/TransactionRecordAdjustment.vue": [
		"10a7",
		9,
		"chunk-2674743e"
	],
	"./components/PA/transaction/record/TransactionRecordBonus": [
		"284b",
		9,
		"chunk-d6869472"
	],
	"./components/PA/transaction/record/TransactionRecordBonus.vue": [
		"284b",
		9,
		"chunk-d6869472"
	],
	"./components/PA/transaction/record/TransactionRecordDeposit": [
		"5456",
		9,
		"chunk-bbc02d62"
	],
	"./components/PA/transaction/record/TransactionRecordDeposit.vue": [
		"5456",
		9,
		"chunk-bbc02d62"
	],
	"./components/PA/transaction/record/TransactionRecordLottery": [
		"091f",
		9,
		"chunk-52418f78"
	],
	"./components/PA/transaction/record/TransactionRecordLottery.vue": [
		"091f",
		9,
		"chunk-52418f78"
	],
	"./components/PA/transaction/record/TransactionRecordTransfer": [
		"0575",
		9,
		"chunk-1214d06c"
	],
	"./components/PA/transaction/record/TransactionRecordTransfer.vue": [
		"0575",
		9,
		"chunk-1214d06c"
	],
	"./components/PA/transaction/record/TransactionRecordWithdrawal": [
		"dde6",
		9,
		"chunk-77430eda"
	],
	"./components/PA/transaction/record/TransactionRecordWithdrawal.vue": [
		"dde6",
		9,
		"chunk-77430eda"
	],
	"./components/PA/transaction/record/TransactionRecordWithdrawalRestriction": [
		"22a2",
		9,
		"chunk-48898b54"
	],
	"./components/PA/transaction/record/TransactionRecordWithdrawalRestriction.vue": [
		"22a2",
		9,
		"chunk-48898b54"
	],
	"./components/PA/user/ModalUserBank": [
		"f279",
		9,
		"chunk-4a4bf127"
	],
	"./components/PA/user/ModalUserBank.vue": [
		"f279",
		9,
		"chunk-4a4bf127"
	],
	"./components/PA/user/ModalUserChangePassword": [
		"e870",
		9,
		"chunk-e9bde5aa"
	],
	"./components/PA/user/ModalUserChangePassword.vue": [
		"e870",
		9,
		"chunk-e9bde5aa"
	],
	"./components/PA/user/ModalUserChangePasswordWithdrawal": [
		"3d83",
		9,
		"chunk-ab320748"
	],
	"./components/PA/user/ModalUserChangePasswordWithdrawal.vue": [
		"3d83",
		9,
		"chunk-ab320748"
	],
	"./components/PA/user/ModalUserMailDetail": [
		"65d4",
		9,
		"chunk-215d26e9"
	],
	"./components/PA/user/ModalUserMailDetail.vue": [
		"65d4",
		9,
		"chunk-215d26e9"
	],
	"./components/PA/user/UserHome": [
		"fa9e",
		9,
		"chunk-2d23723d"
	],
	"./components/PA/user/UserHome.vue": [
		"fa9e",
		9,
		"chunk-2d23723d"
	],
	"./components/PA/user/UserMail": [
		"ec60",
		9,
		"chunk-77a35fd4"
	],
	"./components/PA/user/UserMail.vue": [
		"ec60",
		9,
		"chunk-77a35fd4"
	],
	"./components/PA/user/UserMailSend": [
		"49f2",
		9,
		"chunk-483c5b84"
	],
	"./components/PA/user/UserMailSend.vue": [
		"49f2",
		9,
		"chunk-483c5b84"
	],
	"./components/PA/user/UserProfile": [
		"4ae9",
		9,
		"chunk-4cfa2c58"
	],
	"./components/PA/user/UserProfile.vue": [
		"4ae9",
		9,
		"chunk-4cfa2c58"
	],
	"./components/PA/user/UserPromotionMGM": [
		"5ac6",
		9,
		"chunk-f9a7b732"
	],
	"./components/PA/user/UserPromotionMGM.vue": [
		"5ac6",
		9,
		"chunk-f9a7b732"
	],
	"./components/PA/user/UserPromotionMGMBonus": [
		"0367",
		9,
		"chunk-aef09558"
	],
	"./components/PA/user/UserPromotionMGMBonus.vue": [
		"0367",
		9,
		"chunk-aef09558"
	],
	"./components/PA/user/UserPromotionMGMDetail": [
		"86c1",
		9,
		"chunk-76e76db4"
	],
	"./components/PA/user/UserPromotionMGMDetail.vue": [
		"86c1",
		9,
		"chunk-76e76db4"
	],
	"./components/PreviewButton": [
		"f666",
		9,
		"chunk-7547a381"
	],
	"./components/PreviewButton.vue": [
		"f666",
		9,
		"chunk-7547a381"
	],
	"./components/Z/AppLotteryButtonBlock": [
		"75fb",
		9,
		"chunk-2d0d7510"
	],
	"./components/Z/AppLotteryButtonBlock.vue": [
		"75fb",
		9,
		"chunk-2d0d7510"
	],
	"./components/Z/AppNavTab": [
		"4c8b",
		9,
		"chunk-2714be3c"
	],
	"./components/Z/AppNavTab.vue": [
		"4c8b",
		9,
		"chunk-2714be3c"
	],
	"./components/Z/DepositThirdPartyReturn": [
		"b5e8",
		9,
		"chunk-2d2100bc"
	],
	"./components/Z/DepositThirdPartyReturn.vue": [
		"b5e8",
		9,
		"chunk-2d2100bc"
	],
	"./components/Z/ModalAlert": [
		"6908",
		9,
		"chunk-3ec7a8ba"
	],
	"./components/Z/ModalAlert.vue": [
		"6908",
		9,
		"chunk-3ec7a8ba"
	],
	"./components/Z/ModalRedEnvelope": [
		"efd0",
		9,
		"chunk-c0d58e14"
	],
	"./components/Z/ModalRedEnvelope.vue": [
		"efd0",
		9,
		"chunk-c0d58e14"
	],
	"./components/Z/ModalServiceTerm": [
		"ccc5",
		9,
		"chunk-2d222188"
	],
	"./components/Z/ModalServiceTerm.vue": [
		"ccc5",
		9,
		"chunk-2d222188"
	],
	"./components/Z/ModalTransfer": [
		"1376",
		9,
		"chunk-3393aef6"
	],
	"./components/Z/ModalTransfer.vue": [
		"1376",
		9,
		"chunk-3393aef6"
	],
	"./components/Z/ModalWinWheel": [
		"5f47",
		9,
		"chunk-43e44498"
	],
	"./components/Z/ModalWinWheel.vue": [
		"5f47",
		9,
		"chunk-43e44498"
	],
	"./components/Z/about/About": [
		"8fb2",
		9,
		"chunk-1de54d82"
	],
	"./components/Z/about/About.vue": [
		"8fb2",
		9,
		"chunk-1de54d82"
	],
	"./components/Z/contact/Contact": [
		"98f3",
		9,
		"chunk-5f66d1b3"
	],
	"./components/Z/contact/Contact.vue": [
		"98f3",
		9,
		"chunk-5f66d1b3"
	],
	"./components/Z/footer/AppFooter": [
		"6728",
		9,
		"chunk-2d0d01bd"
	],
	"./components/Z/footer/AppFooter.vue": [
		"6728",
		9,
		"chunk-2d0d01bd"
	],
	"./components/Z/footer/AppFooterNav": [
		"5be5",
		9,
		"chunk-2d0d34f3"
	],
	"./components/Z/footer/AppFooterNav.vue": [
		"5be5",
		9,
		"chunk-2d0d34f3"
	],
	"./components/Z/forget-password/ForgetPassword": [
		"4864",
		9,
		"chunk-2d0c1d38"
	],
	"./components/Z/forget-password/ForgetPassword.vue": [
		"4864",
		9,
		"chunk-2d0c1d38"
	],
	"./components/Z/forget-password/ModalForgetPassword": [
		"b787",
		9,
		"chunk-b19103fc"
	],
	"./components/Z/forget-password/ModalForgetPassword.vue": [
		"b787",
		9,
		"chunk-b19103fc"
	],
	"./components/Z/forget-password/ModalForgetPasswordChange": [
		"f093",
		9,
		"chunk-36799518"
	],
	"./components/Z/forget-password/ModalForgetPasswordChange.vue": [
		"f093",
		9,
		"chunk-36799518"
	],
	"./components/Z/forget-password/ModalForgetPasswordEmail": [
		"f833",
		9,
		"chunk-0bc07d92"
	],
	"./components/Z/forget-password/ModalForgetPasswordEmail.vue": [
		"f833",
		9,
		"chunk-0bc07d92"
	],
	"./components/Z/forget-password/ModalForgetPasswordMobile": [
		"08d7",
		9,
		"chunk-15f5ad3f"
	],
	"./components/Z/forget-password/ModalForgetPasswordMobile.vue": [
		"08d7",
		9,
		"chunk-15f5ad3f"
	],
	"./components/Z/game/GameCategoryNavigation": [
		"652a",
		9,
		"chunk-660d5007"
	],
	"./components/Z/game/GameCategoryNavigation.vue": [
		"652a",
		9,
		"chunk-660d5007"
	],
	"./components/Z/game/GameHome": [
		"9e8b",
		9,
		"chunk-2d0f0c6c"
	],
	"./components/Z/game/GameHome.vue": [
		"9e8b",
		9,
		"chunk-2d0f0c6c"
	],
	"./components/Z/game/GameJackpot": [
		"326d",
		9,
		"chunk-2d0b9283"
	],
	"./components/Z/game/GameJackpot.vue": [
		"326d",
		9,
		"chunk-2d0b9283"
	],
	"./components/Z/game/GameListIcon": [
		"4d19",
		9,
		"chunk-062d6520"
	],
	"./components/Z/game/GameListIcon.vue": [
		"4d19",
		9,
		"chunk-062d6520"
	],
	"./components/Z/game/GameListTable": [
		"64df",
		9,
		"chunk-2d0cfcb6"
	],
	"./components/Z/game/GameListTable.vue": [
		"64df",
		9,
		"chunk-2d0cfcb6"
	],
	"./components/Z/game/GameLobby": [
		"e9e6",
		9,
		"chunk-0bac3a41"
	],
	"./components/Z/game/GameLobby.vue": [
		"e9e6",
		9,
		"chunk-0bac3a41"
	],
	"./components/Z/game/GameProductNavigation": [
		"1a2b",
		9,
		"chunk-0d54b7df"
	],
	"./components/Z/game/GameProductNavigation.vue": [
		"1a2b",
		9,
		"chunk-0d54b7df"
	],
	"./components/Z/game/GameSearchBlock": [
		"8a5c",
		9,
		"chunk-2d0e88ad"
	],
	"./components/Z/game/GameSearchBlock.vue": [
		"8a5c",
		9,
		"chunk-2d0e88ad"
	],
	"./components/Z/game/GameTransferDialog": [
		"3414",
		9,
		"chunk-40817c88"
	],
	"./components/Z/game/GameTransferDialog.vue": [
		"3414",
		9,
		"chunk-40817c88"
	],
	"./components/Z/game/LiveGameEnterDialog": [
		"03d1",
		9,
		"chunk-2d0a3e86"
	],
	"./components/Z/game/LiveGameEnterDialog.vue": [
		"03d1",
		9,
		"chunk-2d0a3e86"
	],
	"./components/Z/header/AppHeader": [
		"3824",
		9,
		"chunk-171d6a1c"
	],
	"./components/Z/header/AppHeader.vue": [
		"3824",
		9,
		"chunk-171d6a1c"
	],
	"./components/Z/header/AppHeaderMenu": [
		"04a2",
		9,
		"chunk-2ae587da"
	],
	"./components/Z/header/AppHeaderMenu.vue": [
		"04a2",
		9,
		"chunk-2ae587da"
	],
	"./components/Z/header/AppHeaderSub": [
		"990a",
		9,
		"chunk-3986242e"
	],
	"./components/Z/header/AppHeaderSub.vue": [
		"990a",
		9,
		"chunk-3986242e"
	],
	"./components/Z/home/Home": [
		"d3a1",
		9,
		"chunk-2d21e175"
	],
	"./components/Z/home/Home.vue": [
		"d3a1",
		9,
		"chunk-2d21e175"
	],
	"./components/Z/home/HomeBanner": [
		"bdd5",
		9,
		"chunk-0b56a327"
	],
	"./components/Z/home/HomeBanner.vue": [
		"bdd5",
		9,
		"chunk-0b56a327"
	],
	"./components/Z/home/HomeNewsMarquee": [
		"e1bf",
		9,
		"chunk-1a58fa5f"
	],
	"./components/Z/home/HomeNewsMarquee.vue": [
		"e1bf",
		9,
		"chunk-1a58fa5f"
	],
	"./components/Z/home/HomeProductBlock": [
		"c429",
		9,
		"chunk-6c4ca3d6"
	],
	"./components/Z/home/HomeProductBlock.vue": [
		"c429",
		9,
		"chunk-6c4ca3d6"
	],
	"./components/Z/home/HomeProductNav": [
		"a0e0",
		9,
		"chunk-7c666c5b"
	],
	"./components/Z/home/HomeProductNav.vue": [
		"a0e0",
		9,
		"chunk-7c666c5b"
	],
	"./components/Z/login/Login": [
		"0565",
		9,
		"chunk-13e346a5"
	],
	"./components/Z/login/Login.vue": [
		"0565",
		9,
		"chunk-13e346a5"
	],
	"./components/Z/maintenance/Maintenance": [
		"a9c8",
		9,
		"chunk-35a1d423"
	],
	"./components/Z/maintenance/Maintenance.vue": [
		"a9c8",
		9,
		"chunk-35a1d423"
	],
	"./components/Z/news/News": [
		"987e",
		9,
		"chunk-0622061c"
	],
	"./components/Z/news/News.vue": [
		"987e",
		9,
		"chunk-0622061c"
	],
	"./components/Z/promotion/Promotion": [
		"3eec",
		9,
		"chunk-fbb25f56"
	],
	"./components/Z/promotion/Promotion.vue": [
		"3eec",
		9,
		"chunk-fbb25f56"
	],
	"./components/Z/promotion/PromotionDetail": [
		"d3c1",
		9,
		"chunk-011de39c"
	],
	"./components/Z/promotion/PromotionDetail.vue": [
		"d3c1",
		9,
		"chunk-011de39c"
	],
	"./components/Z/promotion/PromotionNavTab": [
		"ca2b",
		9,
		"chunk-527d6227"
	],
	"./components/Z/promotion/PromotionNavTab.vue": [
		"ca2b",
		9,
		"chunk-527d6227"
	],
	"./components/Z/register/Register": [
		"3ad1",
		9,
		"chunk-3afb6cf1"
	],
	"./components/Z/register/Register.vue": [
		"3ad1",
		9,
		"chunk-3afb6cf1"
	],
	"./components/Z/transaction/TransactionHome": [
		"e069",
		9,
		"chunk-2d224564"
	],
	"./components/Z/transaction/TransactionHome.vue": [
		"e069",
		9,
		"chunk-2d224564"
	],
	"./components/Z/transaction/TransactionTransfer": [
		"d6bd6",
		9,
		"chunk-b09c010a"
	],
	"./components/Z/transaction/TransactionTransfer.vue": [
		"d6bd6",
		9,
		"chunk-b09c010a"
	],
	"./components/Z/transaction/TransactionWithdrawal": [
		"932f",
		9,
		"chunk-75a6a22d"
	],
	"./components/Z/transaction/TransactionWithdrawal.vue": [
		"932f",
		9,
		"chunk-75a6a22d"
	],
	"./components/Z/transaction/deposit/ModalAutoCashAlert": [
		"dce52",
		9,
		"chunk-325b1d4a"
	],
	"./components/Z/transaction/deposit/ModalAutoCashAlert.vue": [
		"dce52",
		9,
		"chunk-325b1d4a"
	],
	"./components/Z/transaction/deposit/TransactionDepositAutoCash": [
		"1b49",
		9,
		"chunk-d1a1f0ec"
	],
	"./components/Z/transaction/deposit/TransactionDepositAutoCash.vue": [
		"1b49",
		9,
		"chunk-d1a1f0ec"
	],
	"./components/Z/transaction/deposit/TransactionDepositBase": [
		"832b",
		9,
		"chunk-c1fb91fa"
	],
	"./components/Z/transaction/deposit/TransactionDepositBase.vue": [
		"832b",
		9,
		"chunk-c1fb91fa"
	],
	"./components/Z/transaction/deposit/TransactionDepositHome": [
		"4835",
		9,
		"chunk-d9417f86"
	],
	"./components/Z/transaction/deposit/TransactionDepositHome.vue": [
		"4835",
		9,
		"chunk-d9417f86"
	],
	"./components/Z/transaction/deposit/TransactionDepositThirdParty": [
		"59cf",
		9,
		"chunk-d32454d0"
	],
	"./components/Z/transaction/deposit/TransactionDepositThirdParty.vue": [
		"59cf",
		9,
		"chunk-d32454d0"
	],
	"./components/Z/transaction/record/RecordImageDialog": [
		"2352",
		9,
		"chunk-2d0b2194"
	],
	"./components/Z/transaction/record/RecordImageDialog.vue": [
		"2352",
		9,
		"chunk-2d0b2194"
	],
	"./components/Z/transaction/record/TransactionRecordAdjustment": [
		"497e",
		9,
		"chunk-e9855fba"
	],
	"./components/Z/transaction/record/TransactionRecordAdjustment.vue": [
		"497e",
		9,
		"chunk-e9855fba"
	],
	"./components/Z/transaction/record/TransactionRecordBetDay": [
		"6712",
		9,
		"chunk-649bc718"
	],
	"./components/Z/transaction/record/TransactionRecordBetDay.vue": [
		"6712",
		9,
		"chunk-649bc718"
	],
	"./components/Z/transaction/record/TransactionRecordBetHome": [
		"2c1f",
		9,
		"chunk-2d0bd57c"
	],
	"./components/Z/transaction/record/TransactionRecordBetHome.vue": [
		"2c1f",
		9,
		"chunk-2d0bd57c"
	],
	"./components/Z/transaction/record/TransactionRecordBetUnsettle": [
		"d87c",
		9,
		"chunk-d2594f64"
	],
	"./components/Z/transaction/record/TransactionRecordBetUnsettle.vue": [
		"d87c",
		9,
		"chunk-d2594f64"
	],
	"./components/Z/transaction/record/TransactionRecordBetWeek": [
		"bd9b",
		9,
		"chunk-4c31fc07"
	],
	"./components/Z/transaction/record/TransactionRecordBetWeek.vue": [
		"bd9b",
		9,
		"chunk-4c31fc07"
	],
	"./components/Z/transaction/record/TransactionRecordBonus": [
		"dc7d",
		9,
		"chunk-79a61e6f"
	],
	"./components/Z/transaction/record/TransactionRecordBonus.vue": [
		"dc7d",
		9,
		"chunk-79a61e6f"
	],
	"./components/Z/transaction/record/TransactionRecordDeposit": [
		"f7c1",
		9,
		"chunk-06631b20"
	],
	"./components/Z/transaction/record/TransactionRecordDeposit.vue": [
		"f7c1",
		9,
		"chunk-06631b20"
	],
	"./components/Z/transaction/record/TransactionRecordHome": [
		"d13b",
		9,
		"chunk-2d21d492"
	],
	"./components/Z/transaction/record/TransactionRecordHome.vue": [
		"d13b",
		9,
		"chunk-2d21d492"
	],
	"./components/Z/transaction/record/TransactionRecordLottery": [
		"a3ac",
		9,
		"chunk-e0d2017c"
	],
	"./components/Z/transaction/record/TransactionRecordLottery.vue": [
		"a3ac",
		9,
		"chunk-e0d2017c"
	],
	"./components/Z/transaction/record/TransactionRecordTransfer": [
		"7660",
		9,
		"chunk-baa61a58"
	],
	"./components/Z/transaction/record/TransactionRecordTransfer.vue": [
		"7660",
		9,
		"chunk-baa61a58"
	],
	"./components/Z/transaction/record/TransactionRecordWithdrawal": [
		"d01d",
		9,
		"chunk-fa78a47e"
	],
	"./components/Z/transaction/record/TransactionRecordWithdrawal.vue": [
		"d01d",
		9,
		"chunk-fa78a47e"
	],
	"./components/Z/transaction/record/TransactionRecordWithdrawalRestriction": [
		"8691",
		9,
		"chunk-43e47f51"
	],
	"./components/Z/transaction/record/TransactionRecordWithdrawalRestriction.vue": [
		"8691",
		9,
		"chunk-43e47f51"
	],
	"./components/Z/user/ModalUserProfileAuth": [
		"e8ff",
		9,
		"chunk-75fbe4c3"
	],
	"./components/Z/user/ModalUserProfileAuth.vue": [
		"e8ff",
		9,
		"chunk-75fbe4c3"
	],
	"./components/Z/user/UserChangePassword": [
		"8169",
		9,
		"chunk-2b016ce1"
	],
	"./components/Z/user/UserChangePassword.vue": [
		"8169",
		9,
		"chunk-2b016ce1"
	],
	"./components/Z/user/UserChangePasswordWithdrawal": [
		"a95c",
		9,
		"chunk-e8d4976a"
	],
	"./components/Z/user/UserChangePasswordWithdrawal.vue": [
		"a95c",
		9,
		"chunk-e8d4976a"
	],
	"./components/Z/user/UserHome": [
		"e7e9",
		9,
		"chunk-2d22655c"
	],
	"./components/Z/user/UserHome.vue": [
		"e7e9",
		9,
		"chunk-2d22655c"
	],
	"./components/Z/user/UserMail": [
		"efa6",
		9,
		"chunk-495c7278"
	],
	"./components/Z/user/UserMail.vue": [
		"efa6",
		9,
		"chunk-495c7278"
	],
	"./components/Z/user/UserMailDetail": [
		"2289",
		9,
		"chunk-644bfe5b"
	],
	"./components/Z/user/UserMailDetail.vue": [
		"2289",
		9,
		"chunk-644bfe5b"
	],
	"./components/Z/user/UserMailSend": [
		"12a1",
		9,
		"chunk-16bd3fab"
	],
	"./components/Z/user/UserMailSend.vue": [
		"12a1",
		9,
		"chunk-16bd3fab"
	],
	"./components/Z/user/UserProfile": [
		"ffb6",
		9,
		"chunk-13cfbace"
	],
	"./components/Z/user/UserProfile.vue": [
		"ffb6",
		9,
		"chunk-13cfbace"
	],
	"./components/Z/user/UserPromotionMGM": [
		"a8dc",
		9,
		"chunk-44e14fe0"
	],
	"./components/Z/user/UserPromotionMGM.vue": [
		"a8dc",
		9,
		"chunk-44e14fe0"
	],
	"./components/Z/user/UserPromotionMGMBonus": [
		"4589",
		9,
		"chunk-3691f2d6"
	],
	"./components/Z/user/UserPromotionMGMBonus.vue": [
		"4589",
		9,
		"chunk-3691f2d6"
	],
	"./components/Z/user/UserPromotionMGMDetail": [
		"565d",
		9,
		"chunk-453103bc"
	],
	"./components/Z/user/UserPromotionMGMDetail.vue": [
		"565d",
		9,
		"chunk-453103bc"
	],
	"./components/layout/BlankLayout": [
		"a1e1",
		9,
		"chunk-2d207d52"
	],
	"./components/layout/BlankLayout.vue": [
		"a1e1",
		9,
		"chunk-2d207d52"
	],
	"./components/lottery/RedEnvelope": [
		"022d",
		9,
		"chunk-2f3005e0"
	],
	"./components/lottery/RedEnvelope.vue": [
		"022d",
		9,
		"chunk-2f3005e0"
	],
	"./components/lottery/RedEnvelopeLandscape": [
		"9795",
		9,
		"chunk-7aab13dd"
	],
	"./components/lottery/RedEnvelopeLandscape.vue": [
		"9795",
		9,
		"chunk-7aab13dd"
	],
	"./components/lottery/WinWheel": [
		"b902",
		9,
		"chunk-2d222d54",
		"chunk-2d0f04ba",
		"chunk-65dea9e2"
	],
	"./components/lottery/WinWheel.vue": [
		"b902",
		9,
		"chunk-2d222d54",
		"chunk-2d0f04ba",
		"chunk-65dea9e2"
	],
	"./components/lottery/WinWheelLandscape": [
		"5bbc",
		9,
		"chunk-2d222d54",
		"chunk-2d0f04ba",
		"chunk-fc690040"
	],
	"./components/lottery/WinWheelLandscape.vue": [
		"5bbc",
		9,
		"chunk-2d222d54",
		"chunk-2d0f04ba",
		"chunk-fc690040"
	],
	"./i18n-lazy": [
		"3b2b",
		9
	],
	"./i18n-lazy.js": [
		"3b2b",
		9
	],
	"./idMapper": [
		"69ea",
		3
	],
	"./idMapper.json": [
		"69ea",
		3
	],
	"./locales/en-us": [
		"e3b5",
		3,
		"chunk-2d2255f7"
	],
	"./locales/en-us.json": [
		"e3b5",
		3,
		"chunk-2d2255f7"
	],
	"./locales/my-mm": [
		"2546",
		3,
		"chunk-2d0b28fb"
	],
	"./locales/my-mm.json": [
		"2546",
		3,
		"chunk-2d0b28fb"
	],
	"./locales/th-th": [
		"2c2c",
		3,
		"chunk-2d0bd598"
	],
	"./locales/th-th.json": [
		"2c2c",
		3,
		"chunk-2d0bd598"
	],
	"./locales/zh-cn": [
		"2c61",
		3,
		"chunk-2d0bd5e2"
	],
	"./locales/zh-cn.json": [
		"2c61",
		3,
		"chunk-2d0bd5e2"
	],
	"./locales/zh-tw": [
		"cb6e",
		3,
		"chunk-2d221884"
	],
	"./locales/zh-tw.json": [
		"cb6e",
		3,
		"chunk-2d221884"
	],
	"./main": [
		"56d7",
		9
	],
	"./main.js": [
		"56d7",
		9
	],
	"./mixins/_authCaptcha": [
		"df10",
		9,
		"chunk-126736ba"
	],
	"./mixins/_authCaptcha.js": [
		"df10",
		9,
		"chunk-126736ba"
	],
	"./mixins/_copyText": [
		"b9ef",
		9,
		"chunk-2d210fee"
	],
	"./mixins/_copyText.js": [
		"b9ef",
		9,
		"chunk-2d210fee"
	],
	"./mixins/_countdown": [
		"f90b",
		9,
		"chunk-2d22dafb"
	],
	"./mixins/_countdown.js": [
		"f90b",
		9,
		"chunk-2d22dafb"
	],
	"./mixins/_linkUrl": [
		"9f5c",
		9,
		"chunk-b20f115c"
	],
	"./mixins/_linkUrl.js": [
		"9f5c",
		9,
		"chunk-b20f115c"
	],
	"./mixins/_preloadImage": [
		"0bbe",
		9
	],
	"./mixins/_preloadImage.js": [
		"0bbe",
		9
	],
	"./mixins/_productLinkHandler": [
		"0213",
		9,
		"chunk-2d0a349a"
	],
	"./mixins/_productLinkHandler.js": [
		"0213",
		9,
		"chunk-2d0a349a"
	],
	"./mixins/_scrollArrow": [
		"e430",
		9,
		"chunk-2d225402"
	],
	"./mixins/_scrollArrow.js": [
		"e430",
		9,
		"chunk-2d225402"
	],
	"./mixins/_scrollField": [
		"71a7",
		9,
		"chunk-2d0d6546"
	],
	"./mixins/_scrollField.js": [
		"71a7",
		9,
		"chunk-2d0d6546"
	],
	"./mixins/_styleLoader": [
		"d228",
		9
	],
	"./mixins/_styleLoader.js": [
		"d228",
		9
	],
	"./mixins/accountWallet": [
		"cf85",
		9,
		"chunk-8a888ea8"
	],
	"./mixins/accountWallet.js": [
		"cf85",
		9,
		"chunk-8a888ea8"
	],
	"./mixins/banner": [
		"bc89",
		9,
		"chunk-d3dfe862"
	],
	"./mixins/banner.js": [
		"bc89",
		9,
		"chunk-d3dfe862"
	],
	"./mixins/checkField": [
		"ed69",
		9,
		"chunk-02682b0c"
	],
	"./mixins/checkField.js": [
		"ed69",
		9,
		"chunk-02682b0c"
	],
	"./mixins/contact": [
		"3130",
		9,
		"chunk-482c299a"
	],
	"./mixins/contact.js": [
		"3130",
		9,
		"chunk-482c299a"
	],
	"./mixins/forgetPasswordChange": [
		"562a",
		9,
		"chunk-3994c1c7"
	],
	"./mixins/forgetPasswordChange.js": [
		"562a",
		9,
		"chunk-3994c1c7"
	],
	"./mixins/forgetPasswordEmail": [
		"8785",
		9,
		"chunk-257ca691"
	],
	"./mixins/forgetPasswordEmail.js": [
		"8785",
		9,
		"chunk-257ca691"
	],
	"./mixins/forgetPasswordMobile": [
		"ed1d",
		9,
		"chunk-32baeff2"
	],
	"./mixins/forgetPasswordMobile.js": [
		"ed1d",
		9,
		"chunk-32baeff2"
	],
	"./mixins/gameLobby": [
		"b7b1",
		9,
		"chunk-5b92cfef"
	],
	"./mixins/gameLobby.js": [
		"b7b1",
		9,
		"chunk-5b92cfef"
	],
	"./mixins/gameOpen": [
		"23df",
		9,
		"chunk-2d0b2779"
	],
	"./mixins/gameOpen.js": [
		"23df",
		9,
		"chunk-2d0b2779"
	],
	"./mixins/lang": [
		"6126",
		9,
		"chunk-2d0ceb35"
	],
	"./mixins/lang.js": [
		"6126",
		9,
		"chunk-2d0ceb35"
	],
	"./mixins/login": [
		"5489",
		9,
		"chunk-008364f4"
	],
	"./mixins/login.js": [
		"5489",
		9,
		"chunk-008364f4"
	],
	"./mixins/lotteryRedEnvelope": [
		"cd52",
		9,
		"chunk-5c64e66a"
	],
	"./mixins/lotteryRedEnvelope.js": [
		"cd52",
		9,
		"chunk-5c64e66a"
	],
	"./mixins/lotteryWinWheel": [
		"f6e1",
		9,
		"chunk-5c6379ee"
	],
	"./mixins/lotteryWinWheel.js": [
		"f6e1",
		9,
		"chunk-5c6379ee"
	],
	"./mixins/messageC": [
		"843e",
		9,
		"chunk-296cbbc7"
	],
	"./mixins/messageC.js": [
		"843e",
		9,
		"chunk-296cbbc7"
	],
	"./mixins/messageNewsMarquee": [
		"9ae6",
		9,
		"chunk-296ddef2"
	],
	"./mixins/messageNewsMarquee.js": [
		"9ae6",
		9,
		"chunk-296ddef2"
	],
	"./mixins/modalTransfer": [
		"a311",
		9,
		"chunk-31683217"
	],
	"./mixins/modalTransfer.js": [
		"a311",
		9,
		"chunk-31683217"
	],
	"./mixins/news": [
		"8a31",
		9,
		"chunk-f06c2be8"
	],
	"./mixins/news.js": [
		"8a31",
		9,
		"chunk-f06c2be8"
	],
	"./mixins/pagination": [
		"1b80",
		9,
		"chunk-2d0b5dff"
	],
	"./mixins/pagination.js": [
		"1b80",
		9,
		"chunk-2d0b5dff"
	],
	"./mixins/promotion": [
		"1754",
		9,
		"chunk-d40dbfdc"
	],
	"./mixins/promotion.js": [
		"1754",
		9,
		"chunk-d40dbfdc"
	],
	"./mixins/promotionDetail": [
		"d5de",
		9,
		"chunk-2d21e988"
	],
	"./mixins/promotionDetail.js": [
		"d5de",
		9,
		"chunk-2d21e988"
	],
	"./mixins/pwa": [
		"910f",
		9
	],
	"./mixins/pwa.js": [
		"910f",
		9
	],
	"./mixins/register": [
		"92ce",
		9,
		"chunk-4f8d8b58"
	],
	"./mixins/register.js": [
		"92ce",
		9,
		"chunk-4f8d8b58"
	],
	"./mixins/transactionDepositAutoCash": [
		"b137",
		9,
		"chunk-44129728"
	],
	"./mixins/transactionDepositAutoCash.js": [
		"b137",
		9,
		"chunk-44129728"
	],
	"./mixins/transactionDepositBase": [
		"2498",
		9,
		"chunk-43fcd156"
	],
	"./mixins/transactionDepositBase.js": [
		"2498",
		9,
		"chunk-43fcd156"
	],
	"./mixins/transactionDepositHome": [
		"e8df",
		9,
		"chunk-441414aa"
	],
	"./mixins/transactionDepositHome.js": [
		"e8df",
		9,
		"chunk-441414aa"
	],
	"./mixins/transactionDepositThirdParty": [
		"8d11",
		9,
		"chunk-04b7ff63"
	],
	"./mixins/transactionDepositThirdParty.js": [
		"8d11",
		9,
		"chunk-04b7ff63"
	],
	"./mixins/transactionRecordAdjustment": [
		"0738",
		9,
		"chunk-55da43e3"
	],
	"./mixins/transactionRecordAdjustment.js": [
		"0738",
		9,
		"chunk-55da43e3"
	],
	"./mixins/transactionRecordBetDay": [
		"b343",
		9,
		"chunk-0e2971c9"
	],
	"./mixins/transactionRecordBetDay.js": [
		"b343",
		9,
		"chunk-0e2971c9"
	],
	"./mixins/transactionRecordBetUnsettle": [
		"2604",
		9,
		"chunk-0e13aac1"
	],
	"./mixins/transactionRecordBetUnsettle.js": [
		"2604",
		9,
		"chunk-0e13aac1"
	],
	"./mixins/transactionRecordBetWeek": [
		"bcb7",
		9,
		"chunk-0e2a2b8f"
	],
	"./mixins/transactionRecordBetWeek.js": [
		"bcb7",
		9,
		"chunk-0e2a2b8f"
	],
	"./mixins/transactionRecordBonus": [
		"fef8",
		9,
		"chunk-55f382c8"
	],
	"./mixins/transactionRecordBonus.js": [
		"fef8",
		9,
		"chunk-55f382c8"
	],
	"./mixins/transactionRecordDeposit": [
		"4fc9",
		9,
		"chunk-07613607"
	],
	"./mixins/transactionRecordDeposit.js": [
		"4fc9",
		9,
		"chunk-07613607"
	],
	"./mixins/transactionRecordDepositDetail": [
		"a782",
		9,
		"chunk-0774f50f"
	],
	"./mixins/transactionRecordDepositDetail.js": [
		"a782",
		9,
		"chunk-0774f50f"
	],
	"./mixins/transactionRecordLottery": [
		"c263",
		9,
		"chunk-55f16063"
	],
	"./mixins/transactionRecordLottery.js": [
		"c263",
		9,
		"chunk-55f16063"
	],
	"./mixins/transactionRecordTransfer": [
		"5cd9",
		9,
		"chunk-55dd34da"
	],
	"./mixins/transactionRecordTransfer.js": [
		"5cd9",
		9,
		"chunk-55dd34da"
	],
	"./mixins/transactionRecordTransferDetail": [
		"27c4",
		9,
		"chunk-075f9cd5"
	],
	"./mixins/transactionRecordTransferDetail.js": [
		"27c4",
		9,
		"chunk-075f9cd5"
	],
	"./mixins/transactionRecordWithdrawal": [
		"6590",
		9,
		"chunk-076161b5"
	],
	"./mixins/transactionRecordWithdrawal.js": [
		"6590",
		9,
		"chunk-076161b5"
	],
	"./mixins/transactionRecordWithdrawalDetail": [
		"27ff",
		9,
		"chunk-075f9d64"
	],
	"./mixins/transactionRecordWithdrawalDetail.js": [
		"27ff",
		9,
		"chunk-075f9d64"
	],
	"./mixins/transactionRecordWithdrawalRestriction": [
		"0af2",
		9,
		"chunk-55dae7b4"
	],
	"./mixins/transactionRecordWithdrawalRestriction.js": [
		"0af2",
		9,
		"chunk-55dae7b4"
	],
	"./mixins/transactionRecordWithdrawalRestrictionDetail": [
		"efa8",
		9,
		"chunk-07777bf7"
	],
	"./mixins/transactionRecordWithdrawalRestrictionDetail.js": [
		"efa8",
		9,
		"chunk-07777bf7"
	],
	"./mixins/transactionTransfer": [
		"1658",
		9,
		"chunk-2d0ab87e"
	],
	"./mixins/transactionTransfer.js": [
		"1658",
		9,
		"chunk-2d0ab87e"
	],
	"./mixins/transactionWithdrawal": [
		"3f80",
		9,
		"chunk-0b22295d"
	],
	"./mixins/transactionWithdrawal.js": [
		"3f80",
		9,
		"chunk-0b22295d"
	],
	"./mixins/userChangePassword": [
		"a153",
		9,
		"chunk-2d207784"
	],
	"./mixins/userChangePassword.js": [
		"a153",
		9,
		"chunk-2d207784"
	],
	"./mixins/userChangePasswordWithdrawal": [
		"3431",
		9,
		"chunk-2d0b9975"
	],
	"./mixins/userChangePasswordWithdrawal.js": [
		"3431",
		9,
		"chunk-2d0b9975"
	],
	"./mixins/userMail": [
		"3306",
		9,
		"chunk-2ed2d632"
	],
	"./mixins/userMail.js": [
		"3306",
		9,
		"chunk-2ed2d632"
	],
	"./mixins/userMailDetail": [
		"a636",
		9,
		"chunk-1478f1a6"
	],
	"./mixins/userMailDetail.js": [
		"a636",
		9,
		"chunk-1478f1a6"
	],
	"./mixins/userMailSend": [
		"be1f",
		9,
		"chunk-1476a826"
	],
	"./mixins/userMailSend.js": [
		"be1f",
		9,
		"chunk-1476a826"
	],
	"./mixins/userProfile": [
		"daa0",
		9,
		"chunk-5219746b"
	],
	"./mixins/userProfile.js": [
		"daa0",
		9,
		"chunk-5219746b"
	],
	"./mixins/userPromotionMGM": [
		"b17e",
		9,
		"chunk-2d20ec53"
	],
	"./mixins/userPromotionMGM.js": [
		"b17e",
		9,
		"chunk-2d20ec53"
	],
	"./mixins/userPromotionMGMBonus": [
		"3c54",
		9,
		"chunk-2d0c4a25"
	],
	"./mixins/userPromotionMGMBonus.js": [
		"3c54",
		9,
		"chunk-2d0c4a25"
	],
	"./mixins/userPromotionMGMDetail": [
		"8a66",
		9,
		"chunk-2d0e889f"
	],
	"./mixins/userPromotionMGMDetail.js": [
		"8a66",
		9,
		"chunk-2d0e889f"
	],
	"./registerServiceWorker": [
		"ddb8",
		9
	],
	"./registerServiceWorker.js": [
		"ddb8",
		9
	],
	"./router": [
		"a18c",
		9
	],
	"./router/": [
		"a18c",
		9
	],
	"./router/index": [
		"a18c",
		9
	],
	"./router/index.js": [
		"a18c",
		9
	],
	"./router/permission": [
		"3530",
		9
	],
	"./router/permission.js": [
		"3530",
		9
	],
	"./setting/PA": [
		"f76f",
		3,
		"chunk-2d22d437"
	],
	"./setting/PA.json": [
		"f76f",
		3,
		"chunk-2d22d437"
	],
	"./setting/Y": [
		"bb6e",
		3,
		"chunk-2d21a425"
	],
	"./setting/Y.json": [
		"bb6e",
		3,
		"chunk-2d21a425"
	],
	"./setting/Z": [
		"b8a2",
		3,
		"chunk-2d210b7d"
	],
	"./setting/Z.json": [
		"b8a2",
		3,
		"chunk-2d210b7d"
	],
	"./settings": [
		"83d6",
		9
	],
	"./settings.js": [
		"83d6",
		9
	],
	"./store": [
		"4360",
		9
	],
	"./store/": [
		"4360",
		9
	],
	"./store/getters": [
		"94d5",
		9
	],
	"./store/getters.js": [
		"94d5",
		9
	],
	"./store/index": [
		"4360",
		9
	],
	"./store/index.js": [
		"4360",
		9
	],
	"./store/modules/product": [
		"c2ff",
		9
	],
	"./store/modules/product.js": [
		"c2ff",
		9
	],
	"./store/modules/pwa": [
		"d1c6",
		9
	],
	"./store/modules/pwa.js": [
		"d1c6",
		9
	],
	"./store/modules/site": [
		"2469",
		9
	],
	"./store/modules/site.js": [
		"2469",
		9
	],
	"./store/modules/user": [
		"0f9a",
		9
	],
	"./store/modules/user.js": [
		"0f9a",
		9
	],
	"./styles/PA/01/_abstracts.scss": [
		"811e",
		7
	],
	"./styles/PA/01/_layout.scss": [
		"5338",
		7,
		"chunk-74835106"
	],
	"./styles/PA/01/about.scss": [
		"3dde",
		7,
		"chunk-747e2597"
	],
	"./styles/PA/01/contact.scss": [
		"e9a0",
		7,
		"chunk-772b1f26"
	],
	"./styles/PA/01/footer.scss": [
		"9678",
		7,
		"chunk-74bd1b2b"
	],
	"./styles/PA/01/forget-password.scss": [
		"465e",
		7,
		"chunk-7476a397"
	],
	"./styles/PA/01/game.scss": [
		"d416",
		7,
		"chunk-771a0e54"
	],
	"./styles/PA/01/header.scss": [
		"7cbb",
		7,
		"chunk-74b6075d"
	],
	"./styles/PA/01/home.scss": [
		"7189",
		7,
		"chunk-749eaa2e"
	],
	"./styles/PA/01/login.scss": [
		"2f67",
		7,
		"chunk-74704494"
	],
	"./styles/PA/01/maintenance.scss": [
		"acd4",
		7,
		"chunk-7705e477"
	],
	"./styles/PA/01/news.scss": [
		"8f37",
		7,
		"chunk-74c4c657"
	],
	"./styles/PA/01/pagination.scss": [
		"0dfe",
		7,
		"chunk-7453e696"
	],
	"./styles/PA/01/promotion.scss": [
		"fccf",
		7,
		"chunk-774c5c49"
	],
	"./styles/PA/01/register.scss": [
		"2d92",
		7,
		"chunk-746f667e"
	],
	"./styles/PA/01/transaction-deposit.scss": [
		"5b22",
		7,
		"chunk-7498a9fc"
	],
	"./styles/PA/01/transaction-record.scss": [
		"a499",
		7,
		"chunk-76efe636"
	],
	"./styles/PA/01/transaction-transfer.scss": [
		"528c",
		7,
		"chunk-7482f4a1"
	],
	"./styles/PA/01/transaction-wallet.scss": [
		"5b18",
		7,
		"chunk-7498a6f5"
	],
	"./styles/PA/01/transaction-withdrawal.scss": [
		"7372",
		7,
		"chunk-749f8e52"
	],
	"./styles/PA/01/transaction.scss": [
		"6882",
		7,
		"chunk-7493c06d"
	],
	"./styles/PA/01/user.scss": [
		"18cb",
		7,
		"chunk-744df223"
	],
	"./styles/PA/_default/_abstracts.scss": [
		"f23c",
		7
	],
	"./styles/PA/_default/_functions.scss": [
		"eaa4",
		7,
		"chunk-773d4e7a"
	],
	"./styles/PA/_default/_mixins.scss": [
		"dfbc",
		7,
		"chunk-77318646"
	],
	"./styles/PA/_default/about.scss": [
		"de55",
		7,
		"chunk-77306368"
	],
	"./styles/PA/_default/contact.scss": [
		"35a7",
		7,
		"chunk-7468b751"
	],
	"./styles/PA/_default/footer.scss": [
		"0328",
		7,
		"chunk-743cd7c0"
	],
	"./styles/PA/_default/forget-password.scss": [
		"dce5",
		7,
		"chunk-77302eda"
	],
	"./styles/PA/_default/game.scss": [
		"85ca",
		7,
		"chunk-74af396e"
	],
	"./styles/PA/_default/header.scss": [
		"fe56",
		7,
		"chunk-774c9289"
	],
	"./styles/PA/_default/home.scss": [
		"d577",
		7,
		"chunk-771a9958"
	],
	"./styles/PA/_default/login.scss": [
		"2368",
		7,
		"chunk-745915c6"
	],
	"./styles/PA/_default/maintenance.scss": [
		"6088",
		7,
		"chunk-74901e2f"
	],
	"./styles/PA/_default/news.scss": [
		"ae33",
		7,
		"chunk-77061525"
	],
	"./styles/PA/_default/pagination.scss": [
		"c959",
		7,
		"chunk-770e4c0f"
	],
	"./styles/PA/_default/promotion.scss": [
		"5a88",
		7,
		"chunk-74984cdd"
	],
	"./styles/PA/_default/register.scss": [
		"d618",
		7,
		"chunk-771af750"
	],
	"./styles/PA/_default/transaction-deposit.scss": [
		"f8e4",
		7,
		"chunk-7738d1c8"
	],
	"./styles/PA/_default/transaction-record.scss": [
		"f591",
		7,
		"chunk-7736cf22"
	],
	"./styles/PA/_default/transaction-transfer.scss": [
		"92f2",
		7,
		"chunk-74bbf964"
	],
	"./styles/PA/_default/transaction-wallet.scss": [
		"66dc",
		7,
		"chunk-749382ca"
	],
	"./styles/PA/_default/transaction-withdrawal.scss": [
		"d2af",
		7,
		"chunk-7719df96"
	],
	"./styles/PA/_default/transaction.scss": [
		"3066",
		7,
		"chunk-7465cfec"
	],
	"./styles/PA/_default/user.scss": [
		"dde3",
		7,
		"chunk-7730a2fb"
	],
	"./styles/Z/01/_abstracts.scss": [
		"a29c",
		7
	],
	"./styles/Z/01/_layout.scss": [
		"8edf",
		7,
		"chunk-74c50f9a"
	],
	"./styles/Z/01/about.scss": [
		"d666",
		7,
		"chunk-771b09d7"
	],
	"./styles/Z/01/contact.scss": [
		"d311",
		7,
		"chunk-7719995a"
	],
	"./styles/Z/01/footer.scss": [
		"4671",
		7,
		"chunk-7476a4cd"
	],
	"./styles/Z/01/forget-password.scss": [
		"3864",
		7,
		"chunk-746972a6"
	],
	"./styles/Z/01/game.scss": [
		"1986",
		7,
		"chunk-744dbfc3"
	],
	"./styles/Z/01/header.scss": [
		"dcd4",
		7,
		"chunk-77302afa"
	],
	"./styles/Z/01/home.scss": [
		"6a18",
		7,
		"chunk-74a64a17"
	],
	"./styles/Z/01/login.scss": [
		"6772",
		7,
		"chunk-7493484d"
	],
	"./styles/Z/01/maintenance.scss": [
		"020e",
		7,
		"chunk-743c6152"
	],
	"./styles/Z/01/news.scss": [
		"a7a6",
		7,
		"chunk-76f1d91e"
	],
	"./styles/Z/01/pagination.scss": [
		"6021",
		7,
		"chunk-749006d0"
	],
	"./styles/Z/01/promotion.scss": [
		"b46e",
		7,
		"chunk-76fdf7c8"
	],
	"./styles/Z/01/register.scss": [
		"c505",
		7,
		"chunk-770c6752"
	],
	"./styles/Z/01/transaction-deposit.scss": [
		"d032",
		7,
		"chunk-771843de"
	],
	"./styles/Z/01/transaction-record.scss": [
		"1e73",
		7,
		"chunk-7461bbf9"
	],
	"./styles/Z/01/transaction-transfer.scss": [
		"efa0",
		7,
		"chunk-773f93d9"
	],
	"./styles/Z/01/transaction-withdrawal.scss": [
		"a9d7",
		7,
		"chunk-76f2cd3e"
	],
	"./styles/Z/01/transaction.scss": [
		"8222",
		7,
		"chunk-74ad1eaf"
	],
	"./styles/Z/01/user.scss": [
		"bc71",
		7,
		"chunk-771352ae"
	],
	"./styles/Z/02/_abstracts.scss": [
		"68aa",
		7
	],
	"./styles/Z/02/_layout.scss": [
		"aa5c",
		7,
		"chunk-770450fb"
	],
	"./styles/Z/02/about.scss": [
		"95e2",
		7,
		"chunk-74bd52c0"
	],
	"./styles/Z/02/contact.scss": [
		"bc13",
		7,
		"chunk-77133c66"
	],
	"./styles/Z/02/footer.scss": [
		"405a",
		7,
		"chunk-7473e8e1"
	],
	"./styles/Z/02/forget-password.scss": [
		"e212",
		7,
		"chunk-77273c9b"
	],
	"./styles/Z/02/game.scss": [
		"d0e3",
		7,
		"chunk-7718ffaf"
	],
	"./styles/Z/02/header.scss": [
		"1c4c",
		7,
		"chunk-7460cdc8"
	],
	"./styles/Z/02/home.scss": [
		"c6e2",
		7,
		"chunk-770da249"
	],
	"./styles/Z/02/login.scss": [
		"a144",
		7,
		"chunk-76ee75b9"
	],
	"./styles/Z/02/maintenance.scss": [
		"914f",
		7,
		"chunk-74bacf9f"
	],
	"./styles/Z/02/news.scss": [
		"5f2c",
		7,
		"chunk-749a8167"
	],
	"./styles/Z/02/pagination.scss": [
		"1490",
		7,
		"chunk-744b7cef"
	],
	"./styles/Z/02/promotion.scss": [
		"6a1c",
		7,
		"chunk-74a64f4c"
	],
	"./styles/Z/02/register.scss": [
		"6291",
		7,
		"chunk-749109d5"
	],
	"./styles/Z/02/transaction-deposit.scss": [
		"2e3c",
		7,
		"chunk-746fca46"
	],
	"./styles/Z/02/transaction-record.scss": [
		"646b",
		7,
		"chunk-7491ed3f"
	],
	"./styles/Z/02/transaction-transfer.scss": [
		"90d5",
		7,
		"chunk-74bb0981"
	],
	"./styles/Z/02/transaction-withdrawal.scss": [
		"449e",
		7,
		"chunk-7475c9dd"
	],
	"./styles/Z/02/transaction.scss": [
		"0b50",
		7,
		"chunk-74523f7c"
	],
	"./styles/Z/02/user.scss": [
		"c74b",
		7,
		"chunk-770d6487"
	],
	"./styles/Z/03/_abstracts.scss": [
		"a7ad",
		7
	],
	"./styles/Z/03/_layout.scss": [
		"87f4",
		7,
		"chunk-74b027fc"
	],
	"./styles/Z/03/about.scss": [
		"3452",
		7,
		"chunk-74679d2b"
	],
	"./styles/Z/03/contact.scss": [
		"dd19",
		7,
		"chunk-772fe081"
	],
	"./styles/Z/03/footer.scss": [
		"63f0",
		7,
		"chunk-74922702"
	],
	"./styles/Z/03/forget-password.scss": [
		"8156",
		7,
		"chunk-74acb60f"
	],
	"./styles/Z/03/game.scss": [
		"96df",
		7,
		"chunk-74bdc9aa"
	],
	"./styles/Z/03/header.scss": [
		"f042",
		7,
		"chunk-773476a1"
	],
	"./styles/Z/03/home.scss": [
		"954e",
		7,
		"chunk-74bca0fc"
	],
	"./styles/Z/03/login.scss": [
		"060a",
		7,
		"chunk-743e3252"
	],
	"./styles/Z/03/maintenance.scss": [
		"4efb",
		7,
		"chunk-748cb89c"
	],
	"./styles/Z/03/news.scss": [
		"d40b",
		7,
		"chunk-771a0fe7"
	],
	"./styles/Z/03/pagination.scss": [
		"b698",
		7,
		"chunk-76fee656"
	],
	"./styles/Z/03/promotion.scss": [
		"298d",
		7,
		"chunk-745bdcd6"
	],
	"./styles/Z/03/register.scss": [
		"92d5",
		7,
		"chunk-74bbf23f"
	],
	"./styles/Z/03/transaction-deposit.scss": [
		"6916",
		7,
		"chunk-74941b01"
	],
	"./styles/Z/03/transaction-record.scss": [
		"7ae0",
		7,
		"chunk-74b523d4"
	],
	"./styles/Z/03/transaction-transfer.scss": [
		"ca94",
		7,
		"chunk-77208950"
	],
	"./styles/Z/03/transaction-withdrawal.scss": [
		"68c3",
		7,
		"chunk-749461f7"
	],
	"./styles/Z/03/transaction.scss": [
		"97f5",
		7,
		"chunk-74be3f9c"
	],
	"./styles/Z/03/user.scss": [
		"7ebc",
		7,
		"chunk-74b6f03a"
	],
	"./styles/Z/04/_abstracts.scss": [
		"efb3",
		7
	],
	"./styles/Z/04/_layout.scss": [
		"6db3",
		7,
		"chunk-74a85e8a"
	],
	"./styles/Z/04/about.scss": [
		"93b7",
		7,
		"chunk-74bc5f5a"
	],
	"./styles/Z/04/contact.scss": [
		"2457",
		7,
		"chunk-74598645"
	],
	"./styles/Z/04/footer.scss": [
		"f530",
		7,
		"chunk-7736b87d"
	],
	"./styles/Z/04/forget-password.scss": [
		"19a6",
		7,
		"chunk-744e59ac"
	],
	"./styles/Z/04/game.scss": [
		"3c44",
		7,
		"chunk-747cf719"
	],
	"./styles/Z/04/header.scss": [
		"4381",
		7,
		"chunk-74754b71"
	],
	"./styles/Z/04/home.scss": [
		"5794",
		7,
		"chunk-7485388c"
	],
	"./styles/Z/04/login.scss": [
		"d003",
		7,
		"chunk-771838ba"
	],
	"./styles/Z/04/maintenance.scss": [
		"73e5",
		7,
		"chunk-74a03b5d"
	],
	"./styles/Z/04/news.scss": [
		"4b1e",
		7,
		"chunk-748a94e7"
	],
	"./styles/Z/04/pagination.scss": [
		"17a4",
		7,
		"chunk-744d70b0"
	],
	"./styles/Z/04/promotion.scss": [
		"7317",
		7,
		"chunk-749f7867"
	],
	"./styles/Z/04/register.scss": [
		"aafd",
		7,
		"chunk-7705090b"
	],
	"./styles/Z/04/transaction-deposit.scss": [
		"7e6c",
		7,
		"chunk-74b64b0e"
	],
	"./styles/Z/04/transaction-record.scss": [
		"8e7f",
		7,
		"chunk-74c466ad"
	],
	"./styles/Z/04/transaction-transfer.scss": [
		"4d02",
		7,
		"chunk-748b73b7"
	],
	"./styles/Z/04/transaction-withdrawal.scss": [
		"f3ef",
		7,
		"chunk-773691fb"
	],
	"./styles/Z/04/transaction.scss": [
		"4046",
		7,
		"chunk-7473dfeb"
	],
	"./styles/Z/04/user.scss": [
		"b614",
		7,
		"chunk-76fec7d2"
	],
	"./styles/Z/05/_abstracts.scss": [
		"18ea",
		7
	],
	"./styles/Z/05/_layout.scss": [
		"a3c5",
		7,
		"chunk-76f00f05"
	],
	"./styles/Z/05/about.scss": [
		"359b",
		7,
		"chunk-7468265e"
	],
	"./styles/Z/05/contact.scss": [
		"45d4",
		7,
		"chunk-7476d9b8"
	],
	"./styles/Z/05/footer.scss": [
		"d075",
		7,
		"chunk-7718533f"
	],
	"./styles/Z/05/forget-password.scss": [
		"7afa",
		7,
		"chunk-74b52d84"
	],
	"./styles/Z/05/game.scss": [
		"7001",
		7,
		"chunk-749e16cf"
	],
	"./styles/Z/05/header.scss": [
		"3b79",
		7,
		"chunk-747c8e98"
	],
	"./styles/Z/05/home.scss": [
		"330c",
		7,
		"chunk-74671bf6"
	],
	"./styles/Z/05/login.scss": [
		"0ac6",
		7,
		"chunk-74527885"
	],
	"./styles/Z/05/maintenance.scss": [
		"1e32",
		7,
		"chunk-7461acd6"
	],
	"./styles/Z/05/news.scss": [
		"2a48",
		7,
		"chunk-746df756"
	],
	"./styles/Z/05/pagination.scss": [
		"ca5a",
		7,
		"chunk-77207fbf"
	],
	"./styles/Z/05/promotion.scss": [
		"1ad2",
		7,
		"chunk-7460934b"
	],
	"./styles/Z/05/register.scss": [
		"03e8",
		7,
		"chunk-743d9733"
	],
	"./styles/Z/05/transaction-deposit.scss": [
		"1126",
		7,
		"chunk-744a0645"
	],
	"./styles/Z/05/transaction-record.scss": [
		"2f29",
		7,
		"chunk-747035ce"
	],
	"./styles/Z/05/transaction-transfer.scss": [
		"45d8",
		7,
		"chunk-7476da34"
	],
	"./styles/Z/05/transaction-withdrawal.scss": [
		"2dbe",
		7,
		"chunk-74700694"
	],
	"./styles/Z/05/transaction.scss": [
		"b765",
		7,
		"chunk-76ff4f15"
	],
	"./styles/Z/05/user.scss": [
		"d8c1",
		7,
		"chunk-771c9ae7"
	],
	"./styles/Z/_default/_abstracts.scss": [
		"275d",
		7
	],
	"./styles/Z/_default/_functions.scss": [
		"2e94",
		7,
		"chunk-746fdb1b"
	],
	"./styles/Z/_default/_layout.scss": [
		"7ebcd",
		7,
		"chunk-22271800"
	],
	"./styles/Z/_default/_mixins.scss": [
		"5694",
		7,
		"chunk-7484c42d"
	],
	"./styles/Z/_default/about.scss": [
		"d228c",
		7,
		"chunk-6c0c09e6"
	],
	"./styles/Z/_default/contact.scss": [
		"cb82",
		7,
		"chunk-7720f9b0"
	],
	"./styles/Z/_default/footer.scss": [
		"09b8",
		7,
		"chunk-7440462a"
	],
	"./styles/Z/_default/forget-password.scss": [
		"42b1",
		7,
		"chunk-747574bc"
	],
	"./styles/Z/_default/game.scss": [
		"4022",
		7,
		"chunk-7473d7ed"
	],
	"./styles/Z/_default/header.scss": [
		"d6bd",
		7,
		"chunk-771bb495"
	],
	"./styles/Z/_default/home.scss": [
		"21c6",
		7,
		"chunk-7458d5b7"
	],
	"./styles/Z/_default/login.scss": [
		"8d5d",
		7,
		"chunk-74c3ea8e"
	],
	"./styles/Z/_default/maintenance.scss": [
		"072c",
		7,
		"chunk-743eae71"
	],
	"./styles/Z/_default/news.scss": [
		"304f",
		7,
		"chunk-7465ce3a"
	],
	"./styles/Z/_default/pagination.scss": [
		"751b",
		7,
		"chunk-74a0665a"
	],
	"./styles/Z/_default/promotion.scss": [
		"d5ef",
		7,
		"chunk-771b4bb7"
	],
	"./styles/Z/_default/register.scss": [
		"0d40",
		7,
		"chunk-74532479"
	],
	"./styles/Z/_default/transaction-deposit.scss": [
		"f56f",
		7,
		"chunk-7736ca4a"
	],
	"./styles/Z/_default/transaction-record.scss": [
		"63b3",
		7,
		"chunk-7492185b"
	],
	"./styles/Z/_default/transaction-transfer.scss": [
		"883a",
		7,
		"chunk-74afe25b"
	],
	"./styles/Z/_default/transaction-withdrawal.scss": [
		"7a6e",
		7,
		"chunk-74b479d0"
	],
	"./styles/Z/_default/transaction.scss": [
		"9b58",
		7,
		"chunk-74d113fd"
	],
	"./styles/Z/_default/user.scss": [
		"e45e",
		7,
		"chunk-77283a8a"
	],
	"./styles/global/abstracts.scss": [
		"5132",
		7,
		"chunk-7482678e"
	],
	"./styles/global/animation.scss": [
		"bb25",
		7,
		"chunk-7712cc06"
	],
	"./styles/global/base.scss": [
		"e6c1",
		7
	],
	"./styles/global/transition.scss": [
		"eec0",
		7,
		"chunk-773f26fc"
	],
	"./utils/array": [
		"2f7e",
		9
	],
	"./utils/array.js": [
		"2f7e",
		9
	],
	"./utils/cache": [
		"6b43",
		9
	],
	"./utils/cache.js": [
		"6b43",
		9
	],
	"./utils/cookie": [
		"f3e4",
		9
	],
	"./utils/cookie.js": [
		"f3e4",
		9
	],
	"./utils/date": [
		"c466",
		9,
		"chunk-2d216ba7"
	],
	"./utils/date.js": [
		"c466",
		9,
		"chunk-2d216ba7"
	],
	"./utils/device": [
		"51e6",
		9
	],
	"./utils/device.js": [
		"51e6",
		9
	],
	"./utils/document": [
		"60ae",
		9
	],
	"./utils/document.js": [
		"60ae",
		9
	],
	"./utils/image": [
		"2d5d",
		9
	],
	"./utils/image.js": [
		"2d5d",
		9
	],
	"./utils/localStorage": [
		"e8ec",
		9
	],
	"./utils/localStorage.js": [
		"e8ec",
		9
	],
	"./utils/object": [
		"7c9b",
		9
	],
	"./utils/object.js": [
		"7c9b",
		9
	],
	"./utils/promptPay": [
		"f6cf",
		9,
		"chunk-51c859ef"
	],
	"./utils/promptPay.js": [
		"f6cf",
		9,
		"chunk-51c859ef"
	],
	"./utils/register": [
		"5e81",
		9,
		"chunk-2d0d3abf"
	],
	"./utils/register.js": [
		"5e81",
		9,
		"chunk-2d0d3abf"
	],
	"./utils/rsa": [
		"5258",
		9
	],
	"./utils/rsa.js": [
		"5258",
		9
	],
	"./utils/sessionStorage": [
		"67e2",
		9,
		"chunk-2d0d07e4"
	],
	"./utils/sessionStorage.js": [
		"67e2",
		9,
		"chunk-2d0d07e4"
	],
	"./utils/site": [
		"a1b3",
		9
	],
	"./utils/site.js": [
		"a1b3",
		9
	],
	"./utils/sleep": [
		"a976",
		9
	],
	"./utils/sleep.js": [
		"a976",
		9
	],
	"./utils/string": [
		"7f46",
		9,
		"chunk-2d0e26c7"
	],
	"./utils/string.js": [
		"7f46",
		9,
		"chunk-2d0e26c7"
	],
	"./utils/url": [
		"4b90",
		9
	],
	"./utils/url.js": [
		"4b90",
		9
	],
	"./utils/vee-validate": [
		"1dec",
		9
	],
	"./utils/vee-validate.js": [
		"1dec",
		9
	],
	"./utils/version": [
		"03e4",
		9
	],
	"./utils/version.js": [
		"03e4",
		9
	],
	"./vender/javascript-winwheel/win-wheel-custom": [
		"9c82",
		9,
		"chunk-2d222d54",
		"chunk-2d0f04ba"
	],
	"./vender/javascript-winwheel/win-wheel-custom.js": [
		"9c82",
		9,
		"chunk-2d222d54",
		"chunk-2d0f04ba"
	],
	"./vender/javascript-winwheel/win-wheel-origin": [
		"25b2",
		9,
		"chunk-2d222d54",
		"chunk-2d0b2e89"
	],
	"./vender/javascript-winwheel/win-wheel-origin.js": [
		"25b2",
		9,
		"chunk-2d222d54",
		"chunk-2d0b2e89"
	],
	"./views/About": [
		"f820",
		9,
		"chunk-2d22d746"
	],
	"./views/About.vue": [
		"f820",
		9,
		"chunk-2d22d746"
	],
	"./views/Contact": [
		"b8fa",
		9,
		"chunk-2d210c47"
	],
	"./views/Contact.vue": [
		"b8fa",
		9,
		"chunk-2d210c47"
	],
	"./views/DepositThirdPartyReturn": [
		"1c0f",
		9,
		"chunk-2d0b60fe"
	],
	"./views/DepositThirdPartyReturn.vue": [
		"1c0f",
		9,
		"chunk-2d0b60fe"
	],
	"./views/ForgetPassword": [
		"5373",
		9,
		"chunk-2d0c7ef0"
	],
	"./views/ForgetPassword.vue": [
		"5373",
		9,
		"chunk-2d0c7ef0"
	],
	"./views/Home": [
		"bb51",
		9,
		"chunk-2d21a3d2"
	],
	"./views/Home.vue": [
		"bb51",
		9,
		"chunk-2d21a3d2"
	],
	"./views/Iframe": [
		"2d4a",
		9,
		"chunk-2d0bd995"
	],
	"./views/Iframe.vue": [
		"2d4a",
		9,
		"chunk-2d0bd995"
	],
	"./views/Login": [
		"a55b",
		9,
		"chunk-2d2086b7"
	],
	"./views/Login.vue": [
		"a55b",
		9,
		"chunk-2d2086b7"
	],
	"./views/Maintenance": [
		"a5ed",
		9,
		"chunk-2d208c89"
	],
	"./views/Maintenance.vue": [
		"a5ed",
		9,
		"chunk-2d208c89"
	],
	"./views/News": [
		"a2f9",
		9,
		"chunk-2d20813a"
	],
	"./views/News.vue": [
		"a2f9",
		9,
		"chunk-2d20813a"
	],
	"./views/PageNotFound": [
		"a5b5",
		9,
		"chunk-2d208bfd"
	],
	"./views/PageNotFound.vue": [
		"a5b5",
		9,
		"chunk-2d208bfd"
	],
	"./views/ProxyCode": [
		"1742",
		9,
		"chunk-2d0abc1a"
	],
	"./views/ProxyCode.vue": [
		"1742",
		9,
		"chunk-2d0abc1a"
	],
	"./views/Register": [
		"73cf",
		9,
		"chunk-2d0d6d35"
	],
	"./views/Register.vue": [
		"73cf",
		9,
		"chunk-2d0d6d35"
	],
	"./views/SignIn": [
		"54e2",
		9,
		"chunk-2dd9ac2e"
	],
	"./views/SignIn.vue": [
		"54e2",
		9,
		"chunk-2dd9ac2e"
	],
	"./views/game/GameHome": [
		"26ba",
		9,
		"chunk-2d0b3279"
	],
	"./views/game/GameHome.vue": [
		"26ba",
		9,
		"chunk-2d0b3279"
	],
	"./views/game/GameLobby": [
		"04ed",
		9,
		"chunk-2d0a4299"
	],
	"./views/game/GameLobby.vue": [
		"04ed",
		9,
		"chunk-2d0a4299"
	],
	"./views/game/GameLobbyLive": [
		"c268",
		9,
		"chunk-2d216427"
	],
	"./views/game/GameLobbyLive.vue": [
		"c268",
		9,
		"chunk-2d216427"
	],
	"./views/game/GameLobbySlot": [
		"0745",
		9,
		"chunk-2d0a47be"
	],
	"./views/game/GameLobbySlot.vue": [
		"0745",
		9,
		"chunk-2d0a47be"
	],
	"./views/notification/NotificationHome": [
		"9637",
		9,
		"chunk-2d0e5b37"
	],
	"./views/notification/NotificationHome.vue": [
		"9637",
		9,
		"chunk-2d0e5b37"
	],
	"./views/notification/NotificationInbox": [
		"03f1",
		9,
		"chunk-2d0a3ec4"
	],
	"./views/notification/NotificationInbox.vue": [
		"03f1",
		9,
		"chunk-2d0a3ec4"
	],
	"./views/notification/NotificationInboxDetail": [
		"4fe3",
		9,
		"chunk-2d0ccf96"
	],
	"./views/notification/NotificationInboxDetail.vue": [
		"4fe3",
		9,
		"chunk-2d0ccf96"
	],
	"./views/notification/NotificationNews": [
		"e9d8",
		9,
		"chunk-2d226cbe"
	],
	"./views/notification/NotificationNews.vue": [
		"e9d8",
		9,
		"chunk-2d226cbe"
	],
	"./views/notification/NotificationOutbox": [
		"faac",
		9,
		"chunk-2d237713"
	],
	"./views/notification/NotificationOutbox.vue": [
		"faac",
		9,
		"chunk-2d237713"
	],
	"./views/promotion/Promotion": [
		"e241",
		9,
		"chunk-2d224ca0"
	],
	"./views/promotion/Promotion.vue": [
		"e241",
		9,
		"chunk-2d224ca0"
	],
	"./views/promotion/PromotionDetail": [
		"9b2f",
		9,
		"chunk-2d0f0073"
	],
	"./views/promotion/PromotionDetail.vue": [
		"9b2f",
		9,
		"chunk-2d0f0073"
	],
	"./views/report/ReportBetRecord": [
		"b647",
		9,
		"chunk-2d20fe8d"
	],
	"./views/report/ReportBetRecord.vue": [
		"b647",
		9,
		"chunk-2d20fe8d"
	],
	"./views/report/ReportBetRecordDay": [
		"9655",
		9,
		"chunk-2d0e5b73"
	],
	"./views/report/ReportBetRecordDay.vue": [
		"9655",
		9,
		"chunk-2d0e5b73"
	],
	"./views/report/ReportBetRecordDetail": [
		"c23c",
		9,
		"chunk-2d2163f5"
	],
	"./views/report/ReportBetRecordDetail.vue": [
		"c23c",
		9,
		"chunk-2d2163f5"
	],
	"./views/report/ReportBetRecordHome": [
		"044a",
		9,
		"chunk-2d0a3ca7"
	],
	"./views/report/ReportBetRecordHome.vue": [
		"044a",
		9,
		"chunk-2d0a3ca7"
	],
	"./views/report/ReportBetRecordWeek": [
		"259e",
		9,
		"chunk-2d0b29c5"
	],
	"./views/report/ReportBetRecordWeek.vue": [
		"259e",
		9,
		"chunk-2d0b29c5"
	],
	"./views/report/ReportHome": [
		"a3fd",
		9,
		"chunk-2d208526"
	],
	"./views/report/ReportHome.vue": [
		"a3fd",
		9,
		"chunk-2d208526"
	],
	"./views/report/ReportUnsettleBet": [
		"5595",
		9,
		"chunk-2d0c86b2"
	],
	"./views/report/ReportUnsettleBet.vue": [
		"5595",
		9,
		"chunk-2d0c86b2"
	],
	"./views/transaction/TransactionDeposit": [
		"cee3",
		9,
		"chunk-2d222946"
	],
	"./views/transaction/TransactionDeposit.vue": [
		"cee3",
		9,
		"chunk-2d222946"
	],
	"./views/transaction/TransactionHome": [
		"9696",
		9,
		"chunk-2d0e5bf0"
	],
	"./views/transaction/TransactionHome.vue": [
		"9696",
		9,
		"chunk-2d0e5bf0"
	],
	"./views/transaction/TransactionTransfer": [
		"5a6a",
		9,
		"chunk-2d0d2bad"
	],
	"./views/transaction/TransactionTransfer.vue": [
		"5a6a",
		9,
		"chunk-2d0d2bad"
	],
	"./views/transaction/TransactionWallet": [
		"b8a8",
		9,
		"chunk-2d210b83"
	],
	"./views/transaction/TransactionWallet.vue": [
		"b8a8",
		9,
		"chunk-2d210b83"
	],
	"./views/transaction/TransactionWithdrawal": [
		"9c3a",
		9,
		"chunk-2d0f044e"
	],
	"./views/transaction/TransactionWithdrawal.vue": [
		"9c3a",
		9,
		"chunk-2d0f044e"
	],
	"./views/transaction/deposit/TransactionDepositAutoCash": [
		"3eac",
		9,
		"chunk-2d0c572a"
	],
	"./views/transaction/deposit/TransactionDepositAutoCash.vue": [
		"3eac",
		9,
		"chunk-2d0c572a"
	],
	"./views/transaction/deposit/TransactionDepositBase": [
		"4ddb",
		9,
		"chunk-2d0cc824"
	],
	"./views/transaction/deposit/TransactionDepositBase.vue": [
		"4ddb",
		9,
		"chunk-2d0cc824"
	],
	"./views/transaction/deposit/TransactionDepositHome": [
		"0761",
		9,
		"chunk-2d0a47f8"
	],
	"./views/transaction/deposit/TransactionDepositHome.vue": [
		"0761",
		9,
		"chunk-2d0a47f8"
	],
	"./views/transaction/deposit/TransactionDepositThirdParty": [
		"2b21",
		9,
		"chunk-2d0bd1a5"
	],
	"./views/transaction/deposit/TransactionDepositThirdParty.vue": [
		"2b21",
		9,
		"chunk-2d0bd1a5"
	],
	"./views/transaction/record/TransactionRecordAdjustment": [
		"0ab1",
		9,
		"chunk-2d0aeaf6"
	],
	"./views/transaction/record/TransactionRecordAdjustment.vue": [
		"0ab1",
		9,
		"chunk-2d0aeaf6"
	],
	"./views/transaction/record/TransactionRecordBetDay": [
		"8956",
		9,
		"chunk-2d0df258"
	],
	"./views/transaction/record/TransactionRecordBetDay.vue": [
		"8956",
		9,
		"chunk-2d0df258"
	],
	"./views/transaction/record/TransactionRecordBetHome": [
		"505f",
		9,
		"chunk-2d0c73a2"
	],
	"./views/transaction/record/TransactionRecordBetHome.vue": [
		"505f",
		9,
		"chunk-2d0c73a2"
	],
	"./views/transaction/record/TransactionRecordBetUnsettle": [
		"a6b5",
		9,
		"chunk-2d208fbe"
	],
	"./views/transaction/record/TransactionRecordBetUnsettle.vue": [
		"a6b5",
		9,
		"chunk-2d208fbe"
	],
	"./views/transaction/record/TransactionRecordBetWeek": [
		"d973",
		9,
		"chunk-2d21f2e7"
	],
	"./views/transaction/record/TransactionRecordBetWeek.vue": [
		"d973",
		9,
		"chunk-2d21f2e7"
	],
	"./views/transaction/record/TransactionRecordBonus": [
		"dc74",
		9,
		"chunk-2d229092"
	],
	"./views/transaction/record/TransactionRecordBonus.vue": [
		"dc74",
		9,
		"chunk-2d229092"
	],
	"./views/transaction/record/TransactionRecordDeposit": [
		"e85b",
		9,
		"chunk-2d226376"
	],
	"./views/transaction/record/TransactionRecordDeposit.vue": [
		"e85b",
		9,
		"chunk-2d226376"
	],
	"./views/transaction/record/TransactionRecordDepositDetail": [
		"3549",
		9,
		"chunk-2d0b9d5d"
	],
	"./views/transaction/record/TransactionRecordDepositDetail.vue": [
		"3549",
		9,
		"chunk-2d0b9d5d"
	],
	"./views/transaction/record/TransactionRecordHome": [
		"02ec",
		9,
		"chunk-2d0a3b16"
	],
	"./views/transaction/record/TransactionRecordHome.vue": [
		"02ec",
		9,
		"chunk-2d0a3b16"
	],
	"./views/transaction/record/TransactionRecordLottery": [
		"0d63",
		9,
		"chunk-2d0af0e7"
	],
	"./views/transaction/record/TransactionRecordLottery.vue": [
		"0d63",
		9,
		"chunk-2d0af0e7"
	],
	"./views/transaction/record/TransactionRecordTransfer": [
		"8b6b",
		9,
		"chunk-2d0e8c8c"
	],
	"./views/transaction/record/TransactionRecordTransfer.vue": [
		"8b6b",
		9,
		"chunk-2d0e8c8c"
	],
	"./views/transaction/record/TransactionRecordTransferDetail": [
		"3e00",
		9,
		"chunk-2d0c5108"
	],
	"./views/transaction/record/TransactionRecordTransferDetail.vue": [
		"3e00",
		9,
		"chunk-2d0c5108"
	],
	"./views/transaction/record/TransactionRecordWithdrawal": [
		"d225",
		9,
		"chunk-2d21d807"
	],
	"./views/transaction/record/TransactionRecordWithdrawal.vue": [
		"d225",
		9,
		"chunk-2d21d807"
	],
	"./views/transaction/record/TransactionRecordWithdrawalDetail": [
		"cfe1",
		9,
		"chunk-2d222d05"
	],
	"./views/transaction/record/TransactionRecordWithdrawalDetail.vue": [
		"cfe1",
		9,
		"chunk-2d222d05"
	],
	"./views/transaction/record/TransactionRecordWithdrawalRestriction": [
		"e07b",
		9,
		"chunk-2d2245ac"
	],
	"./views/transaction/record/TransactionRecordWithdrawalRestriction.vue": [
		"e07b",
		9,
		"chunk-2d2245ac"
	],
	"./views/transaction/record/TransactionRecordWithdrawalRestrictionDetail": [
		"b8a4",
		9,
		"chunk-2d210b7f"
	],
	"./views/transaction/record/TransactionRecordWithdrawalRestrictionDetail.vue": [
		"b8a4",
		9,
		"chunk-2d210b7f"
	],
	"./views/user/UserChangePassword": [
		"9efb",
		9,
		"chunk-2d0f11fe"
	],
	"./views/user/UserChangePassword.vue": [
		"9efb",
		9,
		"chunk-2d0f11fe"
	],
	"./views/user/UserChangePasswordWithdrawal": [
		"3b74",
		9,
		"chunk-2d0c46a2"
	],
	"./views/user/UserChangePasswordWithdrawal.vue": [
		"3b74",
		9,
		"chunk-2d0c46a2"
	],
	"./views/user/UserHome": [
		"1010",
		9,
		"chunk-2d0aa174"
	],
	"./views/user/UserHome.vue": [
		"1010",
		9,
		"chunk-2d0aa174"
	],
	"./views/user/UserMail": [
		"812a",
		9,
		"chunk-2d0dd41e"
	],
	"./views/user/UserMail.vue": [
		"812a",
		9,
		"chunk-2d0dd41e"
	],
	"./views/user/UserMailDetail": [
		"69f7",
		9,
		"chunk-2d0d0f8a"
	],
	"./views/user/UserMailDetail.vue": [
		"69f7",
		9,
		"chunk-2d0d0f8a"
	],
	"./views/user/UserMailSend": [
		"1bd3",
		9,
		"chunk-2d0b6356"
	],
	"./views/user/UserMailSend.vue": [
		"1bd3",
		9,
		"chunk-2d0b6356"
	],
	"./views/user/UserProfile": [
		"1ce4",
		9,
		"chunk-2d0b6737"
	],
	"./views/user/UserProfile.vue": [
		"1ce4",
		9,
		"chunk-2d0b6737"
	],
	"./views/user/UserPromotionMGM": [
		"a760",
		9,
		"chunk-2d208e26"
	],
	"./views/user/UserPromotionMGM.vue": [
		"a760",
		9,
		"chunk-2d208e26"
	],
	"./views/user/UserPromotionMGMBonus": [
		"d22a",
		9,
		"chunk-2d21d833"
	],
	"./views/user/UserPromotionMGMBonus.vue": [
		"d22a",
		9,
		"chunk-2d21d833"
	],
	"./views/user/UserPromotionMGMDetail": [
		"5588",
		9,
		"chunk-2d0c8696"
	],
	"./views/user/UserPromotionMGMDetail.vue": [
		"5588",
		9,
		"chunk-2d0c8696"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8673";
module.exports = webpackAsyncContext;